import { Component, OnInit, ViewChild, Pipe, TemplateRef, Inject, Renderer2, AfterViewInit, NgZone, ChangeDetectorRef , ElementRef,ViewChildren,QueryList} from '@angular/core';
import * as Sentry from '@sentry/angular';
import { StorageMap } from '@ngx-pwa/local-storage';
import { AppService } from '../services/app.service';
import { AuthService } from '../services/auth.service';
import { MatStepper } from '@angular/material/stepper';
import { FormControl, Validators, AbstractControl } from '@angular/forms';
import * as moment from 'moment';
import 'moment-timezone';
import { StorageHelper } from '../services/storage.helper';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { MatCalendarCellCssClasses, MatCalendar } from '@angular/material/datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { SavedCardsComponent } from './saved-cards.component';
import { AppointmentCancelDialogComponent } from './appointment-cancel-dialog';

import { DomSanitizer } from '@angular/platform-browser';
import { PaymentPageDialogComponent } from './payment-page-dialog';

import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatOption } from '@angular/material/core';
import { DialogPopUpComponent } from '../dialog-pop-up/dialog-pop-up.component';
import { PopupComponent } from '../popup/popup.component';
import { InfoService, petKeyInfo, questions } from '../services/info.service';
import { CardOnFileComponent } from '../card-on-file/card-on-file.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { GooglePlacesAPI, Maps } from '../services/googlePlaces.service';
import { MatRadioChange } from '@angular/material/radio';
import { DatePipe } from '@angular/common';
import { AgreementComponent } from '../agreement/agreement.component';
import { AddImmunizationComponent } from '../add-immunization/add-immunization.component';
import { BreedSelectorDialogComponent } from '../breed-selector-dialog/breed-selector-dialog.component';
import {AddVetComponent} from '../add-vet/add-vet.component';
import {ImagesAndVideosComponent} from '../images-and-videos/images-and-videos.component';
// import { AppProfileSettingsService } from '../services/app-profile-settings.service';
// import { PopUpComponent } from '../dialog-pop-up/pop-up/pop-up.component';


export interface DialogData {
  android: string;
  ios: string;
}
export interface Feeding {
  ptname: string;
}
@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.css']
})
export class WizardComponent implements OnInit {
  @ViewChild('panel') panel: MatExpansionPanel;
  @ViewChild(MatStepper) stepper!: MatStepper;
  // @ViewChild(MatSelect) assignedPet!: MatSelect;
  @ViewChild(TemplateRef) serviceMapModal: any;
  @ViewChild(MatCalendar) calendar: MatCalendar<Date>;
  @ViewChild('calendar1') calendarOne: MatCalendar<Date>;
  @ViewChild('calendar2') calendarTwo: MatCalendar<Date>;
  @ViewChild('searchGoogleAddressInput') public searchElementRef: ElementRef;
  @ViewChildren('searchGoogleAddressInputInvite') searchElementRefInvite: ElementRef;
  @ViewChildren(MatExpansionPanel) panels: QueryList<MatExpansionPanel>;
  @ViewChild('vetInput') vetInput: ElementRef<HTMLInputElement>;
  @ViewChild('calendar2') calendar2: MatCalendar<Date>;
  //
  enableReqAppiontment = true;
  @ViewChild('ForceShow') nextPageStepperControl: DialogPopUpComponent;
  //

  displayedColumnsForAgreements: string[] = ['name', 'signed date', 'expiration date', 'status', 'action'];
  displayedColumnsForImmunizations: string[] = ['name', 'expiry date', 'status', 'action'];
  openEnrollmentClasses: string[] = ['name', 'select'];
  packageColumns:string[] = ['name','services','price','action']
  storageService: StorageHelper;
  isLoading = false;
  emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
  phoneNumber = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
  noSpecialChar = /[^a-zA-Z0-9 ]/;
  regex: any = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
  password = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/

  existEmailCtrl = new FormControl('', [Validators.pattern(this.emailPattern)]);
  existPassCtrl = new FormControl('', []);
  firstNameCtrl = new FormControl('', [this.firstCapitalValidator, this.specialCharValidator]);
  lastNameCtrl = new FormControl('', [this.firstCapitalValidator, this.specialCharValidator]);
  phoneCtrl = new FormControl('', [Validators.pattern(this.phoneNumber)]);
  newEmailCtrl = new FormControl('', [Validators.pattern(this.emailPattern)]);
  newPassCtrl = new FormControl('', [Validators.pattern(this.password)]);
  petNameCtrl = new FormControl('', []);
  petGenderCtrl = new FormControl('', []);
  petBreedCtrl = new FormControl('', []);
  inviteCodeCtrl = new FormControl('', [])
  inviteCodePasswordCtrl = new FormControl('', [Validators.pattern(this.password)])
  locationCtrl = new FormControl('', [])
  newCityCtrl = new FormControl('', []);
  newStateCtrl = new FormControl('',[]);
  newZipCtrl = new FormControl('', []);
  newStreetCtrl = new FormControl('', []);
  inviteStateCtrl = new FormControl('', []);
  inviteCityCtrl = new FormControl('', []);
  inviteZipCtrl = new FormControl('', []);
  inviteStreetCtrl = new FormControl('', []);

  organizationKey: string;
  hidePass = true;
  selectedLocation = null;
  locationTimezone = null;
  displayAddress: string;
  selectedPetID = null;
  selectedPetName: string;
  newPetID = null;
  selectedPetNum = '1';
  selectedReservationTypeID = null;
  selectedServiceBasedOn = null;
  selectedCalendarKey = null;
  selectedInOutCalendarKey = null;
  selectedServiceID = null;
  selectedArea = null;
  userObj = null;
  inviteUrl = 'javascript:;';
  app_android;
  app_ios;
  today = new Date();
  selectedDateString = moment(new Date()).format('DD/MM/YYYY');
  petBirth = null;
  selectedStartDate;
  selectedEndDate;
  startDate: Date;
  endDate: Date;
  addPetBtntxt = "Add Pet";
  selectedTime = null;
  selectedStartTime: string;
  selectedEndTime: string;
  start_time_str: string;
  end_time_str: string;
  selectedPetGender: null;
  selectedPetBread: null;
  appoint_res: any;
  resultStatusDesc: string;
  result_desc: string;
  selectedAddOnServices = [];
  selectedServiceMap = [];
  selectedPets = [];
  pet_names: string;
  petServiceMap = [];
  locations = [];
  petTypes = [];
  reservationTypes = [];
  staffBasedSlots = [];
  serviceTimings = [];
  holidaysList = [];
  workingDates = [];
  inOutList = [];
  capacityBasedSlotsData = [];
  listOfStaffSlots = [];
  servicesMap = [];
  reservationTypesMap = [];
  datePickerType = null;
  minDate: Date;
  minEndDate: Date;
  timeSlots = [];
  rangeInSlots = [];
  rangeOutSlots = [];
  petBreeds = [];
  petGenders = [];
  userPets = [];
  room = [];
  questions = [];
  immunizations = [];
  cardOnFileRequired = false;
  medicationRequired = false;
  feedingRequired = false;
  bsValue: any;
  petOldStr: string;
  petWeight;
  petColor
  loginErrMsg: string;
  signupErrMsg: string;
  pageShowType: string;
  dateList = [];
  currentPetNo = 1;
  modalRef: BsModalRef;
  tenant: string;
  startDateObject;
  endDateObject;
  startMonthObject = new Date();
  endMonthObject = new Date();
  colorCodeAdded = false;
  showForget = false;
  forgetsucess = false;
  forgetsuccessMsg = '';
  selectedStaff;
  selectedSlot;
  location;
  listOfHolidays = [];
  selectedPurchaseType:string = 'service';
  membershipList = [];
  packageList = [];
  isPanelOpen = false;

  appointmentKey: string;
  savedCards: any;
  paymentDetails: any
  showPasswordFieldForInviteCode: boolean = false
  hidePasswordForInviteCode: boolean = true
  user: any
  tenantDetail: any
  contactManager: string
  emailUs: string
  ko: string
  isPageLoader: boolean = false;

  multiLocation: any[] = []
  tenants: any[] = []
  filteredLocations: Observable<string[]>
  toolTipText: string

  locationSelected: boolean = false

  minWindowFilter: any

  singleMonthDate: Date

  singleMonthChanged: boolean

  rangeStartMonthChanged: boolean

  rangeEndMonthChanged: boolean

  rangeStartMonthDate: Date

  rangeEndMonthDate: Date

  calendarDates = []
  name: any;
  animal: any;

  agreements: any[] = []
  qrCodeData: any
  forceAgreement: boolean = false
  agreementPassCheck: boolean = false
  agreementsFound: boolean = false

  depositRequired: boolean = false

  immunizationsForPets: any[] = []
  immunizationsForPetType: any[] = []
  forceImmunization: boolean = false
  immunizationPassCheck: boolean = false
  immunizationsFound: boolean = false

  groupAddOnServices: any[] = []
  currentGroupAddOnServices: any[] = []
  showGroupAddOnServices: boolean = false
  showAgreement: boolean = false
  showImmunization: boolean = false

  appointmentCreated: boolean = false

  peakDays: any[] = []

  showPrimaryServicesInView: boolean = false
  showSavedCards: boolean = false
  savedCardColumns = ['details']

  disablePayDepositBtn: boolean = false

  reservationTypeFromQueryParam: any
  petTypeFromQueryParam:any
  openAccordion: boolean = false
  permissionList: any;
  signUpPermission: any;
  allowHolidayBookingRange:any;
  showSignUp = false;
  locationName: any;
  petOwnerType = '';
  hasFirstPetServices: boolean = false;
  listOfLodging: any;
  returnUserEmailEmpty: string;
  returnUserPassEmpty: string;
  inviteCodeErrMsg: string;
  inviteCodePasswordErrMsg: string;
  firstNameEmpty: string;
  lastNameEmpty: string;
  phoneEmpty: string;
  newEmailEmpty: string;
  newPassEmpty: string;
  address: string;
  searchGoogleAddressInput:string;
  searchGoogleAddressInputInvite:string;
  newCityEmpty: string;
  newStateEmpty: string;
  newZipEmpty: string;
  streetAddressEmpty: string;
  inviteCityEmpty: string;
  inviteStateEmpty: string;
  inviteZipEmpty: string;
  inviteStreetEmpty: string;
  showAddressPopup: boolean;
  showServicePopup: boolean;
  showAddressField: boolean = false;
  addressSaved: boolean = false;
  activeCards: any;
  selectedSavedCard: any;
  cardColumns: string[] = ['details'];
  checkBusinessHourForAddOn: any;
  calendarObj:any ={};
  inviteCodeUser: boolean = false;
  newUserSignUp: boolean = false;
  petImmunizationMap: any;
  selectedMembership: any;
  autoRenewal:boolean = true;
  ageRequired: boolean;
  genderRequired: boolean;
  updatePetObj: any;
  membershipAgreement: any;
  agreementsRequired: any[];
  selectedPackage: any;
  packageInvoiceDetails: any;
  hasCoupon:boolean= false;
  couponCode:string;
  applicableCoupons: any;
  payableAmount:number = 0;
  hasvalidCoupon: boolean;
  couponDetails: any;
  showRules: boolean;
  allowMembershipPurchase: boolean = false;
  allowPackagePurchase: boolean = false;
  allowTrainingPurchase : boolean = false;
  trainingList: any = [];
  sessionSelected: boolean;
  selectedSession: any;
  weightMandatory: boolean;
  trainingInvoiceDetail: any;
  trainingTypeQueryParam: any;
  selectedTrainingType: any = []
  veterinarianDetails: any[];
  myControl = new FormControl('');
  filteredVet:any[] = []
  addVet: boolean;
  selectedVetDetails: any;
  petOwnerMandatory: any = {}
  userDetails: any;
  showNoSlotAvailable: boolean = false;
  showTimeSlotNotAvailable: boolean = false;
  maxDate: Date;
  minNumberOfStay: number;
  allowBookingServices: boolean;
  petOwnersAgreements: any[];
  showEndTimeForStaffBased: boolean;
  showEndTimeInSummary: boolean;
  getAttachmentInProcess : boolean;

  constructor(
    private cdr: ChangeDetectorRef,
    private appService: AppService,
    private authService: AuthService,
    private storage: StorageMap,
    public dialog: MatDialog,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
    private domSanitizer: DomSanitizer,
    private ngZone: NgZone,
    private infoService: InfoService,
    private elementRef: ElementRef,
    private googlPlacesApi: GooglePlacesAPI,
    private matDialog: MatDialog,
    private el: ElementRef,
    // private AppProfileService:AppProfileSettingsService
  ) {
    this.storageService = new StorageHelper();
    this.infoService.selectedPurchaseType = 'service';
    this.minDate = new Date();
    this.minEndDate = new Date();


    console.log("@@@@@@@", window.location.href);
    var url = window.location.href;
    googlPlacesApi.api.then((maps) => {
      this.initAutocompleteAddress(maps);
      this.initAutocompleteAddressInvite(maps);
    });

    //  this.getTenantKey_throughUrl(url);

    // // this.getTenantKey_local();
    // this.getMultiLocations()
  }



  updateControlVariable() {

    let controlvariables = this.infoService.ForceStepperControl;

    if (controlvariables.ForceCardOnFile == true || controlvariables.ForceMedication == true || controlvariables.ForceFeeding == true) {
      this.enableReqAppiontment = false;
    } else {
      this.enableReqAppiontment = true;
    }

  }
  enableReq(event: boolean) {
    this.enableReqAppiontment = event;
  }
  getTenantKey_local() {
    this.tenant = this.appService.tenantKey;
    console.log("tenant key : ", this.tenant);
    this.setTenantData(this.tenant);
  }

  getTenantKey_throughUrl(url) {
    var serverName = url.split('/')[2];
    // serverName = "woofiespal.runloyal.com"
    // serverName = 'runloyalpetresort.runloyal.com'
    // serverName = 'suitepaws-uat.runloyal.com'
    //serverName = 'pupncuts-dev.runloyal.com'
    this.isLoading = true;
    this.appService.getTenant_external(serverName).subscribe(
      (res: any) => {
        console.log(res);
        if (res.data) {
          if (res.data.contactManager) {
            this.contactManager = res.data.contactManager
          }
          if (res.data.emailUs) {
            this.emailUs = res.data.emailUs
          }
          if (res.data.tenant) {
            this.ko = res.data.tenant.name
          }
        }

        var detail = res["data"]
        this.tenant = res["data"]["tenant"]["tenantKey"];
        this.getTenantSetting(this.tenant);
        console.log("tenant key : ", this.tenant);
        this.isLoading = false;

        if (detail) {
          if (detail.iosAppRateLink) {
            this.app_ios = detail.iosAppRateLink;
          }
          if (detail.androidAppRateLink) {
            this.app_android = detail.androidAppRateLink;
          }
          if (detail.tenantColor) {
            this.colorCodeAdded = true;
            this.changeTheme(detail.tenantColor, '#aaaaaa', '#ffffff', '#000000', detail.tenantColor, '#ffffff', detail.tenantColor, '#ffffff');
          }
        }

        this.setTenantData(serverName);
      },
      error => {
        this.isLoading = false;
        console.log("error", error);
      }
    );
  }
  tenantLogo = '';
  getTenantSetting(tenatKey) {
    this.appService.getTenantDetail(tenatKey).subscribe(
      (res: any) => {
        console.log(res);

        this.tenantDetail = res

        if (res) {
          var detail = res["list"]
          for (var i = 0; i < detail.length; i++) {
            if (detail[i].key == 'tenantColor') {
              if (detail[i].value) {
                this.colorCodeAdded = true;
                this.changeTheme(detail[i].value, '#aaaaaa', '#ffffff', '#000000', detail[i].value, '#ffffff', detail[i].value, '#ffffff');
              }
            }
            if (detail[i].key == 'TenantLogo') {
              if (detail[i].value) {
                this.tenantLogo = detail[i].value;
              } else {
                this.tenantLogo = "https://www.runloyal.com/wp-content/uploads/2020/02/cropped-150x70_website_Logo-Transparency-.png"
              }
            }
          }
          var primaryTheme = "#1b5e20";
          if (!this.colorCodeAdded) {
            this.changeTheme(primaryTheme, '#aaaaaa', '#ffffff', '#000000', primaryTheme, '#ffffff', primaryTheme, '#ffffff');
          }
        }
      },
      error => {
        console.log("error", error);
      });
  }

  setTenantData(serverName) {
    this.appService.setTenantKey(this.tenant);
    this.infoService.setTenantKey(this.tenant);
    this.authService.setTenantKey(this.tenant);

    // this.getLocations(serverName);
    if (!this.app_android && this.appService.getMoreData('rateUs')) {
      this.app_android = this.appService.getMoreData('rateUs');
    }
   if (!this.app_ios && this.appService.getMoreData('rateUs')) {
      this.app_ios = this.appService.getMoreData('rateUs');
    }
  }

  async ngOnInit() {

    Sentry.init({
      dsn: 'https://d2cc63c79314b6959f8774b662171bfd@o4508497367728128.ingest.us.sentry.io/4508578332606464',
      release : '1.100',
      integrations: [],
      debug: true
    });

    this.storageService.clearData();
    let browserName = this.getBrowserName()
    if(browserName != 'Chrome'){
       Swal.fire({ 
        title: 'Our site is best optimized for Google Chrome. Using other browsers may result in unexpected behaviors. For a smoother booking experience, we recommend downloading the app.',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Close',
        confirmButtonColor: '#ff0000'
      }).then((result) => {
        if (result.isConfirmed) {
        }
      });
    }

    window['angularComponentReference'] = { component: this, zone: this.ngZone, callingPaymentSuccess: (status) => this.callingPaymentSuccess(status), };

    // this.getLocations();

    /**************************************/

    let url = window.location.href;
    let serverName = url.split('/')[2];
    // serverName = 'suitepaws-uat.runloyal.com'
    // serverName = 'runloyalpetresort.runloyal.com'
    // serverName = 'pupncuts-dev.runloyal.com'
    // serverName = 'fidofido-alpharetta.runloyal.com'
    // serverName = 'redbarninn.runloyal.com'

    this.isLoading = true;

    let tenantExternalRes: any = await this.appService.getTenant_external_aspromise(serverName)
    let detail = tenantExternalRes["data"]
    this.qrCodeData = detail

    console.log('detail.......', detail)

    if (detail) {
      if (detail.contactManager) {
        this.contactManager = detail.contactManager
      }

      if (detail.emailUs) {
        this.emailUs = detail.emailUs
      }

      if (detail.tenant) {
        this.ko = detail.tenant.name
      }

      if (detail.iosAppRateLink) {
        this.app_ios = detail.iosAppRateLink;
      }

      if (detail.androidAppRateLink) {
        this.app_android = detail.androidAppRateLink;
      }

      if (detail.tenantColor) {
        this.colorCodeAdded = true;
        localStorage.setItem('tenantColor', detail.tenantColor)
        this.changeTheme(detail.tenantColor, '#aaaaaa', '#ffffff', '#000000', detail.tenantColor, '#ffffff', detail.tenantColor, '#ffffff');
      }
    }

    /******************************************/

    let tenantKeyFromQueryParam: any = this.route.snapshot.queryParamMap.get('location')
    this.reservationTypeFromQueryParam = this.route.snapshot.queryParamMap.get('reservationType')
    this.petTypeFromQueryParam = this.route.snapshot.queryParamMap.get('petType')
    this.openAccordion = this.route.snapshot.queryParamMap.get('openAccordion') == 'true' ? true : false
    let isMembershipPurchase = this.route.snapshot.queryParamMap.get('membership') == 'true' ? true : false
    let isPackagePurchase = this.route.snapshot.queryParamMap.get('package') == 'true' ? true : false
    var isTrainingPurchase = this.route.snapshot.queryParamMap.get('training') == 'true' ? true : false
    this.trainingTypeQueryParam = this.route.snapshot.queryParamMap.get('trainingType')
    if(this.trainingTypeQueryParam){
       isTrainingPurchase = true
    }

    var domain = serverName.split('.');

    if (domain[0].includes('-')) {
      domain = domain[0].split('-');
    }

    let res: any = await this.appService.getMultiLocationsAsPromise(domain[0])

    if (res.data) {
      this.organizationKey = res.data.content[0].organizationKey

      this.tenants = res.data.content[0].tenants
      this.tenants.forEach(tenant => {
        let obj = {}
        obj['active'] = tenant.active
        obj['appClientId'] = tenant.appClientId
        obj['contactEmail'] = tenant.contactEmail
        obj['contactPhone'] = tenant.contactPhone
        obj['creditCardPercent'] = tenant.creditCardPercent
        obj['displayAddress'] = tenant.displayAddress
        obj['defaultTenant'] = tenant.defaultTenant
        obj['description'] = tenant.description
        obj['message'] = tenant.message
        obj['name'] = tenant.name
        obj['tenantKey'] = tenant.tenantKey
        obj['timezone'] = tenant.timezone
        obj['locationName'] = tenant.name
        obj['locationKey'] = tenant.locations[0].locationKey
        obj['workCalendarKey'] = tenant.locations[0].workCalendarKey
        obj['holidayCalendarKey'] = tenant.locations[0].holidayCalendarKey

        this.multiLocation.push(obj)
      });
    } else {
      this.organizationKey = detail.tenant.organization.organizationKey
      localStorage.setItem('locationKey', detail.locationKey)
    }

    console.log('multiLocation.........', this.multiLocation)

    if (this.multiLocation.length > 1) {
      if (tenantKeyFromQueryParam != null) {
        this.locationSelected = true
        let location = this.multiLocation.find(location => location.tenantKey == tenantKeyFromQueryParam)
        this.locationCtrl.setValue(location.locationKey)
        this.location = location
        this.tenant = location.tenantKey
        localStorage.setItem('tenant', this.tenant)
        this.locationName = location.name
        this.setTenantData(serverName);
        this.selectedLocation = location.locationKey;
        this.locationTimezone = location.timezone;
        moment.tz.setDefault(this.locationTimezone);

        if (location.displayAddress) {
          this.displayAddress = location.displayAddress;
        }

        this.getAppProfile();
        this.getTenantSetting(this.tenant);
        this.getPetType(this.selectedLocation);
        this.storageService.setItem('locationKey', this.selectedLocation);

        if (location.holidayCalendarKey) {
          this.getHolidayDates();
        }
      } else {

        /******************* */
        this.locationSelected = true
        let location = this.multiLocation[0]
        this.locationCtrl.setValue(location.locationKey)
        this.location = location
        this.tenant = location.tenantKey
        localStorage.setItem('tenant', this.tenant)
        this.locationName = location.name
        this.setTenantData(serverName);
        this.selectedLocation = location.locationKey;
        this.locationTimezone = location.timezone;
        moment.tz.setDefault(this.locationTimezone);

        if (location.displayAddress) {
          this.displayAddress = location.displayAddress;
        }

        this.getTenantSetting(this.tenant);
        this.getAppProfile();
        this.getPetType(this.selectedLocation);
        this.storageService.setItem('locationKey', this.selectedLocation);

        if (location.holidayCalendarKey) {
          this.getHolidayDates();
        }
      }
    } else {
      this.locationSelected = true  //For single location
      let location = detail;
      this.locationCtrl.setValue(location.tenant.name)
      this.location = location;
      this.tenant = tenantExternalRes["data"]["tenant"]["tenantKey"];
      localStorage.setItem('tenant', this.tenant)
      this.setTenantData(serverName);
      this.selectedLocation = location.locationKey;
      this.locationTimezone = location.timeZone;
      moment.tz.setDefault(this.locationTimezone);
      this.displayAddress = location.displayAddress;
      this.getTenantSetting(this.tenant);
      this.getAppProfile();
      this.getPetType(this.selectedLocation);
      this.storageService.setItem('locationKey', this.selectedLocation);

      if (this.location.holidayCalendarKey) {
        this.getHolidayDates();
      }
    }

    if(isMembershipPurchase){
      setTimeout(() => {
        if(this.allowMembershipPurchase){
          this.selectedPurchaseType = 'membership'
          this.infoService.selectedPurchaseType = this.selectedPurchaseType
          this.getMembership();
        }
      }, 1000)
    }else if(isPackagePurchase){
      setTimeout(() => {
        if( this.allowPackagePurchase){
          this.selectedPurchaseType = 'package'
          this.infoService.selectedPurchaseType = this.selectedPurchaseType
          this.getPackages();
        }
      }, 1000) 
    }else if(isTrainingPurchase){
      setTimeout(() => {
        if(this.allowTrainingPurchase){
          this.selectedPurchaseType = 'training'
          this.infoService.selectedPurchaseType = this.selectedPurchaseType
          this.getTraining();
        }
      }, 1000)
    }

    this.isLoading = false;
  }

  getBrowserName(){
    const agent = window.navigator.userAgent.toLowerCase();
    const browser =
      agent.indexOf('edge') > -1 ? 'Microsoft Edge'
        : agent.indexOf('edg') > -1 ? 'Chromium-based Edge'
        : agent.indexOf('opr') > -1 ? 'Opera'
        : agent.indexOf('chrome') > -1 ? 'Chrome'
        : agent.indexOf('trident') > -1 ? 'Internet Explorer'
        : agent.indexOf('firefox') > -1 ? 'Firefox'
        : agent.indexOf('safari') > -1 ? 'Safari'
        : 'other';

    return browser;
  }


  ngAfterViewInit() {
  }

  changeTheme(bannerBgColor: string, breadcrumbTextColor: string,
    selectedBreadcrumbTextColor: string, headerLabelTextColor: string,
    btnBgColor: string, btnTextColor: string,
    selectedOptionBgColor: string, selectedOptionTextColor: string,
  ) {
    document.documentElement.style.setProperty('--banner-bg-color', bannerBgColor);
    document.documentElement.style.setProperty('--breadcrumb-text-color', breadcrumbTextColor);
    document.documentElement.style.setProperty('--selected-breadcrumb-text-color', selectedBreadcrumbTextColor);
    document.documentElement.style.setProperty('--header-label-text-color', headerLabelTextColor);
    document.documentElement.style.setProperty('--btn-bg-color', btnBgColor);
    document.documentElement.style.setProperty('--btn-text-color', btnTextColor);
    document.documentElement.style.setProperty('--selected-option-bg-color', selectedOptionBgColor);
    document.documentElement.style.setProperty('--selected-option-text-color', selectedOptionTextColor);
    let newAccordionColor = bannerBgColor + '65'
    document.documentElement.style.setProperty('--selected-accordion-color',newAccordionColor);
  }

  getLocations(serverName) {
    console.log("******************  Getting Location  ******************")
    this.appService.getLocations_external(serverName).subscribe(
      res => {
        console.log(res)
        var location = res["data"];
        if (location) {
          this.location = location;
          this.selectedLocation = location.locationKey;
          this.locationTimezone = location.timeZone;
          moment.tz.setDefault(this.locationTimezone);
          this.displayAddress = location.displayAddress;
          this.getAppProfile();
          this.getPetType(this.selectedLocation);
          this.storageService.setItem('locationKey', this.selectedLocation);

          console.log('holidayCalendarKey.......*****.......', this.location.holidayCalendarKey)

          if (this.location.holidayCalendarKey) {
            this.getHolidayDates();
          }

        } else {
          // Swal.fire("No location found");
        }
      },
      error => {
        console.log("error", error);
      }
    );
  }
  async getAppProfile() {

    await this.appService.getAppProfile(this.organizationKey).subscribe(
      res => {
        console.log(res)
        if (res['data'] && res['data']['content']) {
          this.permissionList = res['data']['content'];
          this.signUpPermission = this.permissionList.find((o: { key: string; platform:string }) => o.key == "SIGNUP_BY_INVITE_CODE_WEB" && o.platform === 'WEB');
          if(this.signUpPermission){    
            this.showSignUp = this.signUpPermission.hide;
          }
          else{
            this.showSignUp = false
          }

          var isRangeHolidayAllowed  = this.permissionList.find((o: { key: string; platform:string}) => o.key == "BOOK_INBETWEEN_HOLIDAYS" && o.platform === 'WEB');
          if(isRangeHolidayAllowed){    
            this.allowHolidayBookingRange = isRangeHolidayAllowed.hide;
          }
          else{
            this.allowHolidayBookingRange = true
          }

          var isCheckBusinessHour = this.permissionList.find((o: { key: string; platform:string}) => o.key == "ALLOW_ADD_ON_BOOKING_OUTSIDE_BUSINESS_HOUR" && o.platform === 'WEB');
          if(isCheckBusinessHour){    
            this.checkBusinessHourForAddOn = isCheckBusinessHour.hide;
          }
          else{
            this.checkBusinessHourForAddOn = true;
          }

          var isMembershipPurchaseAllowed = this.permissionList.find((o: { key: string; platform:string}) => o.key == "ALLOW_MEMBERSHIP_PURCHASE" && o.platform === 'WEB');
          if(isMembershipPurchaseAllowed){    
            this.allowMembershipPurchase = isMembershipPurchaseAllowed.hide;
          }
          else{
            this.allowMembershipPurchase = false;
          }

          var isPackagePurchaseAllowed = this.permissionList.find((o: { key: string; platform:string}) => o.key == "ALLOW_PACKAGE_PURCHASE" && o.platform === 'WEB');
          if(isPackagePurchaseAllowed){    
            this.allowPackagePurchase = isPackagePurchaseAllowed.hide;
          }
          else{
            this.allowPackagePurchase = false;
          }

          var isTrainingPurchaseAllowed = this.permissionList.find((o: { key: string; platform:string}) => o.key == "ALLOW_TRAINING_SERVICE_PURCHASE" && o.platform === 'WEB');
          if(isTrainingPurchaseAllowed){    
            this.allowTrainingPurchase = isTrainingPurchaseAllowed.hide;
          }
          else{
            this.allowTrainingPurchase = false;
          }

          var isBookingServicesAllowed = this.permissionList.find((o: { key: string; platform:string}) => o.key == "ALLOW_BOOKING_SERVICES" && o.platform === 'WEB');
          if(isBookingServicesAllowed){
            this.allowBookingServices = isBookingServicesAllowed.hide;
          }
          else{
            this.allowBookingServices = false;
          }

          var isShowEndTimeForStaffBased = this.permissionList.find((o: { key: string; platform:string}) => o.key == "SHOW_STAFF_END_TIME_WEB" && o.platform === 'WEB');
          if(isShowEndTimeForStaffBased){
            this.showEndTimeForStaffBased = isShowEndTimeForStaffBased.hide;
          }
          else{
            this.showEndTimeForStaffBased = true;
          }

          if(!this.allowBookingServices){
            this.selectedPurchaseType = '';
            this.infoService.selectedPurchaseType = this.selectedPurchaseType;
            if(!this.allowMembershipPurchase && !this.allowPackagePurchase && !this.allowTrainingPurchase){
              Swal.fire({
                html: '<p style="font-size:15px;text-align:center">No services available for booking</p>',
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: 'Close',
              })
            }
            else if(this.allowMembershipPurchase){
              this.selectedPurchaseType = 'membership'
              this.infoService.selectedPurchaseType = this.selectedPurchaseType
              this.getMembership();
            }
            else if(this.allowPackagePurchase){
              this.selectedPurchaseType = 'package'
              this.infoService.selectedPurchaseType = this.selectedPurchaseType
              this.getPackages();
            }
            else if(this.allowTrainingPurchase){
              this.selectedPurchaseType = 'training'
              this.infoService.selectedPurchaseType = this.selectedPurchaseType
              this.getTraining();
            }
          }

          this.profileMap = new Map();
          this.permissionList.forEach(element => {
            if (element.hasOwnProperty("key") && element.type  != 'GENERAL' && element.hide){
              this.profileMap.set(element.key, JSON.parse(element.value))
            }
          });

        } else {

        }
      },
      error => {
        console.log("error", error);
      }
    );
  }
  next() {
    this.stepper.next();
  }
  removeWwwFromString(inputString) {
    return inputString.replace('www.', '');
  }
  nextStep($event, type) {
    console.log(type)
    // var url = this.removeWwwFromString(this.appService.paymentReturnUrl);
    // console.log(url)
    // window.location.href = url;
    switch (type) {
      case 'yourinfo':
        console.log(this.selectedServiceMap);
        var valid = false;
        if(this.selectedPurchaseType == 'service'){
          valid = this.validateServiceMap();
        }
        if (valid && this.selectedPurchaseType == 'service') {
          this.isLoading = false;
          if (parseInt(this.selectedPetNum) == this.currentPetNo) {
            console.log(this.petServiceMap);
            this.petServiceMap[this.currentPetNo - 1] = { services: { ...this.selectedServiceMap } };
            this.resetUserInfoForm();
            console.log("******************Service Map*****************")
            console.log(this.petServiceMap);
            this.isLoading = false;
            this.stepper.next();
          } else {
            var staffBasedService = this.selectedServiceMap.filter(x => x.basedOn === "STAFF_BASED")
            if (staffBasedService && staffBasedService.length > 0) {
              this.petServiceMap[this.currentPetNo - 1] = { services: { ...this.selectedServiceMap } };
              this.reservationTypes.forEach(reservationType => {
                if (reservationType.services && reservationType.services.length > 0) {
                  reservationType.services.forEach(service => {
                    service['selected'] = false;
                  });
                }
              });
              this.selectedServiceMap = [];
              this.startDate = null;
              this.endDate = null;
              this.selectedReservationTypeID = null;
              this.selectedServiceBasedOn = null;
              this.datePickerType = null;
              this.selectedStartTime = null;
              this.selectedEndTime = null;
              this.timeSlots = [];
              this.PickTimeSlots = [];

              this.selectedArea = null;
              this.selectedTime = null;
              this.selectedAddOnServices = [];
              this.capacityBasedSlotsData = [];
              this.currentPetNo++;
            } else {
              this.isLoading = false;
              this.openModal(this.serviceMapModal);
            }
          }
        }

        if(this.selectedPurchaseType == 'membership'){
          if (this.selectedMembership) {
            this.isLoading = false;
            this.stepper.next();
          }
          else {
            Swal.fire({
              title: 'Error',
              html: '<p style="font-size:15px;text-align:center">Please select a membership</p>',
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: 'Close',
            })
          }
        }

        if(this.selectedPurchaseType == 'package'){
          if (this.selectedPackage) {
            this.isLoading = false;
            this.stepper.next();
          }
          else {
            Swal.fire({
              title: 'Error',
              html: '<p style="font-size:15px;text-align:center">Please select a package</p>',
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: 'Close',
            })
          }
        }

        if(this.selectedPurchaseType == 'training'){
          if (this.sessionSelected) {
            this.isLoading = false;
            this.stepper.next();
          }
          else {
            Swal.fire({
              title: 'Error',
              html: '<p style="font-size:15px;text-align:center">Please select a session for training</p>',
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: 'Close',
            })
          }
        }

        break;
      case 'invite':
        if(this.inviteCodeCtrl.value && this.inviteCodePasswordCtrl.value && this.inviteCodeCtrl.value != '' && this.inviteCodePasswordCtrl.value != ''){
        this.isLoading = true
        let request = {
          inviteCode: this.inviteCodeCtrl.value,
          token: this.inviteCodePasswordCtrl.value,
          platform: 'WEB',
          device: '',
          timeZone: moment.tz.guess(),
          user: this.user,
        }
        if (request) {
          this.inviteCodeUser = true;
          this.newUserSignUp = false;
          this.appService.submitPasswordForInviteCode(request).subscribe(
            (res: any) => {
              this.isLoading = false
              if (res.status.code == 1000) {
                if (res.data) {
                  this.storageService.setItem('authObj', JSON.stringify(res.data));
                  this.appService.setAuthVariables(JSON.stringify(res.data));
                  this.userObj = res.data;
                  if(this.selectedPurchaseType != 'package'){
                    this.getPets(this.userObj['id']);
                  }
                  else{
                    this.getUserCards();
                  }
                  this.isLoading = false;
                  this.pageShowType = 'showpets';
                  this.appService.getUniversalLink(this.userObj['id']).subscribe(
                    res => {
                      console.log(res);
                      this.inviteUrl = res['data']['inviteUrl'];
                    },
                    error => {
                      console.log("error", error);
                    });
                  this.stepper.next();
                  this.appService.getUserDetailByUserKey(this.userObj['id']).subscribe(
                    response => {
                      console.log(response);
                      if (response && response['data']) {
                        this.userDetails = response['data'];
                        if (response['data'].address &&  response['data'].address.line1 && response['data'].address.city && response['data'].address.state && response['data'].address.zipCode && response['data'].address.line1 != "" && response['data'].address.city != "" && response['data'].address.state != "" && response['data'].address.zipCode !="") {
                          this.showAddressField = false;
                          this.addressSaved = true;
                        }
                        else {
                          this.showAddressField = true
                        }
                        this.appService.setAuthVariables(JSON.stringify(res.data));
                        this.storageService.setItem('email', res['data']['email']);
                        this.storageService.setItem('no', res['data']['mobileNumber']);
                        this.petOwnerMandatory = {}
                        this.checkPetOwnerMandatory();
                      }
                      else {
                        this.showAddressField = false;
                        this.addressSaved = true;
                      }

                    },
                    error => {
                      this.stepper.next();
                      console.log("error", error);
                    });
                }
              }
            },
            (err: any) => {
              this.isLoading = false
              Swal.fire({
                title: 'Error',
                html: '<p style="font-size:15px;text-align:center">' + err.message + '</p>',
                // text: err.error.message,
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: 'Close',
              })
            })
        }
        }

        break;
      case 'signin':
        const email = this.existEmailCtrl.value;
        const password = this.existPassCtrl.value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email && email != '' && emailRegex.test(email) && password && password != '') {
          // this.storageService.clearData();
          this.isLoading = true;
          this.authService.login(email, password, this.organizationKey).subscribe(
            (res: any) => {
              console.log("loggedin", res);
              this.isLoading = false;
              if (res["userType"] == "EMPLOYEE" || res["userType"] == "ADMIN" || res["userType"] == "ORGANIZATION_ADMIN") {
                Swal.fire("You seem to have another type of account with us and cannot login to this app using same email or mobile #");
              } else {
                this.inviteCodeUser = false;
                this.newUserSignUp = false;
                this.pageShowType = 'showpets';
                this.storageService.setItem('authObj', JSON.stringify(res));
                localStorage.setItem('tenant', res.tenant)
                this.appService.setAuthVariables(JSON.stringify(res));
                this.userObj = res;
                if(this.selectedPurchaseType != 'package'){
                  this.getPets(this.userObj['id']);
                }
                else{
                  this.getUserCards();
                }
                this.isLoading = false;
                this.appService.getUniversalLink(this.userObj['id']).subscribe(
                  res => {
                    console.log(res, 'sign in inside');
                    this.storageService.setItem('email', res['data']['user']['email']);
                    this.storageService.setItem('no', res['data']['user']['mobileNumber']);
                    this.inviteUrl = res['data']['inviteUrl'];
                  },
                  error => {
                    console.log("error", error);
                  });
                this.stepper.next();
                this.appService.getUserDetailByUserKey(this.userObj['id']).subscribe(
                  response => {
                    console.log(response);
                    if (response && response['data']) {
                      this.userDetails = response['data'];
                      if (response['data'].address &&  response['data'].address.line1 && response['data'].address.city && response['data'].address.state && response['data'].address.zipCode && response['data'].address.line1 != "" && response['data'].address.city != "" && response['data'].address.state != "" && response['data'].address.zipCode !="") {
                        this.showAddressField = false;
                        this.addressSaved = true;
                      }
                      else {
                        this.showAddressField = true
                      }
                      this.petOwnerMandatory = {}
                      this.checkPetOwnerMandatory();
                    }
                    else {
                      this.showAddressField = false;
                      this.addressSaved = true;
                    }

                  },
                  error => {
                    this.stepper.next();
                    console.log("error", error);
                  });
              }
              // this.petServiceMap.forEach

            },
            error => {
              // console.log("error", error);
              this.isLoading = false;
              this.loginErrMsg = "Invalid username or password.";
            }
          );

        }
        break;
      case 'signup':
        var userObj = {
          firstName: this.firstNameCtrl.value,
          lastName: this.lastNameCtrl.value,
          email: this.newEmailCtrl.value,
          mobileNumber: this.phoneCtrl.value,
          token: this.newPassCtrl.value,
          address:{
            city:this.newCityCtrl.value,
            state:this.newStateCtrl.value,
            zipCode:this.newZipCtrl.value,
            line1:this.newStreetCtrl.value,
            displayAddress: `${this.newStreetCtrl.value || ''}, ${this.newCityCtrl.value || ''}, ${this.newStateCtrl.value || ''}, ${this.newZipCtrl.value || ''}`
          }
        }
        console.log(userObj, 'userObj');
        const emailRegexValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (userObj.firstName && userObj.firstName.trim() != '' && userObj.lastName && userObj.lastName.trim() != '' && userObj.email && userObj.email.trim() != '' && emailRegexValidation.test(userObj.email) && userObj.mobileNumber && userObj.mobileNumber.trim() != '' && userObj.token && userObj.token.trim() != '' && userObj.address.city && userObj.address.city.trim() != '' && userObj.address.state && userObj.address.state.trim() != '' && userObj.address.zipCode && userObj.address.zipCode.trim() != '' && userObj.address.line1 && userObj.address.line1.trim() != ''){
          if (this.validateEmail(userObj)) {
            this.isLoading = true;
            this.inviteCodeUser = false;
            this.newUserSignUp = true;
            this.authService.signUp(userObj).subscribe(
              res => {
                this.isLoading = false;
                console.log(res, 'response');

                console.log(res["data"]);
                if (res["data"] && res["data"]["responseCode"] == 1004) {
                  this.signupErrMsg = res["data"]["message"];
                  return;
                }
                this.pageShowType = 'addpet';
                this.userObj = res["data"];
                this.userDetails = res["data"];
                this.userDetails.userKey = res["data"]["id"];
                this.petOwnerMandatory = {}
                this.checkPetOwnerMandatory();
                this.appService.setAuthVariables(JSON.stringify(res["data"]));
                localStorage.setItem("locationKey", this.location.locationKey)
                this.getVetData();
                this.appService.getUniversalLink(res['data']['id']).subscribe(
                  res => {
                    console.log(res, 'universal Link');
                    this.inviteUrl = res['data']['inviteUrl'];
                  },
                  error => {
                    console.log("error", error);
                  }
                );
                this.addressSaved = true;
                this.storageService.setItem('authObj', JSON.stringify(res["data"]));
                this.stepper.next();
              },
              error => {
                console.log("error", error);
                this.isLoading = false;

                Swal.fire({
                  icon: 'warning',
                  title: 'Warning',
                  html: '<p style="font-size:15px;text-align:center">Your account already exists. Please login with your email.</p>',
                  confirmButtonText: 'Ok',
                  showCancelButton: false,
                })
              }
            );
          }
        }
        break;
      case 'addpet':
        var petname = this.petNameCtrl.value;
        if (this.validatePet(petname,'add')) {
          if (petname && petname.trim() != '' && this.selectedPetBread && this.selectedPetBread != "") {
            this.savePet();
          }
        }
        break;
      case 'editPet':
        var petname = this.petNameCtrl.value;
        if (this.validatePet(petname,'edit')) {
          if (petname && petname.trim() != '' && this.selectedPetBread && this.selectedPetBread != "") {
            this.updatePet();
          }
        }
        break;
      case 'confirm':
        // if(!this.addressSaved && !this.validateUserAddress('save')){
        //   Swal.fire({
        //     icon: 'warning',
        //     title: 'Warning',
        //     html: '<p style="font-size:15px;text-align:center">Please save your address to continue.</p>',
        //     confirmButtonText: 'Ok',
        //     showCancelButton: false,
        //   })
        //   return;
        // }

        if(!this.allMandatoryFieldsAdded()){
          Swal.fire({
            icon: 'warning',
            title: 'Warning',
            html: '<p style="font-size:15px;text-align:center">Please fill all pet owner mandatory fields to continue.</p>',
            confirmButtonText: 'Ok',
            showCancelButton: false,
          })
          return;
        }
        else if(!this.addressSaved || (this.petOwnerMandatory && (this.petOwnerMandatory.requireAuthorized || this.petOwnerMandatory.requireEmergency || this.petOwnerMandatory.requireMobile || this.petOwnerMandatory.requireEmail))){
          this.updatePetOwnerDetails();
        }
        var BreakException = {};
        try {

          this.petServiceMap.forEach(petService => {
            if (!petService['pet']) {
              Swal.fire("Please assign pet to each service!");
              throw BreakException;
            }

            let pushValue = {
              name: petService.pet.name,
              petKey: petService.pet.petKey,
              typeID: petService.pet.type.id,
              ForceFeeding: false,
              ForceMedication: false,
              ForceCardOnFile: false,
              answers: new Map<string, questions>()
            }
            console.log(pushValue);

            this.infoService.addPetKey(pushValue);

          });
          this.createAppointmnet();
        } catch (e) {
          if (e !== BreakException) throw e;
        }

        this.getAgreements()
        this.getImmunizationsForPetType()
        setTimeout(() => { this.getImmunizations() }, 1000);
        break;
      case 'membership-confirm':
        // if (!this.addressSaved && !this.validateUserAddress('save')) {
        //   Swal.fire({
        //     icon: 'warning',
        //     title: 'Warning',
        //     html: '<p style="font-size:15px;text-align:center">Please save your address to continue.</p>',
        //     confirmButtonText: 'Ok',
        //     showCancelButton: false,
        //   })
        //   return;
        // }

        if(!this.allMandatoryFieldsAdded()){
          Swal.fire({
            icon: 'warning',
            title: 'Warning',
            html: '<p style="font-size:15px;text-align:center">Please fill all pet owner mandatory fields to continue.</p>',
            confirmButtonText: 'Ok',
            showCancelButton: false,
          })
          return;
        }
        else if(!this.addressSaved || (this.petOwnerMandatory && (this.petOwnerMandatory.requireAuthorized || this.petOwnerMandatory.requireEmergency || this.petOwnerMandatory.requireMobile || this.petOwnerMandatory.requireEmail))){
          this.updatePetOwnerDetails();
        }

        var selectedPets = this.userPets.filter(pet => pet.selected);
        if (selectedPets.length == 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Warning',
            html: '<p style="font-size:15px;text-align:center">Please select a pet to continue.</p>',
            confirmButtonText: 'Ok',
            showCancelButton: false,
          })
          return;
        }

        if(this.selectedPurchaseType == 'membership'){
          if (this.selectedMembership.restrictByPetCount && this.selectedMembership.restrictByPetCount == true) {
            if (this.selectedMembership.maxPetsAllowedOnPurchase) {
              if (selectedPets.length > this.selectedMembership.maxPetsAllowedOnPurchase) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Warning',
                  html: '<p style="font-size:15px;text-align:center">Please select only ' + this.selectedMembership.maxPetsAllowedOnPurchase + 'pets for ' + this.selectedMembership.name + '</p>',
                  confirmButtonText: 'Ok',
                  showCancelButton: false,
                })
                return;
              }
              else if (selectedPets.length < this.selectedMembership.maxPetsAllowedOnPurchase) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Warning',
                  html: '<p style="font-size:15px;text-align:center">Please select ' + this.selectedMembership.maxPetsAllowedOnPurchase + 'pets for ' + this.selectedMembership.name + '</p>',
                  confirmButtonText: 'Ok',
                  showCancelButton: false,
                })
                return;
              }
            }
          }
          
          if(!this.selectedMembership.displayDateWhilePurchase){
            if(this.selectedMembership.subscriptionEffectiveDate && this.selectedMembership.subscriptionEffectiveDate != ''){
              this.selectedMembership.effectiveDate =  moment(this.selectedMembership.subscriptionEffectiveDate).isAfter(moment()) ? moment(this.selectedMembership.subscriptionEffectiveDate).format('MM/DD/YYYY') : moment().format('MM/DD/YYYY');
           }
           else{
            moment.tz.setDefault(this.locationTimezone);
            let month = Number(new Date().getMonth() + 1) > 9 ? Number(new Date().getMonth() + 1) : '0' + Number(new Date().getMonth() + 1);
            let day = new Date().getDate() > 9 ? new Date().getDate() : '0' + new Date().getDate();
            let year = new Date().getFullYear();
            let slashFormat = month + '/' + day + '/' + year;
            this.selectedMembership.effectiveDate = slashFormat;
            this.selectedMembership.startDate = new Date();
           }
          }
          else{
            moment.tz.setDefault(this.locationTimezone);
            let month = Number(new Date().getMonth() + 1) > 9 ? Number(new Date().getMonth() + 1) : '0' + Number(new Date().getMonth() + 1);
            let day = new Date().getDate() > 9 ? new Date().getDate() : '0' + new Date().getDate();
            let year = new Date().getFullYear();
            let slashFormat = month + '/' + day + '/' + year;
            this.selectedMembership.effectiveDate = slashFormat;
            this.selectedMembership.startDate = new Date();
          }
          if(this.selectedMembership.allowAutoRenewal){
            this.selectedMembership.autoRenewal = "true";
            // if(!this.selectedMembership.showAutoRenewalOption){
            //   this.selectedMembership.autoRenewal = "true";
            // }
          }
          else{
            this.selectedMembership.autoRenewal = "false";
          }
          if(this.selectedMembership.reservationServices.service.priceTiers && this.selectedMembership.reservationServices.service.priceTiers.length > 1){
            var selectedPet = this.userPets.filter(x => x.selected == true);
            if(selectedPet.length > 1){
              var findTier = this.selectedMembership.reservationServices.service.priceTiers[selectedPet.length -1]
              if(findTier){
                this.selectedMembership.reservationServices.service.priceTiers[0] = findTier;
                this.selectedMembership.totalPrice = (findTier.amount + (findTier.amount * (this.selectedMembership.reservationServices.service.taxPercentage ? this.selectedMembership.reservationServices.service.taxPercentage : 0) / 100)).toFixed(2);
              }
              else{
                var findTier = this.selectedMembership.reservationServices.service.priceTiers[this.selectedMembership.reservationServices.service.priceTiers.length - 1]
                this.selectedMembership.reservationServices.service.priceTiers[0] = findTier;
                this.selectedMembership.totalPrice = (findTier.amount + (findTier.amount * (this.selectedMembership.reservationServices.service.taxPercentage ? this.selectedMembership.reservationServices.service.taxPercentage : 0) / 100)).toFixed(2);
              }
            }
            else{
              this.selectedMembership.reservationServices.service.priceTiers[0] = this.selectedMembership.reservationServices.service.priceTiers[0];
            }
          }
          this.selectedMembership.petNames = this.userPets.filter(x => x.selected).map(x => x.name).join(',');
          this.getUserMembershipAgreement('membership');
          this.immunizationPassCheck = true;
          if(this.selectedMembership.requireVaccineInfo && this.selectedMembership.immTypes && this.selectedMembership.immTypes.length > 0){
            this.getImmunizationsForPetType();
            setTimeout(() => { 
              for(var i = 0 ; i < this.userPets.length ; i++){
                if(this.userPets[i].selected){
                  this.getImmunizationsCall(this.selectedMembership.immTypes, this.userPets[i].petKey,this.userPets[i].name)
                }
              }
             }, 1000);
          }
        }
        else if(this.selectedPurchaseType == 'training'){
          this.immunizationPassCheck = true;
          if(this.selectedSession.groupService.immunizationTypeId && this.selectedSession.groupService.immunizationTypeId != '' && this.selectedSession.groupService.forceImmunization){
            this.selectedSession.groupService.immTypes = this.selectedSession.groupService.immunizationTypeId.includes(",") ? this.selectedSession.groupService.immunizationTypeId.split(",") : [this.selectedSession.groupService.immunizationTypeId]
            console.log(this.selectedSession.groupService.immTypes)
            this.getImmunizationsForPetType();
            setTimeout(() => { 
              for(var i = 0 ; i < this.userPets.length ; i++){
                if(this.userPets[i].selected){
                  this.getImmunizationsCall(this.selectedSession.groupService.immTypes, this.userPets[i].petKey,this.userPets[i].name)
                }
              }
             }, 1000);
          }
          this.getUserMembershipAgreement('training');
        }
        this.getUserCards();
        this.stepper.next();


        break;
      case 'forget':
        var emailAdd = this.existEmailCtrl.value;
        var validEmail = this.regex.test(this.existEmailCtrl.value);
        if (validEmail) {
          this.isLoading = true;
          this.authService.forgotPassword(emailAdd).subscribe(
            res => {
              this.isLoading = false;
              console.log(res["data"]);
              if (res["data"] && res["data"]["responseCode"] == 1000) {
                this.forgetsuccessMsg = res["status"]["message"];
                this.forgetsucess = true;
                return;
              }
              else if (res["data"] && res["data"]["responseCode"] == 1004) {
                this.loginErrMsg = res["data"]["message"];
              }
            },

            error => {
              // console.log("error", error);
              this.isLoading = false;
              this.loginErrMsg = "Your account not found.";
            }
          );
        }
        break;
      default:
        break;
    }
  }
  showForgetPassword(show) {
    this.showForget = show;
  }



  validateEmail(user) {
    var validEmail = this.regex.test(user.email);
    if (!validEmail) {
      return false;
    }
    if (user.mobileNumber.length != 10) {
      return false;
    }
    return true;
  }

  appponitmentSummary:any;

  createAppointmnet() {
    console.log(this.petServiceMap, "pet service map");

    moment.tz.setDefault(this.locationTimezone);
    let appointment = {
      appointmentDate: undefined,
      appointmentEndTime: undefined,
      location: {
        locationKey: this.selectedLocation
      },
      appointmentDetails: [],
      questions: [],
      appointmentKey: "",
      appointmentSource: "WEB"
    }

    let index = 0;
    this.immunizations = [];
    console.log("asdf", this.petServiceMap);

    var makeAllServicesManual = false;
    if (this.petServiceMap.length > 1) {
      var isAutoService = false;
      var isManualSevrice = false;
      var showStaff = false;
      for (let i = 0; i < this.petServiceMap.length; i++) {
        for (const [key, service] of Object.entries(this.petServiceMap[i]['services'])) {
          if (service['isAutoApproval']) {
            isAutoService = true;
          }
          if (!service['isAutoApproval']) {
            isManualSevrice = true;
          }
          if (service['showStaff']) {
            showStaff = true;
          }
        }
      }
      if (isManualSevrice && isAutoService) {
        makeAllServicesManual = true;
      }
    }

    this.petServiceMap.forEach(petService => {

      let appointmentDetail = {
        pet: {
          petKey: petService['pet'].petKey,
          name: petService['pet'].name,
          type: petService['pet'].type,
          appointmentCount: petService['pet'].appointmentCount
        },
        reservationTypes: [],
        notes: [
          {
            description: petService['notes'],
            createdByName: this.userObj['firstName']
          }
        ],
        deleted: false,
        selected: true,
      }

      for (const [key, service] of Object.entries(petService['services'])) {
        let sDate = moment(service['startDate']).format("MM-DD-YY");
        let eDate = moment(service['endDate']).format("MM-DD-YY");
        let startDate = moment(sDate, "MM-DD-YY").valueOf();
        let endDate = moment(eDate, "MM-DD-YY").valueOf();

        let reservationType = {
          id: key,
          startDate,
          endDate,
          services: [],
          questions: [],
          name: "",
          deleted: false,
          linkedReservationTypeId : 0 ,
          serviceBasedOn : service['basedOn']
        }

        if (service['basedOn'] == 'LODGING_BASED') {
          reservationType.startDate = this.getConvertedDateAndTime(service['startDate'], service['startTime']['name']).valueOf();
          reservationType.endDate = this.getConvertedDateAndTime(service['endDate'], service['endTime']['name']).valueOf();
        }

        if (service['basedOn'] == 'CAPACITY_BASED') {
          reservationType.startDate = this.getConvertedDateAndTime(service['startDate'], service['timeSlot']['name']).valueOf();
          reservationType.endDate = this.getConvertedDateAndTime(service['endDate'], service['timeSlot_end']['name']).valueOf();
        }
        if (service['basedOn'] == 'STAFF_BASED') {
          var sTime = moment(service['timeSlot']['startTime']).tz(this.locationTimezone);
          var eTime = moment(service['timeSlot']['endTime']).tz(this.locationTimezone);

          reservationType.startDate = this.getConvertedDateAndTime(service['startDate'], sTime).valueOf();
          reservationType.endDate = this.getConvertedDateAndTime(service['endDate'], eTime).valueOf();
        }
        if (this.reservationTypesMap[key].immunizationTypeId && this.reservationTypesMap[key].immunizationTypeId != '') {
          this.immunizations.push(this.reservationTypesMap[key].immunizationTypeId);
        }

        if (this.reservationTypesMap[key].cardOnFileRequired) {
          this.cardOnFileRequired = true;
        }

        if (this.reservationTypesMap[key].medicationRequired) {
          this.medicationRequired = true;
        }

        if (this.reservationTypesMap[key].feedingRequired) {
          this.feedingRequired = true;
        }
        console.log(this.reservationTypesMap[key],"key");
        // 🏵️ Check is force question ? if yes add all question to the appointment later add it to the respective pet 
        if (this.reservationTypesMap[key].questions && this.reservationTypesMap[key].questions.length > 0 && this.reservationTypesMap[key].forceQuestions) {
          reservationType.questions = this.reservationTypesMap[key].questions;
        }

        if(this.reservationTypesMap[key].linkedReservationTypeId && this.reservationTypesMap[key].forceQuestions){
          reservationType.linkedReservationTypeId = this.reservationTypesMap[key].linkedReservationTypeId
        }
        reservationType.name = this.reservationTypesMap[key].name;

        if (this.reservationTypesMap[key].questions && this.reservationTypesMap[key].questions.length > 0) {
          this.questions = this.questions.concat(this.reservationTypesMap[key].questions);
        }

        let serviceAssignments = [];
        let startDateAndTime = null;
        let endDateAndTime = null;

        console.log(service);

        switch (service['basedOn']) {
          case 'STAFF_BASED':
            startDateAndTime = moment(service['timeSlot']['startTime']).tz(this.locationTimezone);
            endDateAndTime = moment(service['timeSlot']['endTime']).tz(this.locationTimezone);
            break;
          case 'LODGING_BASED':
            startDateAndTime = this.getConvertedDateAndTime(service['startDate'], service['startTime']['name']);
            endDateAndTime = this.getConvertedDateAndTime(service['endDate'], service['endTime']['name']);
            break;
          case 'CAPACITY_BASED':
            startDateAndTime = this.getConvertedDateAndTime(service['startDate'], service['timeSlot']['name']);
            endDateAndTime = this.getConvertedDateAndTime(service['startDate'], service['timeSlot_end']['name']);
            break;
          default:
            break;
        }

        appointment.appointmentDate = moment(startDateAndTime).valueOf();
        appointment.appointmentEndTime = moment(endDateAndTime).valueOf();

        var calendarStartDate = moment(moment(startDateAndTime), "DD.MM.YYYY hh:mm A");
        var calendarEndDate = moment(moment(endDateAndTime), "DD.MM.YYYY hh:mm A");

        while (moment(calendarStartDate).isSameOrBefore(calendarEndDate, 'day')) {
          var assignmentObj = {
            date: calendarStartDate.format('x'),
            // lodging: (service['basedOn'] !== "STAFF_BASED" ? { id: service['areaSlot']['id'] } : undefined),
            // assignedTo: (service['basedOn'] === "STAFF_BASED" ? { userKey: service['timeSlot']['employees'][index]['userKey'] } : undefined)
          }

          if (service['isAutoApproval'] && !makeAllServicesManual) {
            assignmentObj["lodging"] = (service['basedOn'] !== "STAFF_BASED" ? { id: service['areaSlot']['id'] } : undefined);
            assignmentObj["assignedTo"] = (service['basedOn'] === "STAFF_BASED" ? { userKey: service['timeSlot']['employees'][index]['userKey'] } : undefined);
          }

          if (service['basedOn'] == "STAFF_BASED") {
            assignmentObj['endDate'] = calendarEndDate;
          }
          if (service['showStaff']) {
            assignmentObj["assignedTo"] = (service['basedOn'] === "STAFF_BASED" ? { userKey: service['timeSlot']['selectedEmployee']['userKey'] } : undefined);
          }
          serviceAssignments.push(assignmentObj);
          calendarStartDate.add(1, 'days');
        }

        reservationType.services.push({
          id: service['service']['id'],
          serviceAssignments,
          deleted: false
        });

        service['addOn'] && service['addOn'].forEach((addOn) => {
          if ((addOn.selected || addOn.deleted) && addOn.addOn) {
            let serviceAssignments = [];
            switch (service['basedOn']) {
              case 'STAFF_BASED':
                var date = moment(moment(service['startDate']), "DD.MM.YYYY hh:mm A");
                serviceAssignments.push({
                  date: date.format('x'),
                });
                break;
              case 'LODGING_BASED':
                if (addOn.dateList) {
                  addOn.dateList.forEach((serviceDate) => {
                    var date = moment(moment(serviceDate['date']), "DD.MM.YYYY hh:mm A");
                    if (serviceDate.checked) {
                      serviceAssignments.push({
                        date: date.format('x'),
                      })
                    }
                  })
                } else {
                  addOn.dates = [];
                }
                break;
              case 'CAPACITY_BASED':
                var date = moment(moment(service['startDate']), "DD.MM.YYYY hh:mm A");
                serviceAssignments.push({
                  date: date.format('x'),
                });
                break;
              default:
                break;
            }
            reservationType.services.push({ id: addOn.id, serviceAssignments: serviceAssignments, deleted: addOn.deleted ? addOn.deleted : false });
          }
        });
        appointmentDetail.reservationTypes.push(reservationType);
      }
      // index++;
      appointment.appointmentDetails.push(appointmentDetail);
    });
    this.isLoading = true;
    this.stepper.next();
    this.appponitmentSummary = appointment.appointmentDetails
    this.infoService.storeAppointment(appointment, this.userObj['id']);
    this.infoService.forceCheck().subscribe(res => {
      if (res) {
        this.nextPageStepperControl.prevPageSubmitAction();
        this.updateControlVariable();
      }
    })
  }
  formatTimestamp(reservation:any) {
    if(reservation.hasOwnProperty('endDate') && (reservation.serviceBasedOn != 'STAFF_BASED' || this.showEndTimeForStaffBased)){
      return moment(reservation.startDate).format('ddd DD MMM YYYY h:mm A') + " - " + moment(reservation.endDate).format('ddd DD MMM YYYY h:mm A') ;
    }else{
      return moment(reservation.startDate).format('ddd DD MMM YYYY h:mm A')
    }
     // You can customize the format as needed
  }

  validatePet(pet, type) {
    if (!pet || pet.trim() == "") {
      Swal.fire('Enter pet name');
      return false;
    }
    if (!this.selectedPetBread) {
      Swal.fire('Select pet breed');
      return false;
    }

    if (this.ageRequired && !this.petBirth) {
      Swal.fire('Enter pet birth date');
      return false;
    }

    if (this.genderRequired && !this.selectedPetGender) {
      Swal.fire('Select pet gender');
      return false;
    }

    if (this.weightMandatory && !this.petWeight) {
      Swal.fire('Enter pet weight');
      return false;
    }

    //app_profile_setting value validating AddPet!!
    if (this.profileMap.size > 0) {
      if (this.profileMap.has('PET_COLOR_WEB')) {
        let colorRequired = false;
        if (type == 'add') {
          this.profileMap.get("PET_COLOR_WEB").forEach(item => {
            if (item.type == "onCreatePet") {
              colorRequired = item.status;
            }
          });
        }
        if (type == 'edit') {
          this.profileMap.get("PET_COLOR_WEB").forEach(item => {
            if (item.type == "onCreateAppointment") {
              colorRequired = item.status;
            }
          })
        }
        if (colorRequired && !this.petColor) {
          Swal.fire("Pet's Color Required!");
          return false;
        }
      }
      //dob
      if (this.profileMap.has('PET_DOB_WEB')) {
        let colorRequired = false;
        if (type == 'add') {
          this.profileMap.get("PET_DOB_WEB").forEach(item => {
            if (item.type == "onCreatePet") {
              colorRequired = item.status;
            }
          });
        }
        if (type == 'edit') {
          this.profileMap.get("PET_DOB_WEB").forEach(item => {
            if (item.type == "onCreateAppointment") {
              colorRequired = item.status;
            }
          })
        }
        if (colorRequired && !this.petBirth) {
          Swal.fire("Pet's Date of birth Required!");
          return false;
        }
      }
      //gender
      if (this.profileMap.has('PET_SEX_WEB')) {
        let genderRequired = false;
        if (type == 'add') {
          this.profileMap.get("PET_SEX_WEB").forEach(item => {
            if (item.type == "onCreatePet") {
              genderRequired = item.status;
            }
          });
        }
        if (type == 'edit') {
          this.profileMap.get("PET_SEX_WEB").forEach(item => {
            if (item.type == "onCreateAppointment") {
              genderRequired = item.status;
            }
          })
        }
        if (genderRequired && !this.selectedPetGender) {
          Swal.fire("Pet's Gender Required!");
          return false;
        }
      }
      //weight
      if (this.profileMap.has('PET_WEIGHT_WEB')) {
        let weightRequired = false;
        if (type == 'add') {
          this.profileMap.get("PET_WEIGHT_WEB").forEach(item => {
            if (item.type == "onCreatePet") {
              weightRequired = item.status;
            }
          });
        }
        if (type == 'edit') {
          this.profileMap.get("PET_WEIGHT_WEB").forEach(item => {
            if (item.type == "onCreateAppointment") {
              weightRequired = item.status;
            }
          })
        }
        if (weightRequired && !this.petWeight) {
          Swal.fire("Pet's Weight Required!");
          return false;
        }
      }

      if (this.profileMap.has('PET_VETERINARIAN_WEB')) {
        let vetRequired = false;
        if (type == 'add') {
          this.profileMap.get("PET_VETERINARIAN_WEB").forEach(item => {
            if (item.type == "onCreatePet") {
              vetRequired = item.status;
            }
          });
        }
        if (type == 'edit') {
          this.profileMap.get("PET_VETERINARIAN_WEB").forEach(item => {
            if (item.type == "onCreateAppointment") {
              vetRequired = item.status;
            }
          })
        }
        if (vetRequired && !this.selectedVetDetails) {
          Swal.fire("Pet's Veterinarian Required!");
          return false;
        }
      }
    }
    return true;
  }

  validateServiceMap() {
    var BreakException = {};
    let result = true;
    try {
      const populatedServices = this.selectedServiceMap.filter(service => service !== undefined && service !== null);
      if (populatedServices.length == 0) {
        Swal.fire('You need to select at least one service!');
        result = false;
        throw BreakException;
      }
      this.selectedServiceMap.forEach(service => {
        console.log(service);
        switch (service['basedOn']) {
          case 'STAFF_BASED':
            if (!service['service']) {
              Swal.fire("Service is required!");
              result = false;
              throw BreakException;
            }
            if (!service['startDate']) {
              Swal.fire(`Date is required for ${service['service']['name']}!`);
              result = false;
              throw BreakException;
            }
            if (!service['timeSlot']) {
              Swal.fire(`Time slot is required for ${service['service']['name']}!`);
              result = false;
              throw BreakException;
            }
            break;
          case 'LODGING_BASED':
            if (!service['service']) {
              Swal.fire("Service is required!");
              result = false;
              throw BreakException;
            }
            if (!service['startDate'] || !service['endDate']) {
              Swal.fire(`Start and end date is required for ${service['service']['name']}!`);
              result = false;
              throw BreakException;
            }
            if (!service['startTime'] || !service['endTime']) {
              Swal.fire(`Start and end time is required for ${service['service']['name']}!`);
              result = false;
              throw BreakException;
            }
            if (service['addOn'] && service['addOn'].length) {
              for (var i = 0; i < service['addOn'].length; i++) {
                if (service['addOn'][i].selected) {
                  var filterdate = service['addOn'][i].dateList.filter(slot => slot.checked == true);
                  if (filterdate.length == 0) {
                    Swal.fire(`Please select at lease one date for ${service['addOn'][i].name}!`);
                    result = false;
                    throw BreakException;
                  }
                }
              }
            }

            // if(!service['areaSlot']) {
            //   Swal.fire('Alert', `Area slot is required for ${service['service']['name']}!`);
            //   result = false;
            //   throw BreakException;
            // }
            break;
          case 'CAPACITY_BASED':
            if (!service['service']) {
              Swal.fire("Service is required!");
              result = false;
              throw BreakException;
            }
            if (!service['startDate']) {
              Swal.fire(`Date is required for ${service['service']['name']}!`);
              result = false;
              throw BreakException;
            }
            if (!service['timeSlot']) {
              Swal.fire(`Time slot is required for ${service['service']['name']}!`);
              result = false;
              throw BreakException;  
            }
            if(service.hasEndTime && !service['timeSlot_end']){
              Swal.fire(`End time slot is required for ${service['service']['name']}!`);
              result = false;
              throw BreakException;
            }
            // if(!service['areaSlot']) {
            //   Swal.fire(`Area slot is required for ${service['service']['name']}!`);
            //   result = false;
            //   throw BreakException;
            // }
            break;
          default:
            break;
        }

      });
    } catch (e) {
      if (e !== BreakException) throw e;
    }

    return result;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-dialog-centered custom-confirm-modal' });
  }

  confirm(): void {
    this.petServiceMap[this.currentPetNo - 1] = { services: { ...this.selectedServiceMap } };
    this.petServiceMap[this.currentPetNo] = { services: { ...this.selectedServiceMap } };
    console.log(this.petServiceMap)
    this.currentPetNo++;
    if (parseInt(this.selectedPetNum) == this.currentPetNo) {
      this.resetUserInfoForm();
      console.log("******************Service Map*****************")
      console.log(this.petServiceMap);
      this.stepper.next();
    }
    this.modalRef.hide();
  }

  decline(): void {
    this.petServiceMap[this.currentPetNo - 1] = { services: { ...this.selectedServiceMap } };
    this.reservationTypes.forEach(reservationType => {
      if (reservationType.services && reservationType.services.length > 0) {
        reservationType.services.forEach(service => {
          service['selected'] = false;
        });
      }
    });
    this.selectedServiceMap = [];
    this.startDate = null;
    this.endDate = null;
    this.selectedReservationTypeID = null;
    this.selectedServiceBasedOn = null;
    this.datePickerType = null;
    this.selectedStartTime = null;
    this.selectedEndTime = null;
    this.timeSlots = [];
    this.PickTimeSlots = [];
    this.openAccordion = false;
    this.panel.close();
    this.panels.forEach(panel => {
      panel.close();
    });
    this.selectedArea = null;
    this.selectedTime = null;
    this.selectedAddOnServices = [];
    this.capacityBasedSlotsData = [];
    this.currentPetNo++;
    this.modalRef.hide();
  }


  onLocationChange(event: any) {
    this.locationSelected = true
    this.locationCtrl.setValue(event.option.viewValue)
    this.selectedLocation = event.option.value;
    console.log('selectedLocation', event.option.value)
    let currentLocation = this.multiLocation.find(tenant => tenant.locationKey == this.selectedLocation)
    console.log('currentTenant..........', currentLocation)
    this.tenant = currentLocation.tenantKey
    localStorage.setItem('tenant', this.tenant)
    this.appService.setTenantKey(this.tenant);
    this.authService.setTenantKey(this.tenant);
    this.getAppProfile();

    this.getPetType(this.selectedLocation);
    this.storageService.setItem('locationKey', this.selectedLocation);

    this.location = currentLocation;
    this.locationTimezone = currentLocation.timezone;
    moment.tz.setDefault(this.locationTimezone);
    this.displayAddress = currentLocation.displayAddress;
    this.storageService.setItem('locationKey', this.selectedLocation);

    console.log('holidayCalendarKey.........', this.location.holidayCalendarKey)

    if (this.location.holidayCalendarKey) {
      this.getHolidayDates();
    }
  }

  onLocationChangeNew(event: MatSelectChange) {
    let selected: any = event.source.selected
    this.locationSelected = true
    this.locationCtrl.setValue(selected.value)
    this.selectedLocation = selected.value;
    console.log('selectedLocation', this.selectedLocation)
    let currentLocation = this.multiLocation.find(tenant => tenant.locationKey == this.selectedLocation)
    console.log('currentTenant..........', currentLocation)
    this.tenant = currentLocation.tenantKey
    localStorage.setItem('tenant',  this.tenant)
    this.appService.setTenantKey(this.tenant);
    this.infoService.setTenantKey(this.tenant);
    this.authService.setTenantKey(this.tenant);
    this.getAppProfile();

    this.getPetType(this.selectedLocation);
    this.storageService.setItem('locationKey', this.selectedLocation);

    this.location = currentLocation;
    this.locationName = currentLocation.name;
    this.locationTimezone = currentLocation.timezone;
    moment.tz.setDefault(this.locationTimezone);
    this.displayAddress = currentLocation.displayAddress;
    this.storageService.setItem('locationKey', this.selectedLocation);

    console.log('holidayCalendarKey.........', this.location.holidayCalendarKey)

    if (this.location.holidayCalendarKey) {
      this.getHolidayDates();
    }
    this.resetLocation();
    this.membershipList = [];
    this.packageList = [];
    this.selectedMembership = undefined;
    this.selectedPackage = undefined;
    this.sessionSelected = undefined;
    this.trainingList = [];
    this.value=false;
    this.selectedTraining = undefined;
    this.selectedSession = [];
    setTimeout(() => {
      if (this.selectedPurchaseType == 'membership') {
        if (this.allowMembershipPurchase) {
          this.getMembership();
        } else if(this.allowBookingServices){
          this.selectedPurchaseType = 'service';
        }
      }
    }, 1000)
    setTimeout(() => {
      if (this.selectedPurchaseType == 'package') {
        if (this.allowPackagePurchase) {
          this.getPackages();
        } else if(this.allowBookingServices){
          this.selectedPurchaseType = 'service';
        }
      }
    }, 1000)
    setTimeout(() => {
      if (this.selectedPurchaseType == 'training') {
        if (this.allowTrainingPurchase) {
          this.getTraining();
        } else if(this.allowBookingServices){
          this.selectedPurchaseType = 'service';
        }
      }
    }, 1000)
    setTimeout(() => {
      if (this.selectedPurchaseType == 'service') {
        if(!this.allowBookingServices){
          this.selectedPurchaseType = '';
          this.infoService.selectedPurchaseType = this.selectedPurchaseType;
          if(!this.allowMembershipPurchase && !this.allowPackagePurchase && !this.allowTrainingPurchase){
            Swal.fire({
              html: '<p style="font-size:15px;text-align:center">No services available for booking</p>',
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: 'Close',
            })
          }
          else if(this.allowMembershipPurchase){
            this.selectedPurchaseType = 'membership'
            this.infoService.selectedPurchaseType = this.selectedPurchaseType
            this.getMembership();
          }
          else if(this.allowPackagePurchase){
            this.selectedPurchaseType = 'package'
            this.infoService.selectedPurchaseType = this.selectedPurchaseType
            this.getPackages();
          }
          else if(this.allowTrainingPurchase){
            this.selectedPurchaseType = 'training'
            this.infoService.selectedPurchaseType = this.selectedPurchaseType
            this.getTraining();
          }
        }
      }
    }, 3000)
  }

  resetUserInfoForm() {
    this.existEmailCtrl.reset();
    this.existPassCtrl.reset();
    this.firstNameCtrl.reset();
    this.lastNameCtrl.reset();
    this.newEmailCtrl.reset();
    this.phoneCtrl.reset();
    this.newPassCtrl.reset();
    this.petNameCtrl.reset();
    this.petGenderCtrl.reset();
    this.petBreedCtrl.reset();
    this.inviteCodeCtrl.reset();
    this.inviteCodePasswordCtrl.reset();
    this.newStateCtrl.reset();
    this.newCityCtrl.reset();
    this.newZipCtrl.reset();
    this.newStreetCtrl.reset();
    this.inviteCityCtrl.reset();
    this.inviteStateCtrl.reset();
    this.inviteZipCtrl.reset();
    this.inviteStreetCtrl.reset();
    this.loginErrMsg = "";
    this.returnUserEmailEmpty = "";
    this.returnUserPassEmpty ="";
    this.signupErrMsg = "";
    this.inviteCodeErrMsg ="";
    this.inviteCodePasswordErrMsg = "";
    this.firstNameEmpty = "";
    this.lastNameEmpty = "";
    this.phoneEmpty = "";
    this.newPassEmpty = "";
    this.newEmailEmpty = ""
    this.newCityEmpty = "";
    this.newStateEmpty = "";
    this.newZipEmpty = "";
    this.streetAddressEmpty = "";
    this.inviteCityEmpty = "";
    this.inviteStateEmpty = "";
    this.inviteZipEmpty = "";
    this.inviteStreetEmpty = ""; 
    
  }

  getPetType(locationKey: string) {
    this.isLoading = true;
    console.log("******************  Getting Pet Types  ******************")
    var date = this.getTimezoneSpecificDateObj(new Date());
    var dt = date.valueOf();
    this.appService.getPetType_external(locationKey, dt,).subscribe(
      res => {
        this.isLoading = false;
        console.log(res)
        this.petTypes = res["list"];
        this.petTypes.sort((a, b) => {
          if (a.orderId < b.orderId) {
            return -1;
          }

          if (a.orderId > b.orderId) {
            return 1;
          }

          return 0;
        })
        for (let i = 0; i < this.petTypes.length; i++) {
          let petType = this.petTypes[i];
          if (petType.reservationTypes && petType.reservationTypes.length > 0) {
            petType.reservationTypes.map(reservationType => {
              if (reservationType.services && reservationType.services.length > 0) {
                reservationType.services = reservationType.services.filter(service => !service.serviceGroupType)
              }
            });
          }
        }

        if (this.petTypes && this.petTypes.length > 0) {
          var autoSelectPet = false;
          this.infoService.storePetType(this.petTypes);
          var findIndex = 0;
          if (this.petTypes.length>0 && this.petTypeFromQueryParam){
            findIndex = this.petTypes.findIndex(x=> x.id == this.petTypeFromQueryParam)
            if (findIndex == -1){
              findIndex = 0;
            }
            else{
              autoSelectPet = true;
            }
          }
          else{
            if (this.reservationTypeFromQueryParam) {
              let splitted: string[] = this.reservationTypeFromQueryParam.split(',')
              let findedReservationTypes: any[] = []
              splitted.forEach((a) => {
                let finded = this.reservationTypes.find((b) => b.id == a)
                if (finded) {
                  findedReservationTypes.push(finded)
                }
                else {
                  for (var i = 0; i < this.petTypes.length; i++) {
                    var type = this.petTypes[i]
                    let matchingReservationType = type.reservationTypes.find((rType) => rType.id == a);
                    if (matchingReservationType) {
                      findedReservationTypes.push(matchingReservationType);
                      findIndex = i;
                      autoSelectPet = true;
                    }
                  }
                }
              })
              this.reservationTypes = findedReservationTypes
            }
          }
          if(!autoSelectPet && this.petTypes.length == 1){
            autoSelectPet = true;
          }
          if(autoSelectPet){
            this.selectedPetID = this.petTypes[findIndex].id;
            this.infoService.getPetTypeId(this.selectedPetID);
            this.infoService.petTypeId = this.selectedPetID;
            this.newPetID = this.selectedPetID;
            this.selectedPetName = this.petTypes[findIndex].name;
            this.getReservationTypes(this.petTypes[findIndex]);
            this.addPetGender(this.petTypes[findIndex]);
            this.getPetBreed(this.petTypes[findIndex]);
          }
        }
      },
      error => {
        console.log("error", error);
      }
    );
  }

 

  onNewPetTypeChange($event: any) {
    this.newPetID = $event.value;
    var petType = this.petTypes.find(o => o.id == this.newPetID);
    this.addPetGender(petType);
    this.getPetBreed(petType);
  }

  onPetNumChange($event: any) {
    this.selectedPetNum = $event.value;
    if (this.selectedServiceID && this.selectedServiceBasedOn) {
      this.updateTimeSlots();
    }
  }

  getReservationTypesOld(petTypeObj) {
    console.log("**************  Getting Reservation Types  **************")
    this.reservationTypes = petTypeObj["reservationTypes"];
    if (this.reservationTypes && this.reservationTypes.length > 0) {
      this.reservationTypes.map(reservationType => {
        // reservationType.services = reservationType.services.filter(service => service.addOn == false)
        if (reservationType.services) {
          reservationType.services.map(service => {
            service['selected'] = false;
            service['isEveryDay'] = true;
            this.servicesMap[service['id']] = service;
          });
        }
        this.reservationTypesMap[reservationType['id']] = reservationType;
      });
    }
  }

  getReservationTypes(petTypeObj) {
    this.reservationTypes = []
    console.log("**************  Getting Reservation Types  **************")
    var filterReservationType = petTypeObj["reservationTypes"].filter(type => type.showForFirstAppointment === true && type.calendarKey);
    if (filterReservationType && filterReservationType.length > 0) {
      this.hasFirstPetServices = true
    }
    else{
      this.hasFirstPetServices = false
    }
    if(this.hasFirstPetServices){
      if(this.petOwnerType == "firstTimeAppointment"){
        this.reservationTypes = petTypeObj["reservationTypes"].filter(type => type.showForFirstAppointment === true && type.calendarKey);
      }
      else if(this.petOwnerType == "allReadyBookedAppointment"){
        this.reservationTypes  = petTypeObj["reservationTypes"].filter(type => type.calendarKey)
      }
    }
    else{
      this.reservationTypes = petTypeObj["reservationTypes"].filter(type => type.calendarKey)
    }
    if (this.reservationTypes && this.reservationTypes.length > 0) {
      if (this.reservationTypeFromQueryParam) {
        let splitted: string[] = this.reservationTypeFromQueryParam.split(',')
        let findedReservationTypes: any[] = []

        splitted.forEach((a) => {
          let finded = this.reservationTypes.find((b) => b.id == a)

          if (finded) {
            findedReservationTypes.push(finded)
          }
        })

        this.reservationTypes = findedReservationTypes

        console.log('reservationTypes route query param', splitted)
        console.log('reservationTypes', findedReservationTypes)

        this.reservationTypes.map(reservationType => {
          if (reservationType.services) {
            reservationType.services.map(service => {
              service['selected'] = false;
              service['isEveryDay'] = true;
              this.servicesMap[service['id']] = service;
            });
          }
          this.reservationTypesMap[reservationType['id']] = reservationType;
        });
      } else {
        this.reservationTypes.map(reservationType => {
          if (reservationType.services) {
            reservationType.services.map(service => {
              service['selected'] = false;
              service['isEveryDay'] = true;
              this.servicesMap[service['id']] = service;
            });
          }
          this.reservationTypesMap[reservationType['id']] = reservationType;
        });
      }
    }
  }

  filterNoAddOn(service) {
    return service.addOn == false
  }

  filterNoAddOnHasPriceTiers(service) {
    console.log('service.addOn', service.addOn, 'service.priceTiers', service.priceTiers)
    return service.addOn == false && service.priceTiers && service.priceTiers.length > 0
  }

  filterAddOn(service) {
    return service.addOn == true && service.priceTiers && service.priceTiers.length > 0
  }

  filterActive(pet) {
    return pet.status == "ACTIVE"
  }

  filterSelected(service) {
    return service.selected == true;
  }

  filterNotNull(service) {
    return service != null
  }

  filterSlotAvailable(slot) {
    console.log(slot['available'])
    return slot['available'] == true
  }

  onPetTypeChange($event: any) {
    this.selectedPetID = $event.value;
    this.infoService.getPetTypeId(this.selectedPetID);

    this.infoService.petTypeId = this.selectedPetID;

    this.newPetID = this.selectedPetID;
    this.resetLocation();
    this.selectedAddOnServices = [];
    this.datePickerType = null;
    var petType = this.petTypes.find(o => o.id == this.selectedPetID);
    this.selectedPetName = petType.name;
    this.getReservationTypes(petType);
    this.addPetGender(petType);
    this.getPetBreed(petType);
  }

  onnPOTypeChange($event:any){
    this.petOwnerType = $event.value
    this.resetLocation();
    this.selectedAddOnServices = [];
    this.datePickerType = null;
    this.servicesMap = [];
    this.selectedReservationTypeID = null;
    if (this.panel) {
      this.panel.close();
    }
    if (this.panels) {
      this.panels.forEach(panel => {
        panel.close();
      });
    }
    var petType = this.petTypes.find(o => o.id == this.selectedPetID);
    this.getReservationTypes(petType);
  }

  resetLocation(){
    this.selectedServiceID = null;
    this.selectedServiceBasedOn = null;
    this.timeSlots = [];
    this.PickTimeSlots = [];
    this.value=false;
    this.datePickerType ='';
    this.showGroupAddOnServices = false
    this.showPrimaryServicesInView = false;
    this.selectedServiceMap = [];
    console.log(this.selectedServiceMap);
    
  }

  selectCategory(reservationTypeID) {
    this.refreshTimeSlots();
    this.selectedReservationTypeID = reservationTypeID;
    this.selectedServiceBasedOn = this.reservationTypesMap[this.selectedReservationTypeID].serviceBasedOn;
    this.selectedCalendarKey = this.reservationTypesMap[this.selectedReservationTypeID].calendarKey;
    this.selectedInOutCalendarKey = this.reservationTypesMap[this.selectedReservationTypeID].inOutCalendarKey;
    this.datePickerType = this.selectedServiceBasedOn == "LODGING_BASED" ? "Range" : "Single";
    this.minNumberOfStay = undefined;
    if(this.reservationTypesMap[this.selectedReservationTypeID].minimumNoOfStay && this.reservationTypesMap[this.selectedReservationTypeID].minimumNoOfStay != 0){
      this.minNumberOfStay = this.reservationTypesMap[this.selectedReservationTypeID].minimumNoOfStay;
    }
    this.maxDate = new Date();
    this.maxDate.setFullYear(this.maxDate.getFullYear() + 5);
    if(this.reservationTypesMap[this.selectedReservationTypeID].allowBookingUntil && this.reservationTypesMap[this.selectedReservationTypeID].allowBookingUntil != 0){
      this.maxDate = new Date();
      this.maxDate.setMonth(this.maxDate.getMonth() + this.reservationTypesMap[this.selectedReservationTypeID].allowBookingUntil);
    }

    let bookingInterval: string = this.reservationTypesMap[this.selectedReservationTypeID].bookingInterval;
    // let todayDate = new Date();
    // let minDate =  todayDate.setDate(todayDate.getDate() + Number(bookingInterval))
    // this.minDate = new Date(minDate)

    /****************** Min Booking Window **********************/

    let minWindowFilterDates = []

    for (let i = 0; i < Number(bookingInterval); i++) {
      let todayDate = new Date();
      let date = new Date(todayDate.setDate(todayDate.getDate() + i))
      let formattedDate = date.getDate().toString() + '-' + (date.getMonth() + 1).toString() + '-' + date.getFullYear()
      minWindowFilterDates.push(formattedDate)
    }

    this.minWindowFilter = (d: Date | null): boolean => {
      let date = new Date(d).getDate().toString() + '-' + (new Date(d).getMonth() + 1).toString() + '-' + new Date(d).getFullYear()
      return !minWindowFilterDates.includes(date);
    };

    /****************** Min Booking Window **********************/

    this.startMonthObject = new Date();
    this.endMonthObject = new Date();
    if (this.datePickerType == 'Single') {
      setTimeout(() => {
        const prev_button = document.querySelectorAll
          ('.mat-calendar-previous-button')
        if (prev_button) {
          Array.from(prev_button).forEach(button => {
            this.renderer.listen(button, "click", (event) => {
              console.log('Single:Prev button clicked');
              var prevMonth = new Date(this.startMonthObject.getFullYear(), this.startMonthObject.getMonth() - 1, 1);
              this.onMonthChange(prevMonth);
            });
          })
        }
        const next_button = document.querySelectorAll
          ('.mat-calendar-next-button')
        if (next_button) {
          Array.from(next_button).forEach(button => {
            this.renderer.listen(button, "click", (event) => {
              console.log('Single:Next button clicked');
              var nextMonth = new Date(this.startMonthObject.getFullYear(), this.startMonthObject.getMonth() + 1, 1);
              this.onMonthChange(nextMonth);
            });
          })
        }
      })
    } else {
      setTimeout(() => {
        const s_prev_button = document.querySelectorAll
          ('.range-start .mat-calendar-previous-button')
        if (s_prev_button) {
          Array.from(s_prev_button).forEach(button => {
            this.renderer.listen(button, "click", (event) => {
              console.log('Range-S:Prev button clicked');
              var prevMonth = new Date(this.startMonthObject.getFullYear(), this.startMonthObject.getMonth() - 1, 1);
              this.rangeStartMonthChanged = true
              this.rangeStartMonthDate = prevMonth
              this.onMonthChange(prevMonth);
            });
          })
        }
        const s_next_button = document.querySelectorAll
          ('.range-start .mat-calendar-next-button')
        if (s_next_button) {
          Array.from(s_next_button).forEach(button => {
            this.renderer.listen(button, "click", (event) => {
              console.log('Range-S:Next button clicked');
              var nextMonth = new Date(this.startMonthObject.getFullYear(), this.startMonthObject.getMonth() + 1, 1);
              this.rangeStartMonthChanged = true
              this.rangeStartMonthDate = nextMonth
              this.onMonthChange(nextMonth);
            });
          })
        }
        const e_prev_button = document.querySelectorAll
          ('.range-end .mat-calendar-previous-button')
        if (e_prev_button) {
          Array.from(e_prev_button).forEach(button => {
            this.renderer.listen(button, "click", (event) => {
              console.log('Range-E:Prev button clicked');
              console.log("prev value", this.endMonthObject);
              var prevMonth = new Date(this.endMonthObject.getFullYear(), this.endMonthObject.getMonth() - 1, 1);
              this.rangeEndMonthChanged = true
              this.rangeEndMonthDate = prevMonth
              this.onMonthChange(prevMonth, true);
            });
          })
        }
        const e_next_button = document.querySelectorAll
          ('.range-end .mat-calendar-next-button')
        if (e_next_button) {
          Array.from(e_next_button).forEach(button => {
            this.renderer.listen(button, "click", (event) => {
              console.log('Range-E:Next button clicked');
              console.log("prev value", this.endMonthObject);
              var nextMonth = new Date(this.endMonthObject.getFullYear(), this.endMonthObject.getMonth() + 1, 1);
              this.rangeEndMonthChanged = true
              this.rangeEndMonthDate = nextMonth
              this.onMonthChange(nextMonth, true);
            });
          })
        }
      })
    }

    if (this.selectedServiceMap[this.selectedReservationTypeID]) {
      this.selectedServiceID = this.selectedServiceMap[this.selectedReservationTypeID].service.id;
      this.selectedTime = this.selectedServiceMap[this.selectedReservationTypeID]['timeSlot'];
      this.selectedStartTime = this.selectedServiceMap[this.selectedReservationTypeID]['startTime'];
      this.selectedEndTime = this.selectedServiceMap[this.selectedReservationTypeID]['endTime'];
      this.selectedArea = this.selectedServiceMap[this.selectedReservationTypeID]['areaSlot'];
      this.selectedAddOnServices = this.selectedServiceMap[this.selectedReservationTypeID]['addOn'];
      if (this.selectedCalendarKey) {
        this.serviceTimings = [];
        var month = moment().get('month')
        var time = moment.utc(month,"MM-DD-YYYY").local().format("MM/DD/YYYY HH:mm:ss")
        var dateMonth = new Date(time)
        this.getCalendarDates(dateMonth.valueOf(), this.selectedCalendarKey);
      }
      if (this.datePickerType == "Range") {
        this.startDate = this.selectedServiceMap[this.selectedReservationTypeID]['startDate'];
        this.endDate = this.selectedServiceMap[this.selectedReservationTypeID]['endDate'];
        this.onDateRangeChange([this.startDate, this.endDate]);
      } else {
        this.startDate = this.selectedServiceMap[this.selectedReservationTypeID]['startDate'];
        this.onSingleDateChange(this.startDate);
      }
    } else {
      this.selectedServiceID = null;
      this.selectedEndTime = null;
      this.selectedStartTime = null;
      if (this.selectedReservationTypeID && this.selectedServiceMap[this.selectedReservationTypeID]) {
        this.selectedServiceMap[this.selectedReservationTypeID]['endTime'] = null;
        this.selectedServiceMap[this.selectedReservationTypeID]['startTime'] = null;
      }
      this.timeSlots = [];
      this.PickTimeSlots = [];

      this.selectedArea = null;
      this.selectedTime = null;
      this.selectedAddOnServices = [];
      this.capacityBasedSlotsData = [];
    }

    this.showGroupAddOnServices = false
  }
  value = false;
  onServiceChange($event, serviceSelections) {
    let origin = $event.option.selected;
    // serviceSelections.deselectAll();
    if (origin) {
      this.value = true;
      // $event.option.selected = true;
      this.selectedServiceID = $event.option.value;
      this.selectedServiceMap[this.selectedReservationTypeID] = {
        addOn: this.reservationTypesMap[this.selectedReservationTypeID].services.filter(this.filterAddOn),
        service: this.servicesMap[this.selectedServiceID],
        basedOn: this.selectedServiceBasedOn,
        isAutoApproval: this.reservationTypesMap[this.selectedReservationTypeID].autoApproval,
        showStaff: this.reservationTypesMap[this.selectedReservationTypeID].showStaffName,
        scheduleType: this.reservationTypesMap[this.selectedReservationTypeID].serviceSlotType
      };
      this.reservationTypes.forEach(reservationType => {
        if (reservationType.id == this.selectedReservationTypeID) {
          reservationType.services.forEach(service => {
            if (service.id == this.selectedServiceID) {
              service['selected'] = true;
            } else {
              service['selected'] = false;
            }
          });
        }
      });
      if (this.selectedServiceBasedOn == "CAPACITY_BASED") {
        this.appService.getLodgingSlots(this.selectedServiceID).subscribe(
          res => {
            this.listOfLodging = [];
            for (var i = 0; i < res["list"].length; i++) {
              var tmpAttr = JSON.parse(res["list"][i].attributes);
              if (tmpAttr.status) {
                if (tmpAttr.status == "active" || tmpAttr.status == "Active" || tmpAttr.status == "ACTIVE") {
                  this.listOfLodging.push(res["list"][i]);
                }
              }
            }
          },
          error => {
            // console.log("error", error);
          }
        )
      };
    } else {
      this.selectedServiceID = null;
      this.selectedAddOnServices = [];
      delete this.selectedServiceMap[this.selectedReservationTypeID];
      this.validateAccordian();
    }

    console.log('this.selectedServiceMap', this.selectedServiceMap)

    this.startDate = null;
    this.endDate = null;
    this.selectedStartTime = null;
    this.selectedEndTime = null;
    this.timeSlots = [];
    this.PickTimeSlots = [];

    this.selectedArea = null;
    this.selectedTime = null;
    this.selectedAddOnServices = [];
    this.capacityBasedSlotsData = [];
    this.workingDates = [];
    this.serviceTimings = [];
    this.serviceHolidays = [];
    this.listOfStaffSlots = [];

    var date: Date
    var endDate: Date

    if (this.datePickerType == 'Single') {
      if (this.singleMonthChanged == true) {
        let startDate = new Date(this.singleMonthDate.setDate(this.singleMonthDate.getDate() + 1))
        date = this.getTimezoneSpecificDateObj(startDate);
      } else {
        date = this.getTimezoneSpecificDateObj(new Date());
      }
    }

    if (this.datePickerType == 'Range') {
      /* if(this.rangeStartMonthChanged == true){
         let rangeStartDate = new Date(this.rangeStartMonthDate.setDate(this.rangeStartMonthDate.getDate() + 1))
         date = this.getTimezoneSpecificDateObj(rangeStartDate);
       }else{
         date = this.getTimezoneSpecificDateObj(new Date());
       }
  
       if(this.rangeEndMonthChanged == true){
         if(this.rangeStartMonthChanged == true){
           let rangeStartDate = new Date(this.rangeStartMonthDate.setDate(this.rangeStartMonthDate.getDate() + 1))
           date = this.getTimezoneSpecificDateObj(rangeStartDate);
         }else{
           date = this.getTimezoneSpecificDateObj(new Date());
         }
  
         let rangeEndDate = new Date(this.rangeEndMonthDate.setDate(this.rangeEndMonthDate.getDate() + 1))
         endDate = this.getTimezoneSpecificDateObj(rangeEndDate);
       }else{
         date = this.getTimezoneSpecificDateObj(new Date());
       } */

      if (this.rangeStartMonthChanged == true && this.rangeEndMonthChanged == true) {
        let rangeStartDate = new Date(this.rangeStartMonthDate.setDate(this.rangeStartMonthDate.getDate() + 1))
        date = this.getTimezoneSpecificDateObj(rangeStartDate);

        let rangeEndDate = new Date(this.rangeEndMonthDate.setDate(this.rangeEndMonthDate.getDate() + 1))
        endDate = this.getTimezoneSpecificDateObj(rangeEndDate);
      } else if (this.rangeStartMonthChanged == true) {
        let rangeStartDate = new Date(this.rangeStartMonthDate.setDate(this.rangeStartMonthDate.getDate() + 1))
        date = this.getTimezoneSpecificDateObj(rangeStartDate);
      } else if (this.rangeEndMonthChanged == true) {
        let rangeEndDate = new Date(this.rangeEndMonthDate.setDate(this.rangeEndMonthDate.getDate() + 1))
        endDate = this.getTimezoneSpecificDateObj(rangeEndDate);
      } else {
        date = this.getTimezoneSpecificDateObj(new Date());
      }
    }

    // -->
    // var date = this.getTimezoneSpecificDateObj(new Date());
    // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    if (this.selectedCalendarKey) {
      // this.getCalendarDates(firstDay.getTime(), lastDay.getTime() + 2*(30*24*60*60*1000), this.selectedCalendarKey);

      this.calendarDates = []
      this.serviceHolidays = []
      var month = moment().get('month') + 1
      var time = moment.utc(month,"MM-DD-YYYY").local().format("MM/DD/YYYY HH:mm:ss")
      var dateMonth = new Date(time)
      if (this.datePickerType == 'Range') {
        if (this.rangeEndMonthChanged == true) {
          this.getCalendarDates(dateMonth.valueOf(), this.selectedCalendarKey);
          setTimeout(() => {
            var endMonth = moment(endDate).get('month') + 1;
            var endTime = moment.utc(endMonth,"MM-DD-YYYY").local().format("MM/DD/YYYY HH:mm:ss")
            var dateMonthEnd = new Date(endTime)
            this.getCalendarDates(dateMonthEnd.valueOf(), this.selectedCalendarKey);
          }, 3000);
        } else {
          this.getCalendarDates(dateMonth.valueOf(), this.selectedCalendarKey);
        }
      } else {
        this.getCalendarDates(dateMonth.valueOf(), this.selectedCalendarKey);
      }
    }

    if (this.selectedInOutCalendarKey) {
      // this.getInOutTimings();
    }
    // -->

    this.showGroupAddOnServices = true
    this.showPrimaryServicesInView = false
    this.getGroupAddOnServices()

    setTimeout(() => {
      // check selectedReservationTypeID exsist
      if (this.selectedServiceMap.hasOwnProperty(this.selectedReservationTypeID))
        this.showPrimaryServices(this.selectedServiceMap[this.selectedReservationTypeID].addOn)
    }, 500);
  }

  getTimezoneSpecificDateObj(dateInMilliseconds) {
    const currentTime = new Date(dateInMilliseconds);
    const convertTime = moment(currentTime).format("YYYY-MM-DD HH:mm:ss");
    const convertTimeObject = new Date(convertTime.replace(/ /g, "T"));
    return convertTimeObject;
  }
  getHolidayDates() {
    this.appService.getCalendarHolidays_new(this.location.holidayCalendarKey).subscribe(
      res => {
        console.log("*******************----------")
        console.log(res);
        if (res['data'] && res['data']['content']) {
          var dates = res['data']['content'];
          for (var i = 0; i < dates.length; i++) {
            var startDate_ = moment(Number(dates[i].startDateTime)).startOf('day').valueOf();
            var endDate_ = moment(Number(dates[i].endDateTime)).endOf('day').valueOf();
            while (startDate_ <= endDate_) {
              let currentDate = moment(startDate_).format('YYYY-MM-DD')
              var startDate = this.getTimezoneSpecificDateObj(startDate_);
              dates[i].dateVal = currentDate;
              this.listOfHolidays.push(JSON.parse(JSON.stringify(dates[i])));
              startDate_ = moment(startDate_).add(1, 'days').valueOf();

            }
            if (dates[i].recurring) { 
              var startDateS = moment(Number(dates[i].startDateTime)).startOf('day').valueOf();
              let currentDate = moment(startDateS).format("MM-DD-YYYY")
              let sourceDate = moment(currentDate, 'MM-DD-YYYY').startOf('day');
              sourceDate.locale(false);
              let todayDate = moment(new Date());
              let noOfFutureYears = todayDate.diff(sourceDate, 'years');
              for (let year = 1; year <= noOfFutureYears + 4; year++) {
                var startDate_ = moment(Number(dates[i].startDateTime)).startOf('day').valueOf();
                var endDate_ = moment(Number(dates[i].endDateTime)).endOf('day').valueOf();
                startDate_ = moment(startDate_).add(year, 'years').valueOf();
                endDate_ = moment(endDate_).add(year, 'years').valueOf();
                while (startDate_ <= endDate_) {
                  let currentDate = moment(startDate_).format('YYYY-MM-DD');
                  var startDate = this.getTimezoneSpecificDateObj(startDate_);
                  dates[i].dateVal = currentDate;
                  this.listOfHolidays.push(JSON.parse(JSON.stringify(dates[i])));
                  startDate_ = moment(startDate_).add(1, 'days').valueOf();
                }
              }
            }
          }
        }
      });
  }

  serviceHolidays = [];
  getCalendarDates(startDate, key, endDate = null) {
    this.appService.getCalendarDates_new(startDate, key, this.locationTimezone, endDate).subscribe(
      res => {
        // this.serviceTimings = res["data"] ? res["data"]["schedule"] : [];
        var list = res["list"] ? res["list"] : [];

        this.serviceTimings = this.serviceTimings.concat(list);
        // var dates = []
        // this.serviceHolidays = [];
        for (var i = 0; i < list.length; i++) {
          if (list[i].showAs != "HOLIDAY") {
            this.calendarDates.push(moment(list[i].startDateTime).format("YYYY-MM-DD"));
          } else {
            var startDate_ = moment(Number(list[i].startDateTime)).startOf('day').valueOf();
            var endDate_ = moment(Number(list[i].endDateTime)).endOf('day').valueOf();
            while (startDate_ <= endDate_) {
              let currentDate = moment(startDate_).format('YYYY-MM-DD')
              var startDate = this.getTimezoneSpecificDateObj(startDate_);
              list[i].dateVal = currentDate;
              this.serviceHolidays.push(JSON.parse(JSON.stringify(list[i])));
              startDate_ = moment(startDate_).add(1, 'days').valueOf();
            }
            // var startDate = this.getTimezoneSpecificDateObj(list[i].startDateTime);
            // startDate.setHours(0, 0, 0, 0);
            // var endDate = this.getTimezoneSpecificDateObj(list[i].endDateTime);
            // endDate.setHours(23, 59, 59, 999);
            // if (this.holidaysList.findIndex(o => o.startDateTime == list[i].startDateTime) < 0) {
            //   // var event = new CalendarEvent(list[i].title, startDate, endDate, true, new Color(200, 0, 0, 0));
            //   holidays.push(event);
            //   var holidayEvent_ = JSON.parse(JSON.stringify(event));
            //   holidayEvent_["startDateTime"] = list[i].startDateTime;
            //   this.holidaysList.push(holidayEvent_);
            // }
          }

          if (list[i].peakDay == true) {
            var startDate_ = moment(Number(list[i].startDateTime)).startOf('day').valueOf();
            let currentDate = moment(startDate_).format('YYYY-MM-DD')
            let obj = { dateVal: currentDate }
            this.peakDays.push(obj)
          }
        }

        setTimeout(() => {
          if (this.calendar) {
            this.calendar.updateTodaysDate()
          }
          if (this.calendarOne) {
            this.calendarOne.updateTodaysDate()
          }
          if (this.calendarTwo) {
            this.calendarTwo.updateTodaysDate()
          }
        }, 0);

        let uniquePeakDays = [...new Map(this.peakDays.map(item => [item['dateVal'], item])).values()]
        this.peakDays = uniquePeakDays

        this.workingDates = this.calendarDates.concat(this.workingDates);
      },
      error => {
        console.log("error", error);
      }
    );
  }

  getInOutTimings() {
    this.appService.getInOutTimings(this.selectedLocation, this.selectedInOutCalendarKey).subscribe(
      res => {
        this.inOutList = res["data"] ? res["data"]["content"] : [];
      },
      error => {
        console.log("error", error);
      }
    );
  }

  onAssignPet($event, services, petIdx, assignedPet: MatSelect) {
    // let result = this.petServiceMap.find(({pet}) => pet && pet.id === $event.value['id']);
    let result = this.selectedPets.find((pet) => pet && pet.id === $event.value['id']);
    if (result) {
      services['pet'] = null;
      delete this.selectedPets[petIdx];
      assignedPet.value = null;
      Swal.fire(`This pet already assigned. Please choose another one!`);
    } else {
      var findPet = this.userPets.find((pet) => pet && pet.id === $event.value['id']);
      if(findPet && !this.hasAllMandatoryFields(findPet)){
        services['pet'] = null;
        delete this.selectedPets[petIdx];
        assignedPet.value = null;
        Swal.fire(`Please fill all mandatory fields for this pet!`);
        this.updatePetObj = findPet;
        this.pageShowType ='editPets'
        this.petNameCtrl.setValue(findPet.name);
        this.selectedPetGender = findPet.gender ? findPet.gender.id : undefined;
        this.selectedPetBread = findPet.breed ? findPet.breed.id : undefined;
        this.petWeight = findPet.weight;
        this.petColor = findPet.color;
      }
      else{
        services['pet'] = $event.value;
        this.selectedPets[petIdx] = services['pet'];
      }
    }
  }

  hasAllMandatoryFields(pet) {
    if (this.profileMap.size > 0) {
  
      if (this.profileMap.has('PET_COLOR_WEB') && !pet.color) {
        const hasMandatoryField = this.profileMap.get("PET_COLOR_WEB").some(item => {
          return item.type === "onCreateAppointment" && item.status;
        });
        if (hasMandatoryField) return false;
      }
  
      if (this.profileMap.has('PET_DOB_WEB') && !pet.dateOfBirth) {
        const hasMandatoryField = this.profileMap.get("PET_DOB_WEB").some(item => {
          return item.type === "onCreateAppointment" && item.status;
        });
        if (hasMandatoryField) return false;
      }
  
      if (this.profileMap.has('PET_SEX_WEB') && !pet.gender) {
        const hasMandatoryField = this.profileMap.get("PET_SEX_WEB").some(item => {
          return item.type === "onCreateAppointment" && item.status;
        });
        if (hasMandatoryField) return false;
      }
  
      if (this.profileMap.has('PET_WEIGHT_WEB') && !pet.weight) {
        const hasMandatoryField = this.profileMap.get("PET_WEIGHT_WEB").some(item => {
          return item.type === "onCreateAppointment" && item.status;
        });
        if (hasMandatoryField) return false;
      }
  
      if (this.profileMap.has('PET_VETERINARIAN_WEB') && !pet.veterinarian) {
        const hasMandatoryField = this.profileMap.get("PET_VETERINARIAN_WEB").some(item => {
          return item.type === "onCreateAppointment" && item.status;
        });
        if (hasMandatoryField) return false;
      }
    }
  
    return true;
  }

  updateTimeSlots() {
    this.timeSlots = [];
    console.log(this.selectedServiceID, this.selectedServiceBasedOn);
    if (this.selectedServiceID) {
      if (this.selectedServiceBasedOn == "LODGING_BASED") {
        const startDate = this.selectedServiceMap[this.selectedReservationTypeID]['startDate'];
        const endDate = this.selectedServiceMap[this.selectedReservationTypeID]['endDate'];
        this.onDateRangeChange([startDate, endDate]);
      } else {
        this.timeSlots = [];
        this.PickTimeSlots = [];

        const startDate = this.selectedServiceMap[this.selectedReservationTypeID]['startDate'];
        this.onSingleDateChange(startDate);
      }
    }
  }

  async updateAddOnServiceCheck($event, service) {
    service['dateList'] = JSON.parse(JSON.stringify(this.dateList));
    if($event && service.parentServiceBasedOn && service.parentCalendarKey && !service.parentAddOn){
      if (!this.checkBusinessHourForAddOn) {
        for (let i = 0; i < service.dateList.length; i++) {
          let startDateDiffMnt = moment.tz(service.dateList[i].value, 'ddd MMM DD, YYYY', this.locationTimezone);
          var startOfDay = startDateDiffMnt.startOf('day');
          let monthToCheck = startDateDiffMnt.format('MMMM');
          let monthValues;
          if (this.calendarObj[service.parentCalendarKey] && this.calendarObj[service.parentCalendarKey][monthToCheck]) {
            monthValues = this.calendarObj[service.parentCalendarKey][monthToCheck];
          } else {
            monthValues = [];
          }
          if(!this.calendarObj[service.parentCalendarKey]){
            this.calendarObj[service.parentCalendarKey] = {}
          }
          if (monthValues.length == 0) {
            await this.getDatesForPrimaryAddOn(startOfDay, service.parentCalendarKey, service);
            this.processDateList(service.dateList, i,service);
          } else {
            this.processDateList(service.dateList, i,service);
          }
        }
      }
      else{
          service.dateList.map(date => {
            date.isAvailable = true;
            date.checked = $event;
          })
      }
    }
    let isAllDateListAvailable = service.dateList.every(date => !date.isAvailable);
    if (isAllDateListAvailable && !service.selected) {
      service.selected = !service.selected;
      this.cdr.detectChanges();
      this.selectedServiceMap[this.selectedReservationTypeID]['addOn'].forEach(addOn => {
        if (addOn.id === service.id) {
          setTimeout(() => {
            addOn.selected = !service.selected;
            this.cdr.detectChanges();
          });
        }
      });
      Swal.fire("No available slots for this service");
      return;
    }
    this.selectedServiceMap[this.selectedReservationTypeID]['addOn'].forEach(addOn => {
      if (addOn.id === service.id) {
        addOn.selected = $event;
      }
    });

    this.updateGroupAddOnService(service)
  }

  processDateList(dateList: any[], index: number,service): void {
    let date = moment.tz(dateList[index].value, 'ddd MMM DD, YYYY', this.locationTimezone);
    let startDateDetail = moment(Number(date)).format("MM/DD/YYYY");
    let monthToCheck = moment(Number(date)).format('MMMM');
    let foundHoliday = false;
    var monthValues;
    if (this.calendarObj[service.parentCalendarKey] && this.calendarObj[service.parentCalendarKey][monthToCheck]) {
      monthValues = this.calendarObj[service.parentCalendarKey][monthToCheck];
    } else {
      monthValues = [];
    }
    for (let value of this.listOfHolidays) {
      let startDateDetailS= moment(date).format("YYYY-MM-DD");
      if (moment(value.dateVal).isSame(startDateDetailS)) {
        dateList[index].isAvailable = false;
        dateList[index].checked = false;
        dateList[index].holidayDetail = value;
        foundHoliday = true;
        break;
      }
    }
    if (!foundHoliday) {
      for (let value of monthValues) {
        let selectedStartDate = moment(value.startDateTime).format("MM/DD/YYYY");
        if (moment(selectedStartDate).isSame(startDateDetail)) {
          dateList[index].isAvailable = value.showAs !== 'HOLIDAY';
          dateList[index].checked = value.showAs !== 'HOLIDAY';
          if (value.showAs === 'HOLIDAY') {
            dateList[index].holidayDetail = value;
          }
          foundHoliday = true;
          break;
        }
      }
    }
  }
  

  dayTypeRadioChanged($event, service) {
    if(service.parentServiceBasedOn && service.parentCalendarKey && !service.parentAddOn){
      // set to the dates which has isAvailable property as true
      service.dateList.map(date => {
        if (date.isAvailable) {
          date.checked = $event.value;
        }
      });
    }
    else{
      service.dateList.map(date => date.checked = $event.value);
    }
  }

  addOnServiceDateCheckChange($event, service) {
    service.isEveryDay = false;
  }

  onSingleDateChange(value: Date): void {

    console.log(value);
    let month = Number(value.getMonth() + 1) > 9 ? Number(value.getMonth() + 1) : '0' + Number(value.getMonth() + 1);
    let day = value.getDate() > 9 ? value.getDate() : '0' + value.getDate();
    let year = value.getFullYear();
    let slashFormat = day + '/' + month + '/' + year;
    var timeZoneSpecificDate = moment(slashFormat, 'DD/MM/YYYY');
    console.log("timeZoneSpecificDate-->", timeZoneSpecificDate);
    let startDate =  moment(slashFormat, 'DD/MM/YYYY').startOf("day");
    let endDate =  moment(slashFormat, 'DD/MM/YYYY').endOf("day");
    if (this.selectedServiceBasedOn == 'CAPACITY_BASED') {
      if (this.listOfLodging && this.listOfLodging.length == 0) {
        Swal.fire("No Lodging available for this date");
      }
      else if(this.reservationTypesMap[this.selectedReservationTypeID].autoApproval){
        var participantParams = "participants=";
        for (let i = 0; i < this.listOfLodging.length; i++) {
          participantParams = participantParams + this.listOfLodging[i].id;
          if (i < this.listOfLodging.length - 1) {
            participantParams = participantParams + "&participants=";
          }
        }

        this.appService.getSlotsForDate_capacity(startDate, endDate, participantParams, this.selectedServiceID, this.selectedCalendarKey).subscribe(
          res => {
            // console.log(res);
            var events = res["data"]["event"];

            if (events && events.length == 0) {
              this.setSingleDateChange(value);
            }

            //initilizing hashmaps for lodges
            for (let j = 0; j < this.listOfLodging.length; j++) {
              var hashMap = {};
              const startDateString = startDate.valueOf();
              const endDateString = endDate.valueOf();
              for (let i =startDateString; i < endDateString; i = i + (1000 * 60 * 60 * 24)) {
                var date__ = moment(i.valueOf()).format('DD/MM/YYYY');
                hashMap[date__] = [];
              }
              this.listOfLodging[j]["haspMap"] = hashMap;
            }

            //arrange the events based on lodgeid and date
            for (let i = 0; i < events.length; i++) {
              for (let j = 0; j < events[i].participantVos.length; j++) {
                if (events[i].participantVos[j].resourceType == "LODGE") {
                  let index = this.listOfLodging.findIndex(o => o.id.toString() == events[i].participantVos[j].subject);
                  if (index > -1) {
                    var hashmap_ = this.listOfLodging[index]["haspMap"];
                    var __date = events[i]["startDate"];
                    __date = moment(__date).format("DD/MM/YYYY");
                    if (hashmap_[__date]) {
                      hashmap_[__date].push(events[i]);
                    }
                  }
                }
              }
            }
            let allSlotsOccupied = true;
            for (let j = 0; j < this.listOfLodging.length; j++) {
              const hashmap_ = this.listOfLodging[j]["haspMap"];
              const capacity = this.listOfLodging[j]["maxNumberOfPets"];
              if (Object.keys(hashmap_).length === 0) {
                allSlotsOccupied = false;
                break;
              }
              for (const key in hashmap_) {
                const eventList = hashmap_[key];
                if (eventList.length < capacity) {
                  allSlotsOccupied = false;
                  break;
                }
              }
              if (!allSlotsOccupied) {
                break;
              }
            }
            
            if (allSlotsOccupied) {
              Swal.fire("No Lodging available for this date");
              return;
            }
            else{
              this.setSingleDateChange(value);
            }

          },
          error => {
            console.log("error:", error);
          }
        );
      }
      else{
        this.setSingleDateChange(value);
      }
    }
    else{
      this.setSingleDateChange(value);
    }
    //if (this.listOfHolidays)
    
  }

  setSingleDateChange(value){
    if (this.selectedServiceID && value) {
      this.startDateObject = value;

      let dateObj = value;
      let month = Number(dateObj.getMonth() + 1) > 9 ? Number(dateObj.getMonth() + 1) : '0' + Number(dateObj.getMonth() + 1);
      let day = dateObj.getDate() > 9 ? dateObj.getDate() : '0' + dateObj.getDate();
      let year = dateObj.getFullYear();
      let slashFormat = day + '/' + month + '/' + year;
      var timeZoneSpecificDate = moment(slashFormat, 'DD/MM/YYYY').tz(this.locationTimezone);
      console.log("date from calendar-->", value);
      console.log("slash format-->", slashFormat);
      console.log("timeZoneSpecificDate-->", timeZoneSpecificDate);
      this.timeSlots = [];
      this.PickTimeSlots = [];

      this.rangeInSlots = [];
      this.rangeOutSlots = [];


      let dashFormat = year + '-' + month + '-' + day;
      var isHoliday = false;
      this.listOfStaffSlots = [];
      this.timeSlots = [];
      this.listOfHolidays.filter((x) => {
        if (x.dateVal === dashFormat) {
          isHoliday = true;
          Swal.fire(x.title + "\n" + x.description);
          return;
        }
      });
      this.serviceHolidays.filter((x) => {
        if (x.dateVal === dashFormat) {
          isHoliday = true;
          Swal.fire(x.title + "\n" + x.description);
          return;
        }
      });

      if(!isHoliday){
        this.reservationTypes.forEach(reservationType => {
          if (reservationType.id == this.selectedReservationTypeID) {
            if(reservationType.hideFromDevices && reservationType.hideStartDate && reservationType.hideEndDate){
              let currentDate = new Date(this.startDateObject);
              let hideStartDate = new Date(reservationType.hideStartDate);
              let hideEndDate = new Date(reservationType.hideEndDate);
              if ((hideStartDate <= currentDate) && (hideEndDate >= currentDate )) {
                 Swal.fire(`We are sorry, we may be closed between your selected dates \nStart Date:${hideStartDate.toDateString()}\nEnd Date:${hideEndDate.toDateString()}`);
                 isHoliday = true;
              } 
            }
          }
        });
      }

      if (!isHoliday) {
        // if (this.workingDates.findIndex(o => o == dashFormat) < 0 && !this.selectedServiceMap[this.selectedReservationTypeID].showStaff) {
        //   this.timeSlots = [];
        //   Swal.fire("This service is not available on this day.");
        //   return;
        // }
        var date_start = moment(slashFormat, 'DD/MM/YYYY').startOf('day');
        var date_end = moment(slashFormat, 'DD/MM/YYYY').endOf('day');

        this.selectedDateString = moment(value).format('DD/MM/YYYY');
        this.selectedStartDate = timeZoneSpecificDate;
        value = new Date(value.toDateString());
        this.capacityBasedSlotsData = [];
        this.selectedServiceMap[this.selectedReservationTypeID]['startDate'] = timeZoneSpecificDate;
        this.selectedServiceMap[this.selectedReservationTypeID]['endDate'] = timeZoneSpecificDate;

        const startTime = moment(timeZoneSpecificDate).startOf("day");
        const endTime = moment(timeZoneSpecificDate).endOf("day");
        this.getDateList(startTime, endTime);
        console.log(this.selectedServiceBasedOn);
        if (this.selectedServiceBasedOn == "STAFF_BASED") {
          if (this.selectedServiceMap[this.selectedReservationTypeID].showStaff || this.selectedServiceMap[this.selectedReservationTypeID].scheduleType == 'STAFF_BASED') {
            this.getSlotForEmpolyee(startTime.valueOf(), endTime.valueOf())
          } else {
            this.showTimeSlotNotAvailable = false
            this.getSlotsForDate(startTime.valueOf(), endTime.valueOf());
          }
        } else if (this.selectedServiceBasedOn == "CAPACITY_BASED") {
          // this.getTimeSlots();
          this.showTimeSlotNotAvailable = false
          this.selectedServiceMap[this.selectedReservationTypeID].showStaff = false;

          this.createSlotsForLodging(timeZoneSpecificDate.format("YYYY-MM-DD"), 'in');
          // this.createSlotsForLodging(timeZoneSpecificDate.valueOf(), 'out');

          // if(this.reservationTypesMap[this.selectedReservationTypeID].autoApproval) {
          //   this.getSlotsForDateCapacity(date_start.valueOf(),date_end.valueOf());
          // }


          if (this.selectedTime && this.reservationTypesMap[this.selectedReservationTypeID].autoApproval)
            this.getSlotsForCapacity(startTime.valueOf(), endTime.valueOf());
        }
      }
    }
  }
  dateClass() {
    return (date: Date): MatCalendarCellCssClasses => {
      let dateObj = date;
      let month = Number(dateObj.getMonth() + 1) > 9 ? Number(dateObj.getMonth() + 1) : '0' + Number(dateObj.getMonth() + 1);
      let day = dateObj.getDate() > 9 ? dateObj.getDate() : '0' + dateObj.getDate();
      let year = dateObj.getFullYear();
      let dashFormat = year + '-' + month + '-' + day;

      const highlightDate = this.listOfHolidays.map(dt => (dt.dateVal)).some(d => d === dashFormat);
      if (highlightDate) {
        return highlightDate ? 'special-date' : '';
      }

      const highlightDate1 = this.serviceHolidays.map(dt => (dt.dateVal)).some(d => d === dashFormat);
      if (highlightDate1) {
        return highlightDate1 ? 'special-date' : '';
      }

      let peakDay = this.peakDays.map(dt => (dt.dateVal)).some(d => d === dashFormat);
      if (peakDay) {
        return peakDay ? 'peak-date' : '';
      }
    };
  }
  onStartDateChange(value: Date): void {
    // value = value && new Date(value.toDateString());

    if (!value) {
      return;
    } else if (this.selectedServiceMap.length <= 0) {
      Swal.fire('Please select a service type in order to move forward');
      return;
    }

    this.startDateObject = value;
    this.minEndDate = value;
    let dateObj = value;
    let month = Number(dateObj.getMonth() + 1) > 9 ? Number(dateObj.getMonth() + 1) : '0' + Number(dateObj.getMonth() + 1);
    let day = dateObj.getDate() > 9 ? dateObj.getDate() : '0' + dateObj.getDate();
    let year = dateObj.getFullYear();
    let slashFormat = day + '/' + month + '/' + year;
    var timeZoneSpecificDate = moment(slashFormat, 'DD/MM/YYYY').tz(this.locationTimezone);
    // console.log("date from calendar-->", value);
    // console.log("slash format-->", slashFormat);
    // console.log("timeZoneSpecificDate-->", timeZoneSpecificDate);

    let dashFormat = year + '-' + month + '-' + day;
    var isHoliday = false;
    this.timeSlots = [];
    this.PickTimeSlots = [];

    this.rangeInSlots = [];
    this.listOfHolidays.filter((x) => {
      if (x.dateVal === dashFormat) {
        isHoliday = true;
        Swal.fire(x.title + "\n" + x.description);
        return;
      }
    });
    this.serviceHolidays.filter((x) => {
      if (x.dateVal === dashFormat) {
        isHoliday = true;
        Swal.fire(x.title + "\n" + x.description);
        return;
      }
    });
    if(!isHoliday){
      this.reservationTypes.forEach(reservationType => {
        if (reservationType.id == this.selectedReservationTypeID) {
          if(reservationType.hideFromDevices && reservationType.hideStartDate && reservationType.hideEndDate){
            console.log(this.startDateObject)
            let currentDate = new Date(this.startDateObject);
            let hideStartDate = new Date(reservationType.hideStartDate);
            let hideEndDate = new Date(reservationType.hideEndDate);
            if ((hideStartDate <= currentDate) && (hideEndDate >= currentDate )) {
               Swal.fire(`We are sorry, we may be closed between your selected dates \nStart Date:${hideStartDate.toDateString()}\nEnd Date:${hideEndDate.toDateString()}`);
               isHoliday = true;
            } 
          }
        }
      });
    }

    if (!isHoliday) {
      // if (this.workingDates.findIndex(o => o == dashFormat) < 0) {
      //   this.rangeInSlots = [];
      //   Swal.fire("This service is not available on this day.");
      //   return;
      // }
      this.selectedStartDate = timeZoneSpecificDate;
      this.calendar2.activeDate = this.minEndDate;
      this.endMonthObject = this.minEndDate;


      this.timeSlots = [];
      this.PickTimeSlots = [];

      this.rangeInSlots = [];

      // -->

      this.createSlotsForLodging(moment(timeZoneSpecificDate).format("YYYY-MM-DD"), "in");

      if (this.selectedStartDate && this.selectedEndDate) {
        if (this.selectedStartDate.valueOf() < this.selectedEndDate.valueOf()) {
          if (this.selectedServiceID) {
            this.selectedServiceMap[this.selectedReservationTypeID]['startDate'] = this.selectedStartDate;
            this.selectedServiceMap[this.selectedReservationTypeID]['endDate'] = this.selectedEndDate;
            // this.capacityBasedSlotsData = [];
            this.getDateList(this.selectedStartDate, this.selectedEndDate);
            // this.getSlotsForCapacity();
          }
        } else {
          Swal.fire('End date should be greater than start date!');
        }
      }
    }
    if (this.selectedServiceMap[this.selectedReservationTypeID].addOn.length > 0) {
      for (var i = 0; i < this.selectedServiceMap[this.selectedReservationTypeID].addOn.length; i++) {
        if (this.selectedServiceMap[this.selectedReservationTypeID].addOn[i].selected == true && this.dateList.length > 0) {
          this.selectedServiceMap[this.selectedReservationTypeID].addOn[i]['dateList'] = JSON.parse(JSON.stringify(this.dateList));
        }
      }
    }
    return;
  }

  onEndDateChange(value: Date): void {
    // value = value && new Date(value.toDateString());

    if (!value) {
      return;
    }
    this.endDateObject = value;
    var isHoliday = false;
    this.timeSlots = [];
    this.PickTimeSlots = [];

    if(this.minNumberOfStay){
      let startDate = new Date(this.startDateObject);
      let endDate = new Date(this.endDateObject);
      let diffTime = endDate.getTime() - startDate.getTime();
      let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      if ((diffDays + 1) < this.minNumberOfStay) {
        Swal.fire(`Minimum number of stay should be ${this.minNumberOfStay} days.`);
        this.endDateObject = ""; 
        this.selectedEndDate = undefined;
        this.selectedServiceMap[this.selectedReservationTypeID]['endDate'] = undefined;
        return;
      }
    }

    if(!this.allowHolidayBookingRange){
      let currentDate = new Date(this.startDateObject); 
      while (currentDate <= this.endDateObject) {
        let month = Number(currentDate.getMonth() + 1) > 9 ? Number(currentDate.getMonth() + 1) : '0' + Number(currentDate.getMonth() + 1);
        let day = currentDate.getDate() > 9 ? currentDate.getDate() : '0' + currentDate.getDate();
        let year = currentDate.getFullYear();
        let dashFormatS = year + '-' + month + '-' + day;
        const highlightDate = this.listOfHolidays.map(dt => (dt.dateVal)).some(d => d === dashFormatS);
        const highlightDate1 = this.serviceHolidays.map(dt => (dt.dateVal)).some(d => d === dashFormatS);
        if (highlightDate || highlightDate1) {
          isHoliday = true
          Swal.fire('We are sorry, we may be closed between your selected dates');
          this.endDateObject = " ";
          this.selectedEndDate = undefined;
          this.selectedServiceMap[this.selectedReservationTypeID]['endDate'] = undefined;
          break;
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
    }

    if(!isHoliday){
      this.reservationTypes.forEach(reservationType => {
        if (reservationType.id == this.selectedReservationTypeID) {
          if(reservationType.hideFromDevices && reservationType.hideStartDate && reservationType.hideEndDate){
            let currentDate = new Date(this.startDateObject);
            let endDate = new Date(this.endDateObject);
            let hideStartDate = new Date(reservationType.hideStartDate);
            let hideEndDate = new Date(reservationType.hideEndDate);
            if ((hideStartDate >= currentDate && hideStartDate <= endDate) || (hideEndDate >= currentDate && hideEndDate <= endDate)) {
               Swal.fire(`We are sorry, we may be closed between your selected dates \nStart Date:${hideStartDate.toDateString()}\nEnd Date:${hideEndDate.toDateString()}`);
               isHoliday = true;
            } 
          }
        }
      });
    }
 
    let dateObj = value;
    let month = Number(dateObj.getMonth() + 1) > 9 ? Number(dateObj.getMonth() + 1) : '0' + Number(dateObj.getMonth() + 1);
    let day = dateObj.getDate() > 9 ? dateObj.getDate() : '0' + dateObj.getDate();
    let year = dateObj.getFullYear();
    let slashFormat = day + '/' + month + '/' + year;
    var timeZoneSpecificDate = moment(slashFormat, 'DD/MM/YYYY').tz(this.locationTimezone);
    console.log("timeZoneSpecificDate-->", timeZoneSpecificDate);

    let dashFormat = year + '-' + month + '-' + day;
   
    this.rangeOutSlots = [];
    this.listOfHolidays.filter((x) => {
      if (x.dateVal === dashFormat) {
        isHoliday = true;
        Swal.fire(x.title + "\n" + x.description);
        return;
      }
    });
    this.serviceHolidays.filter((x) => {
      if (x.dateVal === dashFormat) {
        isHoliday = true;
        Swal.fire(x.title + "\n" + x.description);
        return;
      }
    });
    if (!isHoliday) {
      // if (this.workingDates.findIndex(o => o == dashFormat) < 0) {
      //   this.rangeOutSlots = [];
      //   Swal.fire("This service is not available on this day.");
      //   return;
      // }
      this.selectedEndDate = timeZoneSpecificDate;
      // -->


      this.timeSlots = [];
      this.PickTimeSlots = [];

      this.rangeOutSlots = [];


      var date_e = timeZoneSpecificDate.endOf('day');
      this.createSlotsForLodging(moment(date_e).format("YYYY-MM-DD"), "out");

      if (this.selectedStartDate && this.selectedEndDate) {
        if (this.selectedStartDate.valueOf() < this.selectedEndDate.valueOf()) {
          if (this.selectedServiceID) {
            this.selectedServiceMap[this.selectedReservationTypeID]['startDate'] = this.selectedStartDate;
            this.selectedServiceMap[this.selectedReservationTypeID]['endDate'] = this.selectedEndDate;
            // this.capacityBasedSlotsData = [];
            this.getDateList(this.selectedStartDate, this.selectedEndDate);
            // this.getSlotsForCapacity();
          }
        } else {
          Swal.fire('End date should be greater than start date!');
        }
      }
      if (this.selectedServiceMap[this.selectedReservationTypeID].addOn.length > 0) {
        for (var i = 0; i < this.selectedServiceMap[this.selectedReservationTypeID].addOn.length; i++) {
          if (this.selectedServiceMap[this.selectedReservationTypeID].addOn[i].selected == true && this.dateList.length > 0) {
            this.selectedServiceMap[this.selectedReservationTypeID].addOn[i]['dateList'] = JSON.parse(JSON.stringify(this.dateList));
          }
        }
      }
      return;
    }

  }

  onMonthChange(value, isEnd = false) {
    if (isEnd) {
      this.endMonthObject = value;
    } else {
      this.startMonthObject = value;
    }
    console.log(value);

    if (this.datePickerType == 'Single') {
      this.singleMonthDate = value
      this.singleMonthChanged = true
    }

    let dateObj = value;
    let month = Number(dateObj.getMonth() + 1) > 9 ? Number(dateObj.getMonth() + 1) : '0' + Number(dateObj.getMonth() + 1);
    let day = dateObj.getDate() > 9 ? dateObj.getDate() : '0' + dateObj.getDate();
    let year = dateObj.getFullYear();
    let slashFormat = day + '/' + month + '/' + year;
    var timeZoneSpecificDate = moment.utc(slashFormat, 'DD/MM/YYYY');

    setTimeout(() => {
      if (this.calendar) {
        this.calendar.updateTodaysDate()
      }
      if (this.calendarOne) {
        this.calendarOne.updateTodaysDate()
      }
      if (this.calendarTwo) {
        this.calendarTwo.updateTodaysDate()
      }
    }, 0);
    // console.log("slash format-->", slashFormat);
    // console.log("timeZoneSpecificDate-->", timeZoneSpecificDate);

    if (this.selectedCalendarKey) {
      this.getCalendarDates(timeZoneSpecificDate.valueOf(), this.selectedCalendarKey);
    }

  }

  // -->
  createSlotsForLodging(date, type) {


    console.log(date);
    let slashFormat = date;

    let weekDay = moment(date).day() + 1;



    console.log("this.inOutList.length", this.inOutList.length);
    console.log("this.serviceTimings.length", this.serviceTimings.length);

    var onlyShowInSlots = false;
    if ((this.reservationTypesMap[this.selectedReservationTypeID].serviceBasedOn == "STAFF_BASED" && !this.reservationTypesMap[this.selectedReservationTypeID].autoApproval) || this.reservationTypesMap[this.selectedReservationTypeID].serviceBasedOn == "CAPACITY_BASED") {
      onlyShowInSlots = true;
    }

    var foundInOutSlots = false;
    for (let i = 0; i < this.inOutList.length; i++) {
      if (this.inOutList[i].frequency == weekDay) {
        console.log("got freq");
        foundInOutSlots = true;
        var searchString = type == 'in' ? 'checkIn' : 'checkOut';
        if (this.inOutList[i].title.search(searchString) != -1) {
          this.generateSlots(this.inOutList[i].startDateTime, this.inOutList[i].endDateTime, type, false, null);
          console.log("generating slots for lodging from inoutlist", type);
        }
      }
    }

    var foundServiceSlots = false;
    console.log("slash", slashFormat);
    console.log("serviceTimings", this.serviceTimings);
    if (!foundInOutSlots && ((type == 'in' && onlyShowInSlots) || (!onlyShowInSlots))) {
      console.log("in-out not found checking in service timings");
      this.showTimeSlotNotAvailable = true;
      for (let i = 0; i < this.serviceTimings.length; i++) {
        // console.log("***start")
        // console.log(moment(this.serviceTimings[i].startDate).format("YYYY-MM-DD"));
        // console.log("slashFormat",slashFormat)
        if (moment(this.serviceTimings[i].startDateTime).format("YYYY-MM-DD") == slashFormat) {
          foundServiceSlots = true;

          if (type == 'in') {

            if (this.serviceTimings[i].type == "DROP_OFF") {
              this.generateSlots(this.serviceTimings[i].startDateTime, this.serviceTimings[i].endDateTime, 'in', true, null);
            } else if ((!this.serviceTimings[i].hasOwnProperty('type') || this.serviceTimings[i].type == "PICK_UP_DROP_OFF") && this.datePickerType != 'Single') {
              this.generateSlots(this.serviceTimings[i].startDateTime, this.serviceTimings[i].endDateTime, 'both', true, 'in');
            }

            if (this.datePickerType == 'Single') {
              if (this.serviceTimings[i].type == "PICK_UP") {
                this.generateSlots(this.serviceTimings[i].startDateTime, this.serviceTimings[i].endDateTime, 'out', true, null);
              } else if (!this.serviceTimings[i].hasOwnProperty('type') || this.serviceTimings[i].type == "PICK_UP_DROP_OFF") {
                this.generateSlots(this.serviceTimings[i].startDateTime, this.serviceTimings[i].endDateTime, 'both', true, null);
              }
            }


          } else {
            if (this.serviceTimings[i].type == "PICK_UP") {
              this.generateSlots(this.serviceTimings[i].startDateTime, this.serviceTimings[i].endDateTime, 'out', true, null);
            } else if (!this.serviceTimings[i].hasOwnProperty('type') || this.serviceTimings[i].type == "PICK_UP_DROP_OFF") {
              this.generateSlots(this.serviceTimings[i].startDateTime, this.serviceTimings[i].endDateTime, 'both', true, 'out');
            }
          }

          console.log("generating slots for lodging from servicetimings", type);
        }
      }
    }

    if (!foundInOutSlots && !foundServiceSlots && !onlyShowInSlots) {
      this.rangeInSlots = [];
      this.rangeOutSlots = [];
      Swal.fire("Check" + type + " for this service is not available on selected date");
    }
  }
  refreshTimeSlots() {
    this.startDateObject = null;
    this.PickTimeSlots = [];
    this.timeSlots = [];
    this.rangeOutSlots = [];
    this.rangeInSlots = [];
  }
  PickTimeSlots = [];

  generateSlots(start, end, type, isServiceTimings = false, reduce) {
    var list = [];
    for (let i = start; i <= end; i = i + (30 * 60 * 1000)) {
      var m = moment(i);
      var slotObj = {
        name: i,
        lable_: new Date(i).getHours() + ":" + (new Date(i).getMinutes() == 0 ? '00' : new Date(i).getMinutes()),
        lableAMPM: this.formatAMPM(i),
        // timezone_date : this.getDatetoLocalTimeZone(moment(i)),
        moment: moment(i),
        // timezone_label : this.getDatetoLocalTimeZone(moment(i)).getHours()+":"+(this.getDatetoLocalTimeZone(moment(i)).getMinutes() == 0 ? '00' : this.getDatetoLocalTimeZone(moment(i)).getMinutes()),
        lable: m.format("hh") + ":" + m.format("mm A"),
        selected: false,
        isServiceTimings: isServiceTimings
      }
      // console.log("label",slotObj.lable);
      list.push(slotObj);


      if (type == "in") {
        let index = this.rangeInSlots.findIndex(o => o.lable == slotObj.lable);
        if (index == -1) {
          this.rangeInSlots.push(slotObj);
        }
        let index_ = this.timeSlots.findIndex(o => o.lable == slotObj.lable); // drop
        if (index_ == -1) {
          this.timeSlots.push(slotObj);
        }

      } else if (type == "out") {

        let index = this.rangeOutSlots.findIndex(o => o.lable == slotObj.lable);
        if (index == -1) {
          this.rangeOutSlots.push(slotObj);
        }

        let index_ = this.PickTimeSlots.findIndex(o => o.lable == slotObj.lable); // pick
        if (index_ == -1) {
          this.PickTimeSlots.push(slotObj);
          console.log(this.PickTimeSlots, "$dropTime");

        }
      } else if (type == 'both') {
        // pick_drop
        let index = this.rangeInSlots.findIndex(o => o.lable == slotObj.lable);

        if (index == -1 && reduce == 'in') {
          this.rangeInSlots.push(slotObj);
        }

        let index_ = this.timeSlots.findIndex(o => o.lable == slotObj.lable);
        if (index_ == -1) {
          this.timeSlots.push(slotObj);
        }

        let indexRange = this.rangeOutSlots.findIndex(o => o.lable == slotObj.lable);
        if (indexRange == -1 && reduce == 'out') {
          this.rangeOutSlots.push(slotObj);
        }

        // let indexDrop = this.PickTimeSlots.findIndex(o => o.lable == slotObj.lable);
        // if (indexDrop == -1) {
        //   this.PickTimeSlots.push(slotObj);
        // }

      }
    }
    console.log(start);
    console.log(end);
    console.log(this.timeSlots);
    if (this.timeSlots.length > 1) {
      this.timeSlots.sort(function (a, b) {
        return Date.parse('1970/01/01 ' + a.lable.slice(0, -2) + ' ' + a.lable.slice(-2)) - Date.parse('1970/01/01 ' + b.lable.slice(0, -2) + ' ' + b.lable.slice(-2))
      });
    }
    if (this.rangeOutSlots.length > 1) {
      this.rangeOutSlots.sort(function (a, b) {
        return Date.parse('1970/01/01 ' + a.lable.slice(0, -2) + ' ' + a.lable.slice(-2)) - Date.parse('1970/01/01 ' + b.lable.slice(0, -2) + ' ' + b.lable.slice(-2))
      });
    }
    if (this.rangeInSlots.length > 1) {
      this.rangeInSlots.sort(function (a, b) {
        return Date.parse('1970/01/01 ' + a.lable.slice(0, -2) + ' ' + a.lable.slice(-2)) - Date.parse('1970/01/01 ' + b.lable.slice(0, -2) + ' ' + b.lable.slice(-2))
      });
    }

    if(this.timeSlots.length == 0){
      this.showTimeSlotNotAvailable = true
    }
    else{
      this.showTimeSlotNotAvailable = false
    }

  }
  // -->

  onDateRangeChange(value: Date[]): void {
    if (this.selectedServiceID && value[0] && value[1]) {

      let dateObj = value[0];
      if (dateObj) {
        let month = Number(dateObj.getMonth() + 1) > 9 ? Number(dateObj.getMonth() + 1) : '0' + Number(dateObj.getMonth() + 1);
        let day = dateObj.getDate() > 9 ? dateObj.getDate() : '0' + dateObj.getDate();
        let year = dateObj.getFullYear();
        let slashFormat = day + '/' + month + '/' + year;
        var timeZoneSpecificDate = moment(slashFormat, 'DD/MM/YYYY');
        console.log("timeZoneSpecificDate-->", timeZoneSpecificDate);

        let dashFormat = year + '-' + month + '-' + day;
        if (this.workingDates.findIndex(o => o == dashFormat) < 0) {
          this.rangeInSlots = [];
          Swal.fire("This service is not available on this day.");
          return;
        }
        this.selectedStartDate = timeZoneSpecificDate;
      }

      let dateObj_ = value[1];
      if (dateObj_) {
        let month_ = Number(dateObj_.getMonth() + 1) > 9 ? Number(dateObj_.getMonth() + 1) : '0' + Number(dateObj_.getMonth() + 1);
        let day_ = dateObj_.getDate() > 9 ? dateObj_.getDate() : '0' + dateObj_.getDate();
        let year_ = dateObj_.getFullYear();
        let slashFormat_ = day_ + '/' + month_ + '/' + year_;
        var timeZoneSpecificDate_ = moment(slashFormat_, 'DD/MM/YYYY');
        console.log("timeZoneSpecificDate-->", timeZoneSpecificDate_);

        let dashFormat_ = year_ + '-' + month_ + '-' + day_;
        if (this.workingDates.findIndex(o => o == dashFormat_) < 0) {
          this.rangeOutSlots = [];
          Swal.fire("This service is not available on this day.");
          return;
        }
        this.selectedEndDate = timeZoneSpecificDate_;
        if (this.selectedServiceMap[this.selectedReservationTypeID].addOn.length > 0) {
          for (var i = 0; i < this.selectedServiceMap[this.selectedReservationTypeID].addOn.length; i++) {
            if (this.selectedServiceMap[this.selectedReservationTypeID].addOn[i].selected == true && this.dateList.length > 0) {
              this.selectedServiceMap[this.selectedReservationTypeID].addOn[i]['dateList'] = JSON.parse(JSON.stringify(this.dateList));
            }
          }
        }
      }

      if (dateObj && dateObj_) {
        value[0] = new Date(value[0].toDateString());
        value[1] = new Date(value[1].toDateString());
        this.capacityBasedSlotsData = [];
        this.selectedServiceMap[this.selectedReservationTypeID]['startDate'] = this.selectedStartDate;
        this.selectedServiceMap[this.selectedReservationTypeID]['endDate'] = this.selectedEndDate;
        // this.getSlotsForDate(this.selectedStartDate.getTime(), this.selectedEndDate.getTime());
        this.getDateList(this.selectedStartDate, this.selectedEndDate);
        if(this.reservationTypesMap[this.selectedReservationTypeID].autoApproval){
          this.getSlotsForCapacity();
        }
        // this.reservationTypesMap[this.selectedReservationTypeID].services.forEach(service => {
        //   service.selected = false;
        // });
        this.getTimeSlots();
      }
    }
  }
  selectedDropTime = null;

  DropTimeSlot(event) {
    console.log()
    this.selectedDropTime = event.value;

    this.selectedServiceMap[this.selectedReservationTypeID]['timeSlot_end'] = event.value;

    console.log(this.selectedServiceMap);
    this.validateAccordian();
    if(this.reservationTypesMap[this.selectedReservationTypeID].autoApproval){
      this.getSlotsForCapacity();
    }
  }
  validateAccordian() {
    this.value = false;
    for (const service of this.selectedServiceMap) {
      if (service && service.basedOn === "LODGING_BASED") {
        if (!service.hasOwnProperty("startTime") || !service.hasOwnProperty("endTime")) {
          this.value = true;
          break; // Exit the loop when a condition is met
        }
      } else if (service && service.basedOn === "CAPACITY_BASED") {
        if (service && !service.hasOwnProperty("timeSlot") || !service.hasOwnProperty("timeSlot_end")) {
          this.value = true;
          break; // Exit the loop when a condition is met
        }
      }
    }
  }
  timeSlotChanged($event) {
    this.selectedTime = $event.value;

    this.selectedServiceMap[this.selectedReservationTypeID]['timeSlot'] = $event.value;

    if (this.selectedServiceBasedOn == "CAPACITY_BASED" && this.PickTimeSlots.length <= 0) {
      this.selectedServiceMap[this.selectedReservationTypeID]['hasEndTime'] = false;
      this.selectedServiceMap[this.selectedReservationTypeID]['timeSlot_end'] = this.timeSlots[this.timeSlots.length - 1];
    }
    else{
      this.selectedServiceMap[this.selectedReservationTypeID]['hasEndTime'] = true;
    }
    console.log(this.selectedServiceMap);
    if ((this.selectedServiceBasedOn == "CAPACITY_BASED" || this.selectedServiceBasedOn == "LODGING_BASED") && this.reservationTypesMap[this.selectedReservationTypeID].autoApproval) {
      this.getSlotsForCapacity();
    }
  }

  startTimeSlotChanged($event) {
    this.selectedStartTime = $event.value;
    this.selectedServiceMap[this.selectedReservationTypeID]['startTime'] = $event.value;
    if(this.reservationTypesMap[this.selectedReservationTypeID].autoApproval){
      this.getSlotsForCapacity();
    }
    if (this.selectedServiceMap[this.selectedReservationTypeID].addOn.length > 0) {
      for (var i = 0; i < this.selectedServiceMap[this.selectedReservationTypeID].addOn.length; i++) {
        if (this.selectedServiceMap[this.selectedReservationTypeID].addOn[i].selected == true && this.dateList.length > 0) {
          this.selectedServiceMap[this.selectedReservationTypeID].addOn[i]['dateList'] = JSON.parse(JSON.stringify(this.dateList));
        }
      }
    }
  }

  endTimeSlotChanged($event) {
    this.selectedEndTime = $event.value;
    this.selectedServiceMap[this.selectedReservationTypeID]['endTime'] = $event.value;
    if (this.reservationTypesMap[this.selectedReservationTypeID].autoApproval) {
      this.getSlotsForCapacity();
    }
    if (this.selectedServiceMap[this.selectedReservationTypeID].addOn.length > 0) {
      for (var i = 0; i < this.selectedServiceMap[this.selectedReservationTypeID].addOn.length; i++) {
        if (this.selectedServiceMap[this.selectedReservationTypeID].addOn[i].selected == true && this.dateList.length > 0) {
          this.selectedServiceMap[this.selectedReservationTypeID].addOn[i]['dateList'] = JSON.parse(JSON.stringify(this.dateList));
        }
      }
    }
  }

  areaChanged($event) {
    this.selectedArea = $event.value;
    this.selectedServiceMap[this.selectedReservationTypeID]['areaSlot'] = $event.value;
    console.log(this.selectedServiceMap);
  }

  onNameChange($event, nameCtrl: FormControl) {
    const name = nameCtrl.value;
    if (name) nameCtrl.setValue(name.charAt(0).toUpperCase() + name.slice(1));
  }

  onclickClose($event) {
    window.parent.postMessage({
      'action': "CloseAppoModal"
    }, "*");
  }


  getTimeSlots() {
    var start = this.selectedStartDate;
    var end = this.selectedEndDate;
    var list = [];
    this.timeSlots = [];

    this.PickTimeSlots = [];

    for (let i = start; i <= end; i = i + (90 * 60 * 1000)) {
      var m = moment(i);

      console.log(m)
      var slotObj = {
        name: i,
        lable_: new Date(i).getHours() + ":" + (new Date(i).getMinutes() == 0 ? '00' : new Date(i).getMinutes()),
        lableAMPM: this.formatAMPM(i),
        // timezone_date : this.getDatetoLocalTimeZone(moment(i)),
        moment: moment(i),
        // timezone_label : this.getDatetoLocalTimeZone(moment(i)).getHours()+":"+(this.getDatetoLocalTimeZone(moment(i)).getMinutes() == 0 ? '00' : this.getDatetoLocalTimeZone(moment(i)).getMinutes()),
        lable: m.format("hh") + ":" + m.format("mm A"),
        selected: false,
      }
      // console.log("label",slotObj.lable);
      let index = this.timeSlots.findIndex(o => o.lable == slotObj.lable);
      if (index == -1) {
        this.timeSlots.push(slotObj);
      }

      // list.push(slotObj);
    }
    console.log(start);
    console.log(end);
    console.log(this.timeSlots);
    // this.timeSlots = this.timeSlots.concat(list);
  }

  formatAMPM(date) {
    date = new Date(date);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }
  // -->

  getSlotsForDate(startDate, endDate) {
    let timeSlots = [];
    this.PickTimeSlots = [];

    this.appService.getSlotsForDate(startDate, endDate, this.selectedLocation, this.selectedServiceID).subscribe(
      res => {
        this.staffBasedSlots = res["list"];
        console.log(this.selectedServiceMap[this.selectedReservationTypeID])
        this.staffBasedSlots.forEach(slot => {
          if (this.selectedTime && this.selectedTime['name'] == slot['name']) {
            this.selectedTime = slot;
          }
          if (slot.employees && slot.employees.length >= 1) {
            slot["lable"] = slot.name; 
            timeSlots.push(slot);
          }
        });
        this.timeSlots = timeSlots;

        if(this.timeSlots.length == 0){
          this.showTimeSlotNotAvailable = true
        }
        else{
          this.showTimeSlotNotAvailable = false
        }
        console.log(this.timeSlots);
      },
      error => {
        console.log("error", error);
      }
    );
  }

  getSlotsForCapacity(startDate = null, endDate = null) {
    this.validateAccordian();
    const current = new Date();
    var serviceStartDate;
    var serviceEndDate;
    if (this.selectedServiceBasedOn == "CAPACITY_BASED") {
      serviceStartDate = moment(this.selectedStartDate).startOf("day").valueOf();
      serviceEndDate = moment(this.selectedStartDate).endOf("day").valueOf();
    }
    else if (this.selectedServiceBasedOn == "LODGING_BASED") {
      serviceStartDate = moment(this.selectedStartDate).startOf("day").valueOf();
      serviceEndDate = moment(this.selectedEndDate).endOf("day").valueOf();
    }
    console.log("**************  Getting Slots For Capacity  **************");
    this.isLoading = true;
    this.appService.getSlotsForDateCapacity(this.selectedLocation, this.selectedServiceID).subscribe(
      res => {
        this.isLoading = false;
        this.capacityBasedSlotsData = [];
        for (var i = 0; i < res["list"].length; i++) {
          var tmpAttr = JSON.parse(res["list"][i].attributes);
          if (tmpAttr.status) {
            if ((tmpAttr.status == "active" || tmpAttr.status == "Active" || tmpAttr.status == "ACTIVE") && (!tmpAttr.isInternal || tmpAttr.isInternal == "false" || tmpAttr.isInternal == false)) { 
              tmpAttr.isInActive = false;
              if (tmpAttr.hideStart && tmpAttr.hideUnit) {
                let startDate = moment(parseInt(tmpAttr.hideStart));
                var endDate;
                if (tmpAttr.hideEnd) {
                  endDate = moment(parseInt(tmpAttr.hideEnd));
                }
                if (startDate.isSameOrBefore(serviceEndDate) && (!endDate || (endDate.isSameOrAfter(serviceStartDate)))) {
                  tmpAttr.isInActive = true;
                }
              }
              if(!tmpAttr.isInActive){
                this.capacityBasedSlotsData.push(res["list"][i]);
              }
            }
          }
        }

        if (!this.capacityBasedSlotsData || this.capacityBasedSlotsData.length == 0) {
          this.isLoading = false;
          delete this.selectedServiceMap[this.selectedReservationTypeID].timeSlot;
          delete this.selectedServiceMap[this.selectedReservationTypeID].timeSlot_end;
          delete this.selectedServiceMap[this.selectedReservationTypeID].areaSlot;
          delete this.selectedServiceMap[this.selectedReservationTypeID].startDate;
          delete this.selectedServiceMap[this.selectedReservationTypeID].endDate;
          // delete this.selectedServiceMap[this.selectedReservationTypeID];
          // this.selectedServiceID = undefined;
          // this.selectedAddOnServices = [];
          this.validateAccordian();
          Swal.fire("Currently this service is not available, go back and select different service");
          return;
        }

        this.selectedServiceMap[this.selectedReservationTypeID]['areaSlot'] = this.capacityBasedSlotsData[0];

        this.capacityBasedSlotsData.forEach(slot => {
          if (this.selectedArea && this.selectedArea['id'] == slot['id']) {
            this.selectedArea = slot;
          }
        });


        if (this.selectedServiceBasedOn == "CAPACITY_BASED" || this.selectedServiceBasedOn == "LODGING_BASED") {
          this.getSlotsForDateCapacity(serviceStartDate, serviceEndDate);
        }
      },
      error => {
        this.isLoading = false;
        console.log("error", error);
      }
    );
  }
  getSlotForEmpolyee(startDate, EndDate,) {
    this.showNoSlotAvailable = false;
    console.log("**************  Getting Show Empolyee  **************");
    this.showPageContentLoader()
    this.appService.getSlotsForDate(startDate, EndDate, this.selectedLocation, this.selectedServiceID).subscribe(
      res => {
        this.hidePageContentLoader()
        this.listOfStaffSlots = res["list"]
        console.log(this.selectedServiceMap[this.selectedReservationTypeID])
        console.log(this.listOfStaffSlots, "-->list")
        if(this.listOfStaffSlots.length == 0){
          this.showNoSlotAvailable = true;
        }
      },
      error => {
        this.hidePageContentLoader()
        console.log("error", error);
      }
    );
  }
  getSlotsForDateCapacity(startDate, endDate) {
    console.log("**************  Getting Slots For DateCapacity  **************");
    var participantParams = "participants=";
    for (let i = 0; i < this.capacityBasedSlotsData.length; i++) {
      participantParams = participantParams + this.capacityBasedSlotsData[i].id;
      if (i < this.capacityBasedSlotsData.length - 1) {
        participantParams = participantParams + "&participants=";
      }
      if((i == this.capacityBasedSlotsData.length - 1) || (i == 250)){
        break;
      }
    }

    this.appService.getSlotsForDate_capacity(startDate, endDate, participantParams, this.selectedServiceID, this.selectedCalendarKey).subscribe(
      res => {
        // console.log(res);
        var events = res["data"]["event"];

        if (!events || events.length == 0) {
          this.selectedServiceMap[this.selectedReservationTypeID]['areaSlot'] = this.capacityBasedSlotsData[0];
          this.room = this.capacityBasedSlotsData[0];
          return;
        }

        //initilizing hashmaps for lodges
        for (let j = 0; j < this.capacityBasedSlotsData.length; j++) {
          var hashMap = {};
          for (let i = startDate; i < endDate; i = i + (1000 * 60 * 60 * 24)) {
            var date__ = moment(i.valueOf()).format('DD/MM/YYYY');
            hashMap[date__] = [];
          }
          this.capacityBasedSlotsData[j]["haspMap"] = hashMap;
        }

        //arrange the events based on lodgeid and date
        for (let i = 0; i < events.length; i++) {
          for (let j = 0; j < events[i].participantVos.length; j++) {
            if (events[i].participantVos[j].resourceType == "LODGE") {
              let index = this.capacityBasedSlotsData.findIndex(o => o.id.toString() == events[i].participantVos[j].subject);
              if (index > -1) {
                var hashmap_ = this.capacityBasedSlotsData[index]["haspMap"];

                var __date = events[i]["startDate"];
                __date = moment(__date).format("DD/MM/YYYY");

                if (hashmap_[__date]) {
                  hashmap_[__date].push(events[i]);
                }
              }
            }
          }
        }

        
        var freeLodge = null;


        var thresholds = [0, 0.25, 0.5 , 0.75 ,0.80 , 0.99]; // Empty, quarter occupied, semi-occupied
        for (let threshold of thresholds) {
          for (let j = 0; j < this.capacityBasedSlotsData.length; j++) {
            if (checkOccupancyLevel(this.capacityBasedSlotsData[j], threshold)) {
              this.room = this.capacityBasedSlotsData[j];
              this.selectedServiceMap[this.selectedReservationTypeID]['areaSlot'] = this.capacityBasedSlotsData[j];
              freeLodge = this.capacityBasedSlotsData[j];
              return;
            }
          }
        }

        function checkOccupancyLevel(lodge, threshold) {
          var hashmap_ = lodge["haspMap"];
          var maxPets = lodge["maxNumberOfPets"];
          let lodgeAttribute = JSON.parse(lodge.attributes);
          for (var key in hashmap_) {
            var eventList = hashmap_[key];
            if(eventList && eventList.length > 0 && lodgeAttribute.allowOnlyFamilyPets && lodgeAttribute.allowOnlyFamilyPets == 'true'){
              return false;
            }
            if (eventList.length > threshold * maxPets) {
              return false;
            }
          }
          return true;
        }



        //finding available slots
        // var freeLodge = null;
        // for (let j = 0; j < this.capacityBasedSlotsData.length; j++) {
        //   var hashmap_ = this.capacityBasedSlotsData[j]["haspMap"];
        //   var capacity = this.capacityBasedSlotsData[j]["maxNumberOfPets"];

        //   var found = true;
        //   for (var key in hashmap_) {
        //     if (found) {
        //       var eventList = hashmap_[key];
        //       if (eventList.length >= capacity) {
        //         found = false;
        //       }
        //     }
        //   }
        //   if (found) {
        //     this.room = this.capacityBasedSlotsData[j];
        //     freeLodge = this.capacityBasedSlotsData[j];
        //     this.capacityBasedSlotsData = this.capacityBasedSlotsData.filter(slot => {
        //       slot['available'] = true;
        //       Object.entries(slot['haspMap']).forEach(([key, value]) => {
        //         // if(value.length + parseInt(this.selectedPetNum) > slot.maxNumberOfPets) {
        //         //   slot['available'] = false;
        //         // }
        //       });
        //       return slot['available']
        //     })
        //     return;
        //   }
        // }

        if (!freeLodge && this.reservationTypesMap[this.selectedReservationTypeID].autoApproval) {
          this.isLoading = false;
          delete this.selectedServiceMap[this.selectedReservationTypeID].timeSlot;
          delete this.selectedServiceMap[this.selectedReservationTypeID].timeSlot_end;
          delete this.selectedServiceMap[this.selectedReservationTypeID].areaSlot;
          delete this.selectedServiceMap[this.selectedReservationTypeID].startDate;
          delete this.selectedServiceMap[this.selectedReservationTypeID].endDate;
          // delete this.selectedServiceMap[this.selectedReservationTypeID];
          // this.selectedServiceMap = this.selectedServiceMap.filter(service => service !== undefined && service !== null);
          // this.selectedServiceID = undefined;
          // this.selectedAddOnServices = [];
          this.validateAccordian();
          Swal.fire("Currently this service is not available, go back and select different service");
          return;
          // alert("Currently this service is not available, go back and select different service");
        }

      },
      error => {
        console.log("error:", error);
      }
    );
  }


  getDateList(startDate, endDate) {
    var dateStart = moment(startDate);
    var dateEnd = moment(endDate);
    var dateList = [];

    while (dateEnd > dateStart || dateStart.format('D') === dateEnd.format('D')) {
      dateList.push({
        checked: true,
        date: moment(dateStart).toDate(),
        value: dateStart.format('ddd MMM DD, YYYY')
      });
      dateStart.add(1, 'day');
    }

    this.dateList = dateList;
    console.log(dateList)
  }

  getPetBreed(petTypeObj) {
    console.log("******************  Getting Pet Breed  ******************")
    if (!this.selectedPetID) {
      return;
    }
    this.petBreeds = petTypeObj["breeds"];

    if (this.petBreeds) {

    }
  }

  getPets(userId) {
    this.appService.getUserPets(userId).subscribe(
      (res: any) => {
        res.list = res.list.filter(x => x.status == 'ACTIVE');
        this.userPets = res["list"];
        this.infoService.listOfPets = this.userPets;
        this.infoService.userObj = this.userObj;
        this.userPets = this.userPets.filter(userPet => userPet.type.id == this.selectedPetID);

        if(this.userPets.length == 0){
          this.showAddPet();
        }
        this.veterinarianDetails = []
        this.getVetData();
        // this.selectedPets = [this.userPets[0]]
        this.userPets.map(userPet => userPet.selected = false);
        // if (this.userPets.length == 1) {
        //   this.petServiceMap[0]['pet'] = this.userPets[0];
        // } else {
        //   delete this.petServiceMap[0]['pet'];
        // }
      },
      error => {
        console.log("error", error);
      }
    );
  }

  getPetsAndNext(userId,isReset) {
    this.appService.getUserPets(userId).subscribe(
      res => {
        res["list"] = res["list"].filter(x => x.status == 'ACTIVE');
        this.userPets = res["list"];
        this.infoService.listOfPets = this.userPets;
        this.infoService.userObj = this.userObj;
        if (isReset) {
          this.userPets.map(userPet => userPet.selected = false);
        }
        this.userPets = this.userPets.filter(userPet => userPet.type.id == this.selectedPetID);
        // if (this.userPets.length == 1) {
        //   this.petServiceMap[0]['pet'] = this.userPets[0];
        // } else {
        //   delete this.petServiceMap[0]['pet'];
        // }
        if(this.selectedPurchaseType == 'service'){
          if (this.userPets.length >= parseInt(this.selectedPetNum)) {
            this.pageShowType = 'showpets';
          } else {
            Swal.fire(`Added new pet successfully. Please add new ${this.selectedPetName}!`);
          }
        }
        else{
          this.pageShowType = 'showpets';
        }
      },
      error => {
        console.log("error", error);
      }
    );
  }

  onPetBreadChange($event: any) {
    this.selectedPetBread = $event.value;
  }

  petOldChange($event: any) {
    var now = moment();
    var petBirth = moment($event);
    var years = now.diff(petBirth, 'year');
    petBirth.add(years, 'years');

    var months = now.diff(petBirth, 'months');
    petBirth.add(months, 'months');

    moment.tz.setDefault(this.locationTimezone);
    let month = Number(this.bsValue.getMonth() + 1) > 9 ? Number(this.bsValue.getMonth() + 1) : '0' + Number(this.bsValue.getMonth() + 1);
    let day = this.bsValue.getDate() > 9 ? this.bsValue.getDate() : '0' + this.bsValue.getDate();
    let year = this.bsValue.getFullYear();
    let slashFormat = month + '/' + day + '/' + year;
    this.petBirth =  moment(slashFormat, 'MM/DD/YYYY').format('x');
    this.petOldStr = years + ' years ' + months + ' months old'
  }

  //R-show add pet page
  showAddPet() {
    this.pageShowType = "addpet";
    // this.stepper.next();
    //load app profile settings
    // this.getAppProfileSetting();
  }

  profileMap = new Map();

  getAppProfileSetting() {
    this.infoService.getAppProfileSettings().subscribe({
      next: (res: any) => {
        console.info(res, "appprofileSettings")
        if (res.data.hasOwnProperty("content")) {
          res.data.content.forEach(element => {
            if (element.hasOwnProperty("value") && element.hide)
              this.profileMap.set(element.key, JSON.parse(element.value))
          });
        }
      },
      error: (err) => {
        console.log(err);

      }
    })
  }



  savePet() {
    var petObj = {
      "name": this.petNameCtrl.value,
      "type": {
        "id": this.newPetID
      },
      "breed": {
        "id": this.selectedPetBread ? this.selectedPetBread : null
      },
      "gender": {
        "id": this.selectedPetGender ? this.selectedPetGender : null
      },
      "size": {
        "id": null
      },
      "color": this.petColor,
      "notes": '',
      "dateOfBirth": this.petBirth,
      "weight": this.petWeight,
      "veterinarian" : {}
    };

    if (this.selectedVetDetails) {
      petObj["veterinarian"] = {
        "id": this.selectedVetDetails.id
      }
    }
    else {
      delete petObj["veterinarian"];
    }

    petObj["user"] = {};
    petObj["tenant"] = {};
    this.isLoading = true;
    this.appService.addPet(petObj, this.userObj['id']).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.getPetsAndNext(this.userObj['id'],true);
        this.petNameCtrl.reset();
        this.selectedPetGender = null;
        this.selectedPetBread = null;
        this.petWeight = 0;
        this.bsValue = undefined;
      },
      error => {
        console.log("error", error);
        this.isLoading = false;
      }
    );
  }

  addPetGender(petTypeObj) {
    if (!this.selectedPetID) {
      return;
    }
    this.petGenders = petTypeObj["genders"];
    if (this.petGenders) {
      console.log(this.petGenders)
    }
  }
  petInfo: petKeyInfo[];
  qAPassCheck: boolean = false;
  qAPassCheckevent(eventFlag: boolean) {
    this.qAPassCheck = eventFlag;
  }


  injectQAInReservationType(appointmentObj: any) {

    this.petInfo = this.infoService.getPetInfo();
    // iterate appointment to inject qa from petInfo
    appointmentObj.appointmentDetails.forEach(petWithAppointment => {

      this.petInfo.forEach(petInfo => {

        if (petInfo.petKey == petWithAppointment.pet.petKey) {

          let qusAns: Map<string, questions[]> = petInfo.answers;// map<string,questions[]>

          // Assuming this returns an array of objects
          // Use map to create a new array with the specific properties
          // iterate a hashmap
          let answerArray = [];
          qusAns.forEach((value, key) => {
            value.forEach((question) => {
              answerArray.push({ answer: question.answer, question: question.question });
            });
          })

          petWithAppointment.answers = answerArray;

          // Once pet in appointment found interate appointment for service and inject answers
          petWithAppointment.reservationTypes.forEach(service => {
            delete service.questions;
          });
        }
      })
    })
  }

  buffer = false;
  bookAppointment(appointmentObj, userId) {
    // inject QA 
    this.injectQAInReservationType(appointmentObj);
    console.log(appointmentObj,"appointmentObj");
    
    // return;
    var appointmentObj;
    this.isLoading = true;
    this.buffer = true;
    // this.appService.bookAppointment(appointmentObj, userId).subscribe(
    this.appService.bookAppointmentNew(appointmentObj, userId).subscribe(
      (res: any) => {
        this.appointmentCreated = true
        this.buffer = false;
        this.isLoading = false;
        console.log(res);
        if (res["data"]) {
          this.infoService.appointmentKey = res.data.appointmentKey
          this.appointmentKey = res.data.appointmentKey
          this.user = res.data.user

          var appointment = res["data"];
          this.appoint_res = res.data;
          this.depositRequired = this.appoint_res.depositRequired
          if(this.appoint_res.depositAmount && this.appoint_res.depositAmount > 0){
            this.appoint_res.depositAmount = Math.round((this.appoint_res.depositAmount + Number.EPSILON) * 100) / 100;
          }
          var appointmentStatus = "PENDING";

          if (res["data"]["status"]) {
            appointmentStatus = res["data"]["status"];
          }

          this.resultStatusDesc = "";
          if (appointmentStatus.toLowerCase() == "pending") {
            this.resultStatusDesc = "Your appointment is requested.";
          } else if (appointmentStatus.toLowerCase() == "draft") {
            this.resultStatusDesc = "Your appointment will not be reviewed without a deposit. Click on the Pay Deposit button below to pay the deposit of $" + this.appoint_res.depositAmount;
          } else {
            this.resultStatusDesc = "Your appointment is " + appointmentStatus.toLowerCase();
          }

          this.pet_names = '';
          this.showEndTimeInSummary = true
          appointment.appointmentDetails.forEach(pet => {
            this.pet_names += pet.pet.name + ', ';
            pet.reservationTypes.forEach(service => {
              if((service.endDate == appointment.appointmentEndTime) && service.serviceBasedOn == 'STAFF_BASED' && !this.showEndTimeForStaffBased){
                this.showEndTimeInSummary = false
              }
            })
          });

          this.pet_names = this.pet_names.slice(0, -2);
          this.start_time_str = moment(res["data"]['appointmentDate']).format('ddd, MMM D, YY  h:mm A');
          this.end_time_str = moment(res["data"]['appointmentEndTime']).format('ddd, MMM D, YY  h:mm A');
          // if (appointment.depositRequired && appointment.depositAmount > 0) {
          //   var roundedDeposit = Math.round((appointment.depositAmount + Number.EPSILON) * 100) / 100;
          // }
          this.infoService.setConfirmationValue(this.pet_names, this.start_time_str, this.end_time_str, this.displayAddress,this.showEndTimeInSummary);


          this.allow = false;
          // this.requestNewAppointment();
          // this.stepper.next();

          /**************************************/

          // let forceCardOnFile:boolean = this.infoService.ForceStepperControl.ForceCardOnFile

          // if(!forceCardOnFile && this.appService.savedCards.length > 0){
          //   this.showSavedCards = true
          // }

          /**************************************/
        }
      },
      error => {
        this.buffer = false;
        this.appointmentCreated = false
        this.isLoading = false;
        console.log("error", error);
      }
    );
  }
  show() {
    console.log(this.infoService.pet_names, this.infoService.start_time_str, this.infoService.end_time_str, this.infoService.displayAddress);

  }
  getAppointmentObj() {
    this.isLoading = true
    this.appService.getAppointmentObj(this.appointmentKey).subscribe(
      (res: any) => {
        this.isLoading = false
        if (res["data"]) {
          this.appoint_res = res["data"];
          this.depositRequired = this.appoint_res.depositRequired
          var appointmentStatus = "PENDING";
          if (res["data"]["status"]) {
            appointmentStatus = res["data"]["status"];
          }
          if (appointmentStatus.toLowerCase() == "pending") {
            this.resultStatusDesc = "Your appointment is requested.";
          } else if (appointmentStatus.toLowerCase() == "draft") {
            this.resultStatusDesc = "Your appointment will not be reviewed without a deposit. Click on the Pay Deposit button below to pay the deposit of $" + this.appoint_res.depositAmount;
          } else {
            this.resultStatusDesc = "Your appointment is " + appointmentStatus.toLowerCase();
          }
        }
      },

      (err) => {
        this.isLoading = false
      }
    )
  }
  allow = false;
  showSavedCard = false;
  proceedAppointment() {
    this.getUserCards()
    this.allow = true;
    let appointment = this.infoService.appointmentObj;
    let user = this.infoService.userId;
    this.bookAppointment(appointment, user);
  }
  requestNewAppointment() {
    if (this.appoint_res && this.appoint_res.forceDepositForAppAndWeb && this.appoint_res.depositRequired) {
      //let dialogRef  = this.dialog.open(AppointmentCancelDialogComponent)
      Swal.fire({
        icon: 'warning',
        title: 'Warning',
        html: '<p style="font-size:15px;text-align:center">Your appointment will not be reviewed without a deposit. Are you sure you want to cancel?</p>',
        //  text: cardNotPresentEnabledMessageObj.value,
        confirmButtonText: 'NO',
        cancelButtonText: 'CANCEL REQUEST',
        showCancelButton: true,
      }).then((result: any) => {
        if (!result.isConfirmed) {
          window.location.reload()
        }
      });
    } else {
      // window.location.reload()
    }
  }

  getConvertedDateAndTime(date, time) {
    // -->

    // var timeZoneDate = moment(time);
    // var zeroHour = moment(time).startOf('day');
    // var slotTime = timeZoneDate.valueOf() - zeroHour.valueOf();

    console.log(date);
    console.log(time);
    var time_ = moment(time).format('hh:mm A');
    console.log(time_);
    // -->

    // let value = date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear();
    let value = date.format("DD.MM.YYYY");
    if (time) {
      value += " " + time_;
    }
    return moment(value, "DD.MM.YYYY hh:mm A").clone();
  }

  openDialog(android: string, ios: string) {
    this.dialog.open(AlertComponent, {
      data: {
        android,
        ios
      },
      width: '500px',
    });
  }

  openDialogs(): void {
    const dialogRef = this.dialog.open(PopupComponent, {
      width: '250px',
      data: { name: this.name, animal: this.animal }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.animal = result;
    });
  }

  checkEqualSlot(key: string, index: string, slot: object) {
    if (this.selectedServiceMap[this.selectedReservationTypeID]
      && this.selectedServiceMap[this.selectedReservationTypeID][key]
      && this.selectedServiceMap[this.selectedReservationTypeID][key][index] == slot[index]) {
      return true;
    }
  }
  checkEqualStaff(staff, slot) {
    if (this.selectedStaff && this.selectedStaff.userKey && this.selectedSlot && this.selectedSlot.lable) {
      if (this.selectedStaff.userKey == staff.userKey && this.selectedSlot.lable == slot.lable) {
        return true;
      }
    }
  }
  selectStaffName(slot, staff) {
    staff.shouldDisplay = !staff.shouldDisplay;
    this.selectedStaff = staff;
    this.selectedSlot = slot;
    let index = this.selectedSlot.employees.findIndex(o => o.userKey == staff.userKey);
    let indexSlot = this.listOfStaffSlots.findIndex(o => o.id == slot.id);
    if (indexSlot) {
      this.listOfStaffSlots[indexSlot].selected = true;
      this.listOfStaffSlots[indexSlot].employees[index].selected = true;
      console.log(indexSlot, "-->slot")
    }

  }
  selectStaff($event, time) {
    console.log($event.value);
    console.log(time);
    time["selectedEmployee"] = $event.value;
    this.selectedStaff = $event.value;
    this.selectedSlot = time;
    this.selectedServiceMap[this.selectedReservationTypeID]['timeSlot'] = time;
  }
  selectStaffforSlot($event, time, slot) {
    console.log($event.value);
    console.log(time);
    time["selectedEmployee"] = slot.employees[0];
    this.selectedStaff = time["selectedEmployee"];
    this.selectedSlot = time;
    if (!time.employees) {
      time["employees"] = [];
      time["employees"].push(this.selectedStaff);
    }
    this.selectedServiceMap[this.selectedReservationTypeID]['timeSlot'] = time;
  }
  checkEqualStaffSlot(time, slot) {
    if (this.selectedStaff && this.selectedStaff.userKey && this.selectedSlot && this.selectedSlot.lable) {
      if (this.selectedStaff.userKey == slot.employees[0].userKey && this.selectedSlot.lable == time.lable) {
        return true;
      }
    }
  }
  // -->
  onSlotTap(slot, type = null) {
    if (type == "start") {
      this.rangeInSlots.forEach(slot => {
        slot.selected = false;
      });
    }
    if (type == "end") {
      this.rangeOutSlots.forEach(slot => {
        slot.selected = false;
      });
    }
    slot.selected = !slot.selected;
    if (slot.selected) {
      var timeZoneDate = moment(slot.name);
      var zeroHour = moment(slot.name).startOf('day');

      var slotTime = timeZoneDate.valueOf() - zeroHour.valueOf();

      if (type == "start") {
        var start = this.selectedStartDate;
        this.selectedStartDate = this.getTimeZoneDate(start.getTime()).valueOf() + slotTime;
        this.selectedServiceMap[this.selectedReservationTypeID]['startTime'] = this.selectedStartDate;
        console.log("setting startdate:", moment(this.startDate));
      } else if (type == "end") {
        var end = this.selectedEndDate;
        this.selectedEndDate = this.getTimeZoneDate(end.getTime()).valueOf() + slotTime;
        console.log("setting enddate :", moment(this.endDate));
      }

      if ((!this.reservationTypesMap[this.selectedReservationTypeID].autoApproval)) {
        if (type == "start" && slot.isServiceTimings) {
          var _end = this.selectedEndDate;
          var _slot = this.rangeInSlots[this.rangeInSlots.length - 1]; //last slot
          var _timeZoneDate = moment(_slot.name);
          var _zeroHour = moment(_slot.name).startOf('day');
          var _slotTime = _timeZoneDate.valueOf() - _zeroHour.valueOf();
          this.selectedEndDate = this.getTimeZoneDate(_end.getTime()).valueOf() + _slotTime;
          console.log("setting enddate :", moment(this.endDate));
        }
      }
    }
  }

  getTimeZoneDate(date) {
    let dateObj = new Date(date);
    let month = dateObj.getMonth() + 1;
    let day = dateObj.getDate();
    let year = dateObj.getFullYear();
    let slashFormat = day + '/' + month + '/' + year;
    var timeZoneSpecificDate = moment(slashFormat, 'DD/MM/YYYY');
    return timeZoneSpecificDate;
  }
  // -->

  goBack(type:string) {
    if(type == 'petInfo' && (this.inviteCodeUser || this.newUserSignUp)){
      const additionalMessage = this.inviteCodeUser
      ? 'Note: Invite code is for single-time use. You need to log in via email and the password set during registration after leaving.'
      : this.newUserSignUp
      ? 'You will need to log in with your email and password set during registration after leaving.'
      : '';
      Swal.fire({
        title: 'Warning',
        icon: 'warning',
        html: `Are you sure you want to leave this page? All your data will be lost. <br><br>${additionalMessage}`,
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: 'Stay',
        confirmButtonText: 'Leave',
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.stepper.previous();
        }
      });
    }
    else{
      Swal.fire({
        title: 'Warning',
        icon: 'warning',
        text: 'Are you sure you want to leave this page? All your data will be lost',
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: 'Stay',
        confirmButtonText: 'Leave',
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.stepper.previous();
        }
      })
    }
  }

  setPetType() {
    this.pageShowType = 'showpets';
  }

  goBackForForgetPassword(isShowWarning:any) {
    if (isShowWarning) {
      Swal.fire({
        title: 'Warning',
        icon: 'warning',
        text: 'Are you sure you want to leave this page? All your data will be lost',
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: 'Stay',
        confirmButtonText: 'Leave',
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.showForget = false;
        }

        //stay
        if (result.isDismissed) {

        }
      })
    }
    else {
      this.showForget = false;
    }
  }

  //*****************    Validators Start   *****************//
  getErrorMessage(control: FormControl, checker: string, ...validators: string[]) {
    // console.log(validators);
    let msg = '';
    validators.forEach(validator => {
      switch (validator) {
        case 'required':
          if (control.hasError('required')) {
            msg = `${checker} is mandatory`;
          }
          break;
        case 'iscapital':
          if (control.hasError('iscapital')) {
            msg = `First letter should be capital letter.`;
          }
          break;
        case 'specialchar':
          if (control.hasError('specialchar')) {
            msg = `Name contains special characters.`;
          }
          break;
        case 'pattern':
          if (control.hasError('pattern')) {
            msg = `Invalid ${checker}.`;
          }
          break;
        default:
          break;
      }
    });

    if (msg != '') {
      return msg;
    } else {
      return null;
    }

  }

  firstCapitalValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value !== null && /[a-z]/.test(control.value[0])) {
      return { 'iscapital': true }
    }
    return null
  }

  specialCharValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value !== null && /[^a-zA-Z0-9 ]/.test(control.value)) {
      return { 'specialchar': true }
    }
    return null
  }

  convertInt(str) {
    return parseInt(str);
  }
  //*****************    Validators End   *****************//


  openServiceDescription(service) {
    Swal.fire({
      title: 'Account already exists!',
      html: '<p style="font-size:15px;text-align:center">{{service.description}}</p> ',
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: 'Ok',
    })
  }

  depositPayNewCard() {

    let list = this.tenantDetail.list
    let cardNotPresentAvailableObj = list.find(
      (item: any) => item.key == 'CardNotPresentAvailable'
    )
    let cardNotPresentEnabledObj = list.find(
      (item: any) => item.key == 'CardNotPresentEnabled'
    )
    let cardNotPresentEnabledMessageObj = list.find(
      (item: any) => item.key == 'CardNotPresentEnabledMessage'
    )

    if (cardNotPresentAvailableObj &&
      cardNotPresentAvailableObj.value == 'false' &&
      cardNotPresentEnabledObj &&
      cardNotPresentEnabledObj.value == 'false'
    ) {

      let toAddress = this.emailUs + ', ' + this.contactManager
      let name = this.user.firstName + ' ' + this.user.lastName

      Swal.fire({
        title: 'In-web Payments',
        html: '<p style="font-size:15px;text-align:center">' + cardNotPresentEnabledMessageObj.value + '</p>',
        //  text: cardNotPresentEnabledMessageObj.value,
        confirmButtonText: 'Request In-App Payments'
      }).then((result: any) => {
        if (result.isConfirmed) {
          let to = toAddress
          let bcc = 'operations@runloyal.com'
          let subject = `${name} would like to pay through the app`
          let body = `Hi ${this.ko},` +
            `${name} has indicated that they’d like the option to pay for their future services, packages and appointments through the app.
            Once they have a credit card saved on file, your customers can securely pay for your services, easily add tips for your staff and approve recurring payments.
            Contact the RunLoyal Sales Team to get see how easy it can be to enable this capability and provide an exceptional customer experience!`

          window.open(`mailto:${to}?bcc=${bcc}&subject=${subject}&body=${body}`);
        }
      });

      return
    }

    this.getPaymentLink()
  }

  depositPaySavedCard() {
    this.disablePayDepositBtn = true
    let forceCardOnFile: boolean = this.infoService.ForceStepperControl.ForceCardOnFile

    // if(!forceCardOnFile && this.appService.savedCards.length == 0){
    //   this.getPaymentLink()
    //   return
    // }

    // if (!forceCardOnFile) {
    //   this.getPaymentLink()
    //   return
    // }

    this.payThroughCard()
  }

  payThroughCard() {
    if (!this.selectedSavedCard) {
      Swal.fire({
        title: 'Warning',
        icon: 'warning',
        html: '<p style="font-size:15px;text-align:center">Please select a card</p>',
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: 'Ok',
      })
      this.disablePayDepositBtn = false
      return
    }

    if(this.selectedSavedCard.ccvRequired && !this.selectedSavedCard.cvvValue || this.selectedSavedCard.cvvValue == ""){
      Swal.fire({
        title: 'Warning',
        icon: 'warning',
        html: '<p style="font-size:15px;text-align:center">Please enter cvv</p>',
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: 'Ok',
      })
      this.disablePayDepositBtn = false
      return
    }

    if(this.selectedSavedCard.ccvRequired && this.selectedSavedCard.cvvValue.length < 3){
      Swal.fire({
        title: 'Warning',
        icon: 'warning',
        html: '<p style="font-size:15px;text-align:center">Please enter valid cvv</p>',
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: 'Ok',
      })
      this.disablePayDepositBtn = false
      return
    }

    let request = {
      paymentType: "Credit",
      applicationReturnUrl: this.appService.paymentReturnUrl,
      paymentMode: "CARD_NOT_PRESENT",
      merchantTokenId: this.selectedSavedCard.merchantTokenId,
      appSource: "WEB",
      loggedInUser: { userKey: this.appoint_res.user.userKey },
      transactionType: "Deposit",
      amount: this.appoint_res.depositAmount,
      customerInitiated:true,
      recurring:false,
    };
    if (this.selectedSavedCard.cardType)
    {
      request["cardType"] = this.selectedSavedCard.cardType;
    }
    if(this.selectedSavedCard.ccvRequired && this.selectedSavedCard.cvvValue){
      request["cvv"] = this.selectedSavedCard.cvvValue;
    }
    this.showPageContentLoader()
    this.appService.getPaymentLink(request, this.appoint_res.estimateNumber).subscribe(
      (res: any) => {
        this.hidePageContentLoader()
        if (res.data) {
          if(res.data.paymentStatus == 'APPROVED'){
            if(this.showEndTimeInSummary){
              var message = `Thank you for your payment . \n Your appointment has been successfully confirmed.\nWe can't wait to see ${this.pet_names} at ${this.start_time_str} To ${this.end_time_str} at ${this.displayAddress}`;
            }
            else{
              var message = `Thank you for your payment . \n Your appointment has been successfully confirmed.\nWe can't wait to see ${this.pet_names} at ${this.start_time_str} at ${this.displayAddress}`;
            }
            this.infoService.getAppointmentDetail(this.infoService.appointmentKey).subscribe((res: any) => {
              if (res && res.data) {
                if (res.data.status != 'CONFIRMED') {
                  Swal.fire({
                    icon: 'success',
                    allowOutsideClick: false,
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'Okay',
                    html: `Thank you for your payment . \n Your appointment request has been received and will be reviewed shortly .\n We are looking forward to seeing ${this.pet_names}`
                  }).then((result: any) => {
                    if (result.isConfirmed) {
                      this.reload()
                    }
                  })
                }
                else {
                  Swal.fire({
                    icon: 'success',
                    allowOutsideClick: false,
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'Okay',
                    html: message
                  }).then((result: any) => {
                    if (result.isConfirmed) {
                      this.reload()
                    }
                  })
                }
              }
            })
          }
          else{
            Swal.fire({
              icon: 'error',
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: 'Okay',
              html: res.data.gatewayMessage
            }).then((result: any) => {
              if (result.isConfirmed) {
                this.disablePayDepositBtn = false
              }
            })
          }
         // var url = this.removeWwwFromString(res.data.applicationReturnUrl);
          // window.location.href = res.data.applicationReturnUrl;
        }
      },

      (err: any) => { 
        this.hidePageContentLoader()
      }
    );
  }

  getSavedCards() {
    this.isLoading = true

    this.appService.getSavedCards().subscribe(
      (res: any) => {
        this.savedCards = res.list

        if (this.savedCards.length != 0) {
          let dialogRef = this.dialog.open(SavedCardsComponent, { data: this.savedCards })
          let userInfo = {
            applicationReturnUrl: this.appService.addCardReturnUrl,
            invoiceVo: {
              customerVO: {
                userKey: this.appoint_res.user.userKey,
                firstName: this.appoint_res.user.firstName,
                lastName: this.appoint_res.user.lastName,
                email: this.appoint_res.user.email,
              }
            }
          }

          dialogRef.componentInstance.userInfo = userInfo
          dialogRef.componentInstance.userKey = this.appoint_res.user.userKey
          dialogRef.componentInstance.appointmentRes = this.appoint_res
        }

        if (this.savedCards.length == 0) {
          this.getPaymentLink()
        }
      },

      (err) => {
        this.isLoading = false
        this.getPaymentLink()
      }
    )
  }

  getPaymentLink() {
    this.isLoading = true
    var url = window.location.href + "thankyou"
    console.log("***********" + url);
    let request = {
      "paymentType": "Credit",
      "transactionType": "Deposit",
      // "applicationReturnUrl": this.appService.paymentReturnUrl + '?appointmentKey=' + this.appointmentKey,
      "applicationReturnUrl": url,
      "paymentMode": "CARD_NOT_PRESENT",
      "amount": this.appoint_res.depositAmount,
      "appSource": "WEB",
      "loggedInUser": this.appoint_res.userKey,
      "customerInitiated":true,
      "recurring":false,
      "customPaymentUrl":this.appService.applicationReturnUrl + "/" + this.appService.tenantKey + "/payment.html"
    }
    Swal.fire({
      title: 'We are redirecting you to a secure payment page',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
      willClose: () => {
      }
    }).then((result) => {
      /* Read more about handling dismissals below */
    })
    this.showPageContentLoader()
    this.appService.getPaymentLink(request, this.appoint_res.estimateNumber).subscribe(
      (res: any) => {
        this.hidePageContentLoader()
        this.isLoading = false
        this.paymentDetails = res.data;
        Swal.close()
        if (this.paymentDetails.checkoutUrl) {
          // window.open(this.paymentDetails.checkoutUrl);
          let link = this.paymentDetails.checkoutUrl;
          let data = {
            link : this.paymentDetails.checkoutUrl,
            isRequestDeposit : true,
            petName : this.pet_names,
            startTime : this.start_time_str,
            endTime : this.end_time_str,
            address : this.displayAddress,
            showEndTimeInSummary : this.showEndTimeInSummary
          }
          const dialogRef = this.matDialog.open(CardOnFileComponent, {
            height: '680px', data: data, disableClose: true
          });
          dialogRef.afterClosed().subscribe((result: any) => {
            console.log("//closed")
          })
          // var url = this.removeWwwFromString(this.paymentDetails.checkoutUrl);
          // window.location.href = url;

          // let dialogRef = this.dialog.open(PaymentPageDialogComponent)
          // dialogRef.componentInstance.checkoutUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
          //   this.paymentDetails.checkoutUrl
          // )
        }
      },

      (err) => {
        this.hidePageContentLoader()
        Swal.close()
        this.isLoading = false
      }
    )
  }
  changeUpperCase(textToUpper: string) {
    console.log("textToUpper: " + textToUpper);
    var newWord = textToUpper.toUpperCase();
    console.log("The word in upper case: " + newWord);
  }
  checkInviteCode() {
    if(this.inviteCodeCtrl && this.inviteCodeCtrl.value && this.inviteCodeCtrl.value != ""){
      this.isLoading = true
     this.appService.checkInviteCode(this.inviteCodeCtrl.value.toUpperCase()).subscribe(
      (res: any) => {
        this.isLoading = false
        this.user = res.data.user

        if (res.status.code == 1000) {
          if (res.data.status == 'PENDING') {
            this.showPasswordFieldForInviteCode = true
          } else {
            // let dialogRef = this.dialog.open(InviteCodeDialogComponent)
            // dialogRef.componentInstance.title = 'Account already exists!'
            // dialogRef.componentInstance.message =
            //   'You already signed up with this invite code, Do you like to proceed with different user.'

            Swal.fire({
              title: 'Account already exists!',
              html: '<p style="font-size:15px;text-align:center">You already signed up with this invite code, you cannot use invite code further again -> Need to login via email and set password</p> ',
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: 'Ok',
            })
          }
        } else {
          // let dialogRef = this.dialog.open(InviteCodeDialogComponent)
          // dialogRef.componentInstance.title = 'Account not found'
          // dialogRef.componentInstance.message = res.data.message

          Swal.fire({
            title: 'Account not found',
            html: '<p style="font-size:15px;text-align:center">' + res.data.message + '</p>',
            // text:  res.data.message,
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: 'Close',
          })
        }
      },
      (err) => {
        this.isLoading = false
      }
    )
    }
  }
  callingPaymentSuccess(status) {
    console.log("calling payment page " + status);
    this.dialog.closeAll();
    if (this.appointmentKey) {
      this.getAppointmentObj();
    }
  }

  getDescription(value: any) {
    this.toolTipText = value.description
  }

  showDescription(value: any) {
    Swal.fire({
      icon: 'info',
      title: value.name,
      text: value.description
    })
  }

  checkDescription(value: any) {
    if (value.description) {

      return true
    }

    return false
  }

  displayLocationName(location: any): string {
    return location.locationName
  }

  locationChange(event: any) {
    console.log(event.option.viewValue)

    this.locationCtrl.setValue(event.option.viewValue)

  }

  filterLocations(value: string) {
    const filterValue = value.toLowerCase();

    return this.multiLocation.filter(location => location.locationName.toLowerCase().includes(filterValue));
  }

  /*getAgreementsOld() {
    let selectedServiceCategories: any[] = Object.keys(this.selectedServiceMap)
    let selectedPets: any[] = []
    this.selectedPets.forEach((pet) => selectedPets.push(pet.petKey))
  
    this.appService.getAgreements(selectedServiceCategories, selectedPets).subscribe(
      (res: any) => {
        if (res.list.length > 0) {
          this.selectedPets.forEach((pet) => {
            let obj = {
              name: pet.name,
              petKey: pet.petKey
            }
  
            let filtered: any[] = res.list.filter((item: any) => item.subjectKey == pet.petKey)
  
            if (filtered.length > 0) {
              let array = []
              filtered.forEach((item) => {
                let agreementObj = {
                  id: item.id,
                  name: item.agreement.name,
                  content: item.agreement.content,
                  status: item.userAgreementStatus,
                  agreementSigned :  item.userAgreementStatus == "SIGNED" ? true : false,
                  agreementRequired: item.user.agreementRequired
                }
  
                if (item.signatureTime) {
                  agreementObj['signatureTime'] = item.signatureTime
                }
  
                if (item.signedDate) {
                  agreementObj['signedDate'] = item.signedDate
                }
  
                if (item.expirationDate) {
                  agreementObj['expirationDate'] = item.expirationDate
                }
  
                if(item.agreement){
                  if (item.agreement.forceAgreement == true) {
                    agreementObj['forceAgreement'] = item.agreement.forceAgreement
                    this.forceAgreement = item.agreement.forceAgreement
                  } else {
                    agreementObj['forceAgreement'] = false
                  }
                }
  
                if (item.user.agreementRequired == true) {
                  this.agreementRequired = true
                  array.push(agreementObj)
                }
  
                if((item.agreement.forceAgreement == true) && (item.user.agreementRequired == true)){
                  agreementObj['required'] = true
                }else{
                  agreementObj['required'] = false
                }
              })
  
              obj['agreements'] = array
            }
  
            this.agreements.push(obj)
          })
  
          setTimeout(() => {
            this.checkAgreements()
          }, 1000);
        }
      },
  
      (err) => {
  
      }
    )
  }*/

  getAgreements() {
    this.petOwnersAgreements = []
    this.forceAgreement = false
    this.agreementPassCheck = true
    this.showAgreement = false
    this.petServiceMap.forEach((obj: any) => {
      let reservationTypes: any[] = []

      for (const prop in obj.services) {
        reservationTypes.push(prop)
      }

      this.getAgreementsCall(reservationTypes, obj.pet.petKey, obj.pet.name)
    })
  }

  getAgreementsCall(reservationTypes: any[], petKey: any, name: any) {
    this.appService.getAgreements(reservationTypes, petKey).subscribe(
      (res: any) => {
        if (res.list.length > 0) {
          this.showAgreement = true

          let obj: any = {
            name: name,
            petKey: petKey
          }
          let petOwnerAgreement = res.list.filter((item: any) => item.userAgreementStatus != "SIGNED" && item.subject != 'PET')
          if(petOwnerAgreement.length > 0){
            for(let i = 0; i < petOwnerAgreement.length; i++){
              var find = this.petOwnersAgreements.find((item) => item.agreementId == petOwnerAgreement[i].agreement.id)
              if(!find){
                let item = petOwnerAgreement[i]
                let agreementObj: any = {
                  id: item.id,
                  name: item.agreement.name,
                  content: item.agreement.content,
                  status: item.userAgreementStatus,
                  userId: item.user.id,
                  subject: item.subject,
                  subjectKey: item.subjectKey,
                  agreementId: item.agreement.id
                }
    
                if (item.signatureTime) {
                  agreementObj['signatureTime'] = item.signatureTime
                }
    
                if (item.signedDate) {
                  agreementObj['signedDate'] = item.signedDate
                }
    
                if (item.expirationDate) {
                  agreementObj['expirationDate'] = item.expirationDate
                }
    
                if (item.agreement) {
                  if (item.agreement.forceAgreement) {
                    agreementObj['forceAgreement'] = item.agreement.forceAgreement
    
                    if (item.agreement.forceAgreement == true) {
                      this.forceAgreement = true
                    }
                  } else {
                    agreementObj['forceAgreement'] = false
                  }
                }
                this.petOwnersAgreements.push(agreementObj)
              }
            }
          }
          let filtered: any[] = res.list.filter((item: any) => item.userAgreementStatus != "SIGNED" && item.subject == 'PET')
          let agreements = []

          filtered.forEach((item: any) => {
            let agreementObj: any = {
              id: item.id,
              name: item.agreement.name,
              content: item.agreement.content,
              status: item.userAgreementStatus,
              userId: item.user.id,
              subject: item.subject,
              subjectKey: item.subjectKey,
              agreementId: item.agreement.id
            }

            if (item.signatureTime) {
              agreementObj['signatureTime'] = item.signatureTime
            }

            if (item.signedDate) {
              agreementObj['signedDate'] = item.signedDate
            }

            if (item.expirationDate) {
              agreementObj['expirationDate'] = item.expirationDate
            }

            if (item.agreement) {
              if (item.agreement.forceAgreement) {
                agreementObj['forceAgreement'] = item.agreement.forceAgreement

                if (item.agreement.forceAgreement == true) {
                  this.forceAgreement = true
                }
              } else {
                agreementObj['forceAgreement'] = false
              }
            }

            agreements.push(agreementObj)
          });

          obj["agreements"] = agreements
          this.agreements.push(obj)

          if (this.forceAgreement == false) {
            this.agreementPassCheck = true
          }

          /*let signed = agreements.filter((a) => a.status == "SIGNED")
  
          if(signed.length == agreements.length){
            this.showAgreement = false
          }*/

          if (agreements.length > 0 || this.petOwnersAgreements.length > 0) {
            this.agreementsFound = true
          }

          if (this.forceAgreement && this.agreementsFound) {
            this.agreementPassCheck = false
            this.showAgreement = true
          } else if (!this.forceAgreement && this.agreementsFound) {
            this.agreementPassCheck = true
            this.showAgreement = true
          } else if (this.forceAgreement && !this.agreementsFound) {
            this.agreementPassCheck = false
            this.showAgreement = false
          } else if (!this.forceAgreement && !this.agreementsFound) {
            this.agreementPassCheck = true
            this.showAgreement = false
          }
        }
      },

      (err) => {

      }
    )
  }

  /*getAgreementsCallOld(reservationTypes:any[], petKey:any){
    this.appService.getAgreements(reservationTypes, petKey).subscribe(
      (res: any) => {
        if (res.list.length > 0) {
          this.selectedPets.forEach((pet) => {
            let obj = {
              name: pet.name,
              petKey: pet.petKey
            }
  
            let filtered: any[] = res.list.filter((item: any) => item.subjectKey == pet.petKey)
  
            if (filtered.length > 0) {
              let array = []
              filtered.forEach((item) => {
                let agreementObj = {
                  id: item.id,
                  name: item.agreement.name,
                  content: item.agreement.content,
                  status: item.userAgreementStatus,
                  agreementSigned :  item.userAgreementStatus == "SIGNED" ? true : false,
                  agreementRequired: item.user.agreementRequired
                }
  
                if (item.signatureTime) {
                  agreementObj['signatureTime'] = item.signatureTime
                }
  
                if (item.signedDate) {
                  agreementObj['signedDate'] = item.signedDate
                }
  
                if (item.expirationDate) {
                  agreementObj['expirationDate'] = item.expirationDate
                }
  
                if(item.agreement){
                  if (item.agreement.forceAgreement == true) {
                    agreementObj['forceAgreement'] = item.agreement.forceAgreement
                    this.forceAgreement = item.agreement.forceAgreement
                  } else {
                    agreementObj['forceAgreement'] = false
                  }
                }
  
                if (item.user.agreementRequired == true) {
                  this.agreementRequired = true
                  array.push(agreementObj)
                }
  
                if((item.agreement.forceAgreement == true) && (item.user.agreementRequired == true)){
                  agreementObj['required'] = true
                }else{
                  agreementObj['required'] = false
                }
              })
  
              obj['agreements'] = array
            }
  
            this.agreements.push(obj)
          })
  
          setTimeout(() => {
            this.checkAgreements()
          }, 1000);
        }
      },
  
      (err) => {
  
      }
    )
  }*/

  updateAgreementSignedStatus() {
    this.checkAgreements()
  }

  /*checkAgreementsOld(){
    this.agreements.forEach((agreement:any) =>{
      let agreements:any[] = agreement.agreements == undefined ? [] : agreement.agreements
  
      agreements.forEach((item:any) => {
        if((item.forceAgreement == true) && (item.agreementRequired == true)){
          if(item.agreementSigned == false){
            this.agreementSigned = false
  
            return
          }
  
          if(item.agreementSigned == true){
            this.agreementSigned = true
          }
        }
      })
    })
  }*/

  checkAgreements() {
    this.agreementPassCheck = true

    for (let i = 0; i < this.agreements.length; i++) {
      let agreements = this.agreements[i].agreements
      if (agreements && agreements.length > 0) {
        for (let j = 0; j < agreements.length; j++) {
          if ((agreements[j].forceAgreement == true) && (agreements[j].status != "SIGNED")) {
            this.agreementPassCheck = false
            return
          }
        }
      }
    }
  }

  reload() {
    window.location.reload()
  }

  getImmunizations() {
    this.petServiceMap.forEach((obj: any) => {
      let reservationTypes: any[] = []

      for (const prop in obj.services) {
        reservationTypes.push(prop)
      }

      this.getImmunizationsCall(reservationTypes, obj.pet.petKey, obj.pet.name)
    })
  }

  getImmunizationsCall(reservationTypes: any[], petKey: string, name: string) {
    let obj = {}
    let array: any[] = []
    let types: any[] = []
    obj["petKey"] = petKey
    obj["name"] = name
   
    if(this.selectedPurchaseType == 'service'){
      reservationTypes.forEach((id) => {
        let type = {}
        let findedReservationType = this.reservationTypes.find((item) => item.id == id)
  
        if (findedReservationType) {
          type["id"] = findedReservationType.id
          type["name"] = findedReservationType.name
          type["forceImmunization"] = findedReservationType.forceImmunization
          type["requiredImmunization"] = findedReservationType.requiredImmunization
          if(findedReservationType.immunizationTypeId){
            type["immunizationTypeId"] = findedReservationType.immunizationTypeId.includes(",") ? findedReservationType.immunizationTypeId.split(",") : [findedReservationType.immunizationTypeId]
          }
  
          types.push(type)
        }
      })
    }
    else{
      if(this.selectedPurchaseType == 'membership'){
        let type = {
          id : this.selectedMembership.id,
          name : this.selectedMembership.name,
          forceImmunization : true,
          requiredImmunization : true
        }
        type['immunizationTypeId'] = this.selectedMembership.immTypes.map((item) => item.immTypeId)
        types.push(type)
      }
      else if(this.selectedPurchaseType == 'training'){
        let type = {
          id : this.selectedSession.id,
          name : this.selectedSession.name,
          forceImmunization : true,
          requiredImmunization : true
        }
        type['immunizationTypeId'] = this.selectedSession.groupService.immTypes
        types.push(type)
      }
    }


    obj["reservationTypes"] = types

    this.appService.getImmunizationsForPet(petKey).subscribe(
      (res: any) => {
        if (res.list && res.list.length > 0) {
          // this.showImmunization = true
          let filteredType = types.filter((a) => a.forceImmunization == true)

          if (filteredType.length > 0) {
            this.forceImmunization = true
          }

          types.forEach((type: any) => {
            if (type.immunizationTypeId && type.immunizationTypeId.length > 0) {
              type.immunizationTypeId.forEach((id: any) => {
                let a = res.list.find((b: any) => b.petImmunizationType.id == id)

                if (a) {
                  if (a.status == "EXPIRED") {
                    let immunizationObj = {}
                    immunizationObj["status"] = a.status
                    immunizationObj["endDate"] = a.endDate
                    immunizationObj["petImmunizationTypeId"] = a.petImmunizationType.id
                    immunizationObj["petImmunizationTypeName"] = a.petImmunizationType.name
                    immunizationObj["reservationTypeId"] = type.id
                    immunizationObj["reservationName"] = type.name

                    array.push(immunizationObj)
                  }
                }

                if (!a) {
                  let c = this.immunizationsForPetType.find((e) => e.id == id)

                  if (c) {
                    let immunizationObj = {}
                    immunizationObj["petImmunizationTypeId"] = c.id
                    immunizationObj["petImmunizationTypeName"] = c.name
                    immunizationObj["reservationTypeId"] = type.id
                    immunizationObj["reservationName"] = type.name

                    let finded = array.find((d) => d.petImmunizationTypeId == c.id)

                    if (finded) {
                      finded.reservationName = finded.reservationName + ', ' + type.name
                    }

                    if (!finded) {
                      array.push(immunizationObj)
                    }
                  }
                }
              })
            }
          })

          obj["immunizations"] = array
          this.immunizationsForPets.push(obj)

          if (array.length > 0) {
            this.immunizationsFound = true
          }

          if (this.forceImmunization && this.immunizationsFound) {
            this.immunizationPassCheck = false
            this.showImmunization = true
          } else if (!this.forceImmunization && this.immunizationsFound) {
            this.immunizationPassCheck = true
            this.showImmunization = true
          } else if (this.forceImmunization && !this.immunizationsFound) {
            this.immunizationPassCheck = true
            this.showImmunization = false
          } else if (!this.forceImmunization && !this.immunizationsFound) {
            this.immunizationPassCheck = true
            this.showImmunization = false
          }

          // if(this.forceImmunization == false){
          //   this.immunizationPassCheck = true
          //   this.showImmunization = false
          // }
        } else {
          // this.showImmunization = true
          let filteredType = types.filter((a) => a.forceImmunization == true)

          if (filteredType.length > 0) {
            this.forceImmunization = true
          }

          types.forEach((type: any) => {
            if(type.immunizationTypeId){
              type.immunizationTypeId.forEach((id: any) => {
                let c = this.immunizationsForPetType.find((e) => e.id == id)
  
                if (c) {
                  let immunizationObj = {}
                  immunizationObj["petImmunizationTypeId"] = c.id
                  immunizationObj["petImmunizationTypeName"] = c.name
                  immunizationObj["reservationTypeId"] = type.id
                  immunizationObj["reservationName"] = type.name
  
                  let finded = array.find((d) => d.petImmunizationTypeId == c.id)
  
                  if (finded) {
                    finded.reservationName = finded.reservationName + ', ' + type.name
                  }
  
                  if (!finded) {
                    array.push(immunizationObj)
                  }
                }
              })
            }
          })

          obj["immunizations"] = array
          this.immunizationsForPets.push(obj)

          if (array.length > 0) {
            this.immunizationsFound = true
          }

          if (this.forceImmunization && this.immunizationsFound) {
            this.immunizationPassCheck = false
            this.showImmunization = true
          } else if (!this.forceImmunization && this.immunizationsFound) {
            this.immunizationPassCheck = true
            this.showImmunization = true
          } else if (this.forceImmunization && !this.immunizationsFound) {
            this.immunizationPassCheck = true
            this.showImmunization = false
          } else if (!this.forceImmunization && !this.immunizationsFound) {
            this.immunizationPassCheck = true
            this.showImmunization = false
          }

          // if(this.forceImmunization == false){
          //   this.immunizationPassCheck = true
          //   this.showImmunization = false
          // }
        }
      },

      (err) => {

      }
    )
  }

  updateImmunization(immunization: any) {
    this.immunizationPassCheck = true

    for (let i = 0; i < this.immunizationsForPets.length; i++) {
      let immunizations: any[] = this.immunizationsForPets[i].immunizations
      let filtered = immunizations.filter((a) => a.status != "PENDING" || !a.status)

      if (filtered.length > 0) {
        this.immunizationPassCheck = false

        return
      }
    }
  }

  getImmunizationsForPetType() {
    this.appService.getImmunizationsForPetType(this.selectedPetID).subscribe(
      (res: any) => {
        if (res.list && res.list.length > 0) {
          this.immunizationsForPetType = res.list
        }
      },

      (err) => {

      }
    )
  }

  getGroupAddOnServices() {
  if(this.organizationKey && this.organizationKey != undefined){     
    this.appService.getGroupAddOnServices(this.organizationKey).subscribe(
      (res: any) => {
        this.groupAddOnServices = res.list
        if(this.selectedServiceMap && this.selectedServiceMap[this.selectedReservationTypeID]){
          let addOns: any[] = this.selectedServiceMap[this.selectedReservationTypeID].addOn
          let array: any = []
  
          this.groupAddOnServices.forEach((a) => {
            array = []
            if (a.serviceGroupServices) {
              let serviceGroupServices: any[] = a.serviceGroupServices
              serviceGroupServices.forEach((b) => {
                let finded = addOns.find((c) => c.id == b)
  
                if (finded) {
                  array.push(finded)
                }
              })
  
              a["addOns"] = array
            }
          })
        }

      },

      (err) => {

      }
    )
  }
  }

  onChangeGroupAddOnServices(service: any) {
    let serviceGroupServices: any[] = service.serviceGroupServices
    let addOns: any[] = this.selectedServiceMap[this.selectedReservationTypeID].addOn

    serviceGroupServices.forEach((addOnId: any) => {
      addOns.forEach((addOn) => {
        if (service.selected) {
          if (addOn.id == addOnId) {
            addOn['dateList'] = JSON.parse(JSON.stringify(this.dateList));
            addOn.selected = true
          }
        }

        if (!service.selected) {
          if (addOn.id == addOnId) {
            addOn['dateList'] = JSON.parse(JSON.stringify(this.dateList));
            addOn.selected = false
          }
        }
      })
    })
  }

  updateGroupAddOnService(addOn: any) {
    let filtered: any[] = this.groupAddOnServices.filter((b) => b.reservationTypeId == this.selectedReservationTypeID && b.serviceGroupServices.includes(addOn.id))

    filtered.forEach((a) => {
      let addOns: any[] = a.addOns
      let selected: any[] = addOns.filter((b) => b.selected == true)

      if (selected.length == addOns.length) {
        a.selected = true
      } else {
        a.selected = false
      }
    })
  }

  checkPropertyPresent(object: any, key: string) {
    if (object.hasOwnProperty(key) && object.parentAddOn == false) {

      return true
    }

    return false
  }

  showPrimaryServices(services: any[]) {
    for (let i = 0; i < services.length; i++) {
      if (services[i].parentAddOn == false) {
        this.showPrimaryServicesInView = true
        return
      }
    }
  }

  showAddOnName(addOns: any[]) {
    let text: string = ''
    addOns.forEach((addOn) => text = text + ', ' + addOn.name)
    this.toolTipText = text.substring(1)
  }

  checkReturnUserEmpty(){
    if(!this.existEmailCtrl || this.existEmailCtrl.value == "" || this.existEmailCtrl.value == null){
      this.returnUserEmailEmpty = "Email is required"
    }
    else{
      this.returnUserEmailEmpty = ""
    }

    if(!this.existPassCtrl || this.existPassCtrl.value == "" || this.existPassCtrl.value == null){
      this.returnUserPassEmpty = "Password is required"
    }
    else{
      this.returnUserPassEmpty = ""
    }
  }

  checkInviteCodeEmpty(){
    if(!this.inviteCodeCtrl || this.inviteCodeCtrl.value == "" || this.inviteCodeCtrl.value == null){
      this.inviteCodeErrMsg = "Invite code is required"
    }
    else{
      this.inviteCodeErrMsg = ""
    }
  }

  checkInviteCodeWithPassword(){
     if(!this.inviteCodePasswordCtrl || this.inviteCodePasswordCtrl.value == "" || this.inviteCodePasswordCtrl.value == null){
      this.inviteCodePasswordErrMsg = "Password is required"
     }
      else{
        this.inviteCodePasswordErrMsg = ""
      }
  }

  checkNewUserEmpty(){
    if(!this.firstNameCtrl || this.firstNameCtrl.value == "" || this.firstNameCtrl.value == null){
      this.firstNameEmpty = "First Name is required"
    }
    else{
      this.firstNameEmpty = ""
    }

    if(!this.lastNameCtrl || this.lastNameCtrl.value == "" || this.lastNameCtrl.value == null){
      this.lastNameEmpty = "Last Name is required"
    }
    else{
      this.lastNameEmpty = ""
    }

    if(!this.phoneCtrl || this.phoneCtrl.value == "" || this.phoneCtrl.value == null){
      this.phoneEmpty = "Phone is required"
    }
    else{
      this.phoneEmpty = ""
    }

    if(!this.newEmailCtrl || this.newEmailCtrl.value == "" || this.newEmailCtrl.value == null){
      this.newEmailEmpty = "Email is required"
    }
    else{
      this.newEmailEmpty = ""
    }

    if(!this.newPassCtrl || this.newPassCtrl.value == "" || this.newPassCtrl.value == null){
      this.newPassEmpty = "Password is required"
    }
    else{
      this.newPassEmpty = ""
    }
     
    if(!this.newCityCtrl || this.newCityCtrl.value == "" || this.newCityCtrl.value == null){
      this.newCityEmpty = "City is required"
    }
    else{
      this.newCityEmpty = ""
    }

    if(!this.newStateCtrl || this.newStateCtrl.value == "" || this.newStateCtrl.value == null){
      this.newStateEmpty = "State is required"
    }
    else{
      this.newStateEmpty = ""
    }

    if(!this.newZipCtrl || this.newZipCtrl.value == "" || this.newZipCtrl.value == null){
      this.newZipEmpty = "Zip is required"
    }
    else{
      this.newZipEmpty = ""
    }
    
    if(!this.newStreetCtrl || this.newStreetCtrl.value == "" || this.newStreetCtrl.value == null){
      this.streetAddressEmpty = "Address is required"
    }
    else{
      this.streetAddressEmpty = ""
    }

  
  }

  googlePlacesSearch(){
    this.googlPlacesApi.api.then((maps) => {
      this.initAutocompleteAddress(maps);
    });
  }

  googlePlacesSearchInvite(){
    this.googlPlacesApi.api.then((maps) => {
      this.initAutocompleteAddressInvite(maps);
    });
  }

  
  initAutocompleteAddress(maps:Maps) {
    var autocomplete = new maps.places.Autocomplete(
      this.searchElementRef.nativeElement,{componentRestrictions: { country: ["us"] },fields: ["address_components", "geometry", "formatted_address"],
      types: ["address"],}
    );
    autocomplete.addListener('place_changed', () => {
      let place = autocomplete.getPlace();
      let address1 = "";
      let postcode = "";
      let locality = "";
      let country = "";
      let state = "";
      for (const component of place.address_components) {
        const componentType = component.types[0];
        switch (componentType) {
          case "street_number": {
            address1 = `${component.long_name} ${address1}`;
            break;
          }
          case "route": {
            address1 += component.short_name;
            break;
          }
          case "postal_code": {
            postcode = `${component.long_name}${postcode}`;
            break;
          }
          case "locality":
            locality = component.long_name;
            break;
          case "administrative_area_level_1": {
            state = component.long_name;
            break;
          }
          case "country":
            country = component.long_name;
            break;
        }
      }
      this.newCityCtrl.setValue(locality);
      this.newStateCtrl.setValue(state);
      this.newZipCtrl.setValue(postcode);
      this.newStreetCtrl.setValue(address1);
      this.cdr.detectChanges();
    }); 
  }

  initAutocompleteAddressInvite(maps:Maps){
    setTimeout(() => {
      // Your code goes here
      const addressInput = document.getElementById('searchGoogleAddressInputInvite') as HTMLInputElement;
      var autocomplete2 = new maps.places.Autocomplete(
        addressInput,{componentRestrictions: { country: ["us"] },fields: ["address_components", "geometry", "formatted_address"],
        types: ["address"],}
      );
      autocomplete2.addListener('place_changed', () => {
        let place = autocomplete2.getPlace();
        let address1 = "";
        let postcode = "";
        let locality = "";
        let country = "";
        let state = "";
        for (const component of place.address_components) {
          const componentType = component.types[0];
          switch (componentType) {
            case "street_number": {
              address1 = `${component.long_name} ${address1}`;
              break;
            }
            case "route": {
              address1 += component.short_name;
              break;
            }
            case "postal_code": {
              postcode = `${component.long_name}${postcode}`;
              break;
            }
            case "locality":
              locality = component.long_name;
              break;
            case "administrative_area_level_1": {
              state = component.long_name;
              break;
            }
            case "country":
              country = component.long_name;
              break;
          }
        }
        this.inviteCityCtrl.setValue(locality);
        this.inviteStateCtrl.setValue(state);
        this.inviteZipCtrl.setValue(postcode);
        this.inviteStreetCtrl.setValue(address1);
        this.cdr.detectChanges();
      }); 
    }, 1000);

    
  }

  validateUserAddress(type:any){
    if(!this.showAddressField){
        return true; 
    }
    if(!this.inviteCityCtrl || this.inviteCityCtrl.value == "" || this.inviteCityCtrl.value == null){
      this.inviteCityEmpty = "City is required"
    }
    else{
      this.inviteCityEmpty = ""
    }

    if(!this.inviteStateCtrl || this.inviteStateCtrl.value == "" || this.inviteStateCtrl.value == null){
      this.inviteStateEmpty = "State is required"
    }
    else{
      this.inviteStateEmpty = ""
    }

    if(!this.inviteZipCtrl || this.inviteZipCtrl.value == "" || this.inviteZipCtrl.value == null){
      this.inviteZipEmpty = "Zip is required"
    }
    else{
      this.inviteZipEmpty = ""
    }

    if(!this.inviteStreetCtrl || this.inviteStreetCtrl.value == "" || this.inviteStreetCtrl.value == null){
      this.inviteStreetEmpty = "Address is required"
    }
    else{
      this.inviteStreetEmpty = ""
    }

    if(this.inviteCityEmpty == "" && this.inviteStateEmpty == "" && this.inviteZipEmpty == "" && this.inviteStreetEmpty == ""){
        this.updateUserAddress();
        return true
    }
    else{
      return false;
    }
  }

  updateUserAddress(){
    if(this.inviteCityEmpty == "" && this.inviteStateEmpty == "" && this.inviteZipEmpty == "" && this.inviteStreetEmpty == ""){
      this.isLoading = true
      let request = {
        city: this.inviteCityCtrl.value,
        state: this.inviteStateCtrl.value,
        zipCode: this.inviteZipCtrl.value,
        line1: this.inviteStreetCtrl.value,
        displayAddress: this.inviteStreetCtrl.value + ", " + this.inviteCityCtrl.value + ", " + this.inviteStateCtrl.value + ", " + this.inviteZipCtrl.value
      }
      this.appService.updateUserAddress(request,this.userObj['id']).subscribe(
        (res: any) => {
          this.isLoading = false
          this.addressSaved = true
          // Swal.fire({
          //   icon: 'success',
          //   title: 'Address saved successfully',
          //   showConfirmButton: false,
          //   timer: 1500
          // })
        },
        (err) => {
          this.isLoading = false
        }
      )
    }
  
  }

  getUserCards() {
    this.infoService.GetCard().subscribe((res: any) => {
      if (res) {
        this.appService.savedCards = res.list;
        if(res.list && res.list.length >0){
          var filterActiveCard = res.list.filter((card:any) => card.active);
          if(filterActiveCard && filterActiveCard.length > 0){
            this.showSavedCard = true;
            this.activeCards = filterActiveCard;
            var filterCVVRequired = this.activeCards.filter((card:any) => card.ccvRequired);
            if(filterCVVRequired && filterCVVRequired.length > 0){
              this.cardColumns = ['details' , 'cvvDetails'];
            }
          }
        }
      }
    })
  }

  handleCardChange(change: MatRadioChange) {
    this.selectedSavedCard = change.value;
  }

  validateNumberInput(event: KeyboardEvent) {
    const allowedChars = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
  
    if (!allowedChars.test(inputChar)) {
      event.preventDefault();
    }
  }

  comparePets(pet1: any, pet2: any) {
    return pet1 && pet2 ? pet1.petKey === pet2.petKey : pet1 === pet2;
  }

  getDatesForPrimaryAddOn(startDate, key, obj) {
    return new Promise<void>((resolve, reject) => {
      this.appService.getCalendarDates_new(startDate, key, this.locationTimezone, null).subscribe(
        res => {
          let month = startDate.format('MMMM');
          this.calendarObj[key][month] =res["list"] ? res["list"] : [];
          resolve();
        },
        error => {
          console.log("error", error);
          reject(error);
        }
      );
    });
  }

  isReservationHasGroupAddOn(){
    let find = this.groupAddOnServices.find(x => x.reservationTypeId == this.selectedReservationTypeID);
    if(find){
      return true;
    }
    return false;
  }

  isReservationHasAddOn(){
    let find = this.selectedServiceMap[this.selectedReservationTypeID].addOn.find(x => x.addOn == true && (!x.parentServiceBasedOn || x.parentAddOn == true));
    if(find){
      return true;
    }
    return false;
  }

  // MEMBERSHIP AND PACKAGE 
  onPurchaseTypeChange(event: MatRadioChange) {
    this.selectedPurchaseType = event.value;
    this.selectedMembership = undefined;
    this.selectedPackage = undefined;
    this.hasCoupon = false;
    this.hasvalidCoupon = false;
    this.value=false;
    this.infoService.selectedPurchaseType = this.selectedPurchaseType
    if (this.selectedPurchaseType == 'membership') {
      if (this.membershipList.length == 0) {
        this.getMembership();
      }
    }else if(this.selectedPurchaseType == 'package'){
      if (this.packageList.length == 0) {
        this.getPackages();
      }
    }else if(this.selectedPurchaseType == 'training'){
      if (this.trainingList.length == 0) {
        this.getTraining();
      }
    }
  }

  getMembership() {
    this.isLoading = true;
    this.appService.getMembershipExternal().subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res.data && res.data.content) {
          this.membershipList = res.data.content.filter((item: any) => item.reservationServices && item.reservationServices.service && item.reservationServices.service.priceTiers && item.reservationServices.service.priceTiers.length > 0 && item.showInApp);
          this.membershipList = this.membershipList.sort((a,b) => a.orderNo - b.orderNo);
          if(!this.petTypes || this.petTypes.length == 0){

          }
          this.membershipList.forEach((membership: any) => {
            if (membership.ruleJson) {
              var json = JSON.parse(membership.ruleJson);
              for (var i = 0; i < json.length; i++) {
                json[i].selected = false;
                for (var z = 0; z < json[i].rule.length; z++) {
                  var indexSer = membership.services.findIndex(x => x.id == json[i].rule[z].serviceId)
                  if (indexSer >= 0) {
                    json[i].rule[z].name = membership.services[indexSer].name
                  }
                }
              }
              membership.serviceRules = json;
            }
            let petType = this.petTypes.find((item: any) => item.id == membership.petTypeId);
            if (petType) {

              membership.petTypeName = petType.name;

              if (petType.genders && petType.genders.length > 0 && membership.gender && membership.gender != '') {
                let name = "";
                let genderIds = membership.gender.split(',')
                genderIds.forEach((id: any) => {
                  let find = petType.genders.find((item: any) => item.id == id);
                  if (find) {
                    name = name == '' ? find.name : name + ', ' + find.name;
                  }
                })
                membership.genderAllowed = name;
              }

              if (membership.requiredMinimumAge && membership.requiredMinimumAge != 0 && membership.requiredMaximumAge != '') {
                membership.petMinAge = (Math.floor(membership.requiredMinimumAge / 12) > 0 ? Math.floor(membership.requiredMinimumAge / 12) + " years" : '') + (membership.requiredMinimumAge % 12 > 0 ? " " + membership.requiredMinimumAge % 12 + " months" : "");
              }
            }
            membership.totalPrice = (membership.reservationServices.service.priceTiers[0].amount + (membership.reservationServices.service.priceTiers[0].amount * (membership.reservationServices.service.taxPercentage ? membership.reservationServices.service.taxPercentage : 0) / 100)).toFixed(2);
          });
        }
      },
      (err) => {
        this.isLoading = false;
      }
    )
  }

  openPanel() {
    this.isPanelOpen = true;
  }

  onMembershipSelect($event: any, membership: any) {
    this.selectedMembership = membership;
    this.selectedPetID = membership.petTypeId;
    this.infoService.getPetTypeId(this.selectedPetID);
    this.infoService.petTypeId = this.selectedPetID;
    this.newPetID = this.selectedPetID;
    var petType = this.petTypes.find(o => o.id == this.selectedPetID);
    this.selectedPetName = petType.name;
    this.getReservationTypes(petType);
    this.addPetGender(petType);
    this.getPetBreed(petType);
  }

  async onMembershipPetChange(pet) {
    pet.selected = !pet.selected;
    if (pet.selected) {
      if(this.selectedPurchaseType == 'membership'){
        this.checkWithPet(pet);
      }
      else {
        let totalSelectedPet = this.userPets.filter(x => x.selected == true);
        if (totalSelectedPet.length > (this.selectedSession.maxCapacity - this.selectedSession.totalPet) && this.selectedSession.groupService.enrollmentType == 'FIXED_CLASS_SCHEDULE') {
          pet.selected.selected = false
          Swal.fire("", "You cannot select more than " + (this.selectedSession.maxCapacity - this.selectedSession.totalPet) + " pets for this session.", 'warning');
          return;
        }
        else {
          await this.appService.checkPetAlreadyEnrolled(pet, this.selectedSession, this.organizationKey, this.userObj['id']).subscribe(
            (res: any) => {
              if (res.data && res.data.content && res.data.content.length > 0) {
                pet.selected = false;
                Swal.fire("", "You are already enrolled in a group-based training session", 'warning');
                return;
              }
              else {
                this.checkPetValidationForTraining(pet)
              }
            })
        }
      }
    }
  }

  checkWithPet(pet: any) {
    this.ageRequired = false;
    this.genderRequired = false;
    this.weightMandatory = false;
    if (pet.type && (pet.type.id != this.selectedMembership.petTypeId)) {
      pet.selected = false;
      Swal.fire("", "The selected pet type is not permitted for this membership. Please choose a different pet", 'warning');
    }
    if (this.selectedMembership.restrictByPetCount && this.selectedMembership.restrictByPetCount == true) {
      var selectedPet = this.userPets.filter(x => x.selected == true);
      if (selectedPet.length > this.selectedMembership.maxPetsAllowedOnPurchase) {
        pet.selected = false;
        Swal.fire("", "Please select only " + this.selectedMembership.maxPetsAllowedOnPurchase + "pets for " + this.selectedMembership.name, 'warning');
      }
    }

    if (pet.selected && this.selectedMembership.gender && this.selectedMembership.gender != '') {
      if (pet.gender && pet.gender.id) {
        let genderIds = this.selectedMembership.gender.split(',');
        let genderId = pet.gender.id.toString();
        let isGenderValid = genderIds.includes(genderId)
        if (!isGenderValid) {
          Swal.fire({
            title: "The pet sex for this membership is not matching and you cannot select this pet.",
            icon: "warning",
            allowOutsideClick: false,
            buttons: {
              confirm: {
                text: "Okay",
                value: true,
                visible: true,
                className: "btn btn-primary",
                closeModal: true
              }
            }
          }).then(function () {
            pet.selected = false;
          });
        }
        else {
          this.validatePetAgeForMembership(pet)
        }
      }
      else {
        this.genderRequired = true;
        this.validatePetAgeForMembership(pet)
      }
    }
    else {
      this.validatePetAgeForMembership(pet)
    }
  }

  validatePetAgeForMembership(pet: any) {
    if (pet.selected) {
      if (this.selectedMembership.requiredMinimumAge && this.selectedMembership.requiredMinimumAge != "") {
        var requiredMessage = '';
        var requiredYears = Math.floor(this.selectedMembership.requiredMinimumAge / 12);
        var requiredMonths = this.selectedMembership.requiredMinimumAge % 12;
        if (requiredYears > 0) {
          requiredMessage += requiredYears + ' year' + (requiredYears > 1 ? 's' : '');
        }
        if (requiredMonths > 0) {
          requiredMessage += (requiredYears > 0 ? ' and ' : '') + requiredMonths + ' month' + (requiredMonths > 1 ? 's' : '');
        }
        if (!pet.dateOfBirth || pet.dateOfBirth == null || pet.dateOfBirth == "") {
          this.ageRequired = true;
        }
        else {
          var dateOfBirth = moment().diff(pet.dateOfBirth, 'months')
          if (dateOfBirth < this.selectedMembership.requiredMinimumAge) {
            var years = Math.floor(dateOfBirth / 12);
            var months = dateOfBirth % 12;
            var message = '';
            if (years > 0) {
              message += years + ' year' + (years > 1 ? 's' : '');
            }
            if (months > 0) {
              message += (years > 0 ? ' and ' : '') + months + ' month' + (months > 1 ? 's' : '');
            }
            if(message == ''){
              message = 'less than a month';
            }
            Swal.fire({
              title: "This membership requires minimum pet age of " + requiredMessage + " , while checking in." + "\n" + pet.name + " is currently " + message + "\n" + "Are you sure you want to continue?",
              icon: "warning",
              cancelButtonText: "Cancel",
              confirmButtonText: "Continue",
              allowOutsideClick: false,
              closeOnClickOutside: false,
              buttons: [
                'Cancel',
                'Continue'
              ],
            }).then(function (isConfirm) {
              if (!isConfirm) {
                pet.selected = false;
              }
            });
          }
        }
      }
    }

    if (this.ageRequired || this.genderRequired) {
      pet.selected = false;
      var message = '';

      if (this.ageRequired && this.genderRequired) {
        message = 'This membership requires age and gender to be defined for pet';
      } else if (this.ageRequired) {
        message = 'This membership requires age to be defined for pet';
      } else if (this.genderRequired) {
        message = 'This membership requires gender to be defined for pet';
      }

      Swal.fire({
        text: message,
        icon: 'warning',
        allowOutsideClick: false,
        confirmButtonText: 'OK'
      });
      this.updatePetObj = pet;
      this.pageShowType ='editPets'
      this.petNameCtrl.setValue(pet.name);
      this.selectedPetGender = pet.gender ? pet.gender.id : undefined;
      this.selectedPetBread = pet.breed ? pet.breed.id : undefined;
      this.petWeight = pet.weight;
      this.petColor = pet.color;
    }
  }

  checkPetValidationForTraining(pet: any) {
    this.ageRequired = false;
    this.genderRequired = false;
    this.weightMandatory = false;

    if (pet.type && (pet.type.id != this.selectedPetID)) {
      pet.selected = false;
      Swal.fire("", "The selected pet type is not permitted for this training service. Please choose a different pet", 'warning');
    }

    var weightNotValid = false;
    if(pet.selected && this.selectedSession && this.selectedSession.weightFrom && this.selectedSession.weightTo){
      if(!pet.weight){
        this.weightMandatory = true;
      }
      else if(pet.weight < this.selectedSession.weightFrom || pet.weight > this.selectedSession.weightTo){
        weightNotValid = true;
      }
    }

    if (this.selectedSession && pet.selected && this.selectedSession.gender && this.selectedSession.gender != '') {
      if (pet.gender && pet.gender.id) {
        let genderIds = this.selectedSession.gender.split(',');
        let genderId = pet.gender.id.toString();
        let isGenderValid = genderIds.includes(genderId)
        if (!isGenderValid) {
          Swal.fire({
            title: "The pet sex for this training is not matching and you cannot select this pet.",
            icon: "warning",
            allowOutsideClick: false,
            buttons: {
              confirm: {
                text: "Okay",
                value: true,
                visible: true,
                className: "btn btn-primary",
                closeModal: true
              }
            }
          }).then(function () {
            pet.selected = false;
          });
        }
        else {
          this.validatePetAgeForTraining(pet, this.selectedSession,weightNotValid)
        }
      }
      else {
        this.genderRequired = true;
        this.validatePetAgeForTraining(pet, this.selectedSession,weightNotValid)
      }
    }
    else{
      this.validatePetAgeForTraining(pet, this.selectedSession,weightNotValid)
    }
  }

  validatePetAgeForTraining(pet: any,selectedItem:any,weightNotValid:boolean) {
    if (pet.selected) {
      if (selectedItem.requiredMinimumAge && selectedItem.requiredMinimumAge != "") {
        var requiredMessage = '';
        var requiredYears = Math.floor(selectedItem.requiredMinimumAge / 12);
        var requiredMonths = selectedItem.requiredMinimumAge % 12;
        if (requiredYears > 0) {
          requiredMessage += requiredYears + ' year' + (requiredYears > 1 ? 's' : '');
        }
        if (requiredMonths > 0) {
          requiredMessage += (requiredYears > 0 ? ' and ' : '') + requiredMonths + ' month' + (requiredMonths > 1 ? 's' : '');
        }
        if (!pet.dateOfBirth || pet.dateOfBirth == null || pet.dateOfBirth == "") {
          this.ageRequired = true;
        }
        else {
          var dateOfBirth = moment().diff(pet.dateOfBirth, 'months')
          if (dateOfBirth < selectedItem.requiredMinimumAge) {
            var years = Math.floor(dateOfBirth / 12);
            var months = dateOfBirth % 12;
            var message = '';
            if (years > 0) {
              message += years + ' year' + (years > 1 ? 's' : '');
            }
            if (months > 0) {
              message += (years > 0 ? ' and ' : '') + months + ' month' + (months > 1 ? 's' : '');
            }
            if(message == ''){
              message = 'less than a month';
            }
            if(this.selectedSession.forceAge){
              Swal.fire({
                title: "This training requires minimum pet age of " + requiredMessage + "\n" + pet.name + " is currently " + message ,
                icon: "warning",
                confirmButtonText: "Okay",
                allowOutsideClick: false,
                closeOnClickOutside: false,
                showCancelButton: false,
              }).then(function (isConfirm) {
                pet.selected = false;
              });   
            }
            else if(weightNotValid && this.selectedSession.forceWeight){
              Swal.fire({
                title: "Weight of the pet is not in the range of selected training session",
                icon: "warning",
                confirmButtonText: "Okay",
                allowOutsideClick: false,
                closeOnClickOutside: false,
                showCancelButton: false,
              }).then(function (isConfirm) {
                pet.selected = false;
              });
            }
            else{
              let content = "This training requires minimum pet age of " + requiredMessage + "\n" + pet.name + " is currently " + message ;
              if (weightNotValid) {
                content += "\n" + "Weight of the pet is not in the range of selected training session"
              }
              content +=  "\n" + "Are you sure you want to continue?"
              Swal.fire({
                title: content,
                icon: "warning",
                cancelButtonText: "Cancel",
                confirmButtonText: "Continue",
                allowOutsideClick: false,
                closeOnClickOutside: false,
                buttons: [
                  'Cancel',
                  'Continue'
                ],
              }).then(function (isConfirm) {
                if (!isConfirm) {
                  pet.selected = false;
                }
              });
            }
          }
          else if(weightNotValid){
            if (this.selectedSession.forceWeight) {
              Swal.fire({
                title: "Weight of the pet is not in the range of selected training session",
                icon: "warning",
                confirmButtonText: "Okay",
                allowOutsideClick: false,
                closeOnClickOutside: false,
                showCancelButton: false,
              }).then(function (isConfirm) {
                pet.selected = false;
              });
            }
            else{
              Swal.fire({
                title: "Weight of the pet is not in the range of selected training session" + "\n" + "Are you sure you want to continue?",
                icon: "warning",
                cancelButtonText: "Cancel",
                confirmButtonText: "Continue",
                allowOutsideClick: false,
                closeOnClickOutside: false,
                buttons: [
                  'Cancel',
                  'Continue'
                ],
              }).then(function (isConfirm) {
                if (!isConfirm) {
                  pet.selected = false;
                }
              });
            }
          }
        }
      }
      else if(weightNotValid){
        if (this.selectedSession.forceWeight) {
          Swal.fire({
            title: "Weight of the pet is not in the range of selected training session",
            icon: "warning",
            confirmButtonText: "Okay",
            allowOutsideClick: false,
            closeOnClickOutside: false,
            showCancelButton: false,
          }).then(function (isConfirm) {
            pet.selected = false;
          });
        }
        else{
          Swal.fire({
            title: "Weight of the pet is not in the range of selected training session" + "\n" + "Are you sure you want to continue?",
            icon: "warning",
            cancelButtonText: "Cancel",
            confirmButtonText: "Continue",
            allowOutsideClick: false,
            closeOnClickOutside: false,
            buttons: [
              'Cancel',
              'Continue'
            ],
          }).then(function (isConfirm) {
            if (!isConfirm) {
              pet.selected = false;
            }
          });
        }
      }
    }

    if (this.ageRequired || this.genderRequired || this.weightMandatory) {
      pet.selected = false;
      var message = '';
      let requirements = [];

      if (this.ageRequired) requirements.push('age');
      if (this.genderRequired) requirements.push('gender');
      if (this.weightMandatory) requirements.push('weight');
      
      if (requirements.length > 0) {
        message = `This training requires ${requirements.join(', ')} to be defined for the pet`;
      }

      Swal.fire({
        title: message,
        allowOutsideClick: false,
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      this.updatePetObj = pet;
      this.pageShowType ='editPets'
      this.petNameCtrl.setValue(pet.name);
      this.selectedPetGender = pet.gender ? pet.gender.id : undefined;
      this.selectedPetBread = pet.breed ? pet.breed.id : undefined;
      this.petWeight = pet.weight;
      this.petColor = pet.color;
    }
  }

  updatePet(){
    this.updatePetObj.name = this.petNameCtrl.value;
    this.updatePetObj.dateOfBirth = this.petBirth;
    this.updatePetObj.gender = {"id" : this.selectedPetGender ? this.selectedPetGender : null};
    if(this.petWeight && this.petWeight != 0){
      this.updatePetObj.weight = this.petWeight;
    }
    if(this.selectedVetDetails){
      this.updatePetObj.veterinarian = {id : this.selectedVetDetails.id};
    }

    if(this.selectedPetBread){
      this.updatePetObj.breed = {"id" : this.selectedPetBread};
    }

    this.appService.updatePet(this.updatePetObj).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.getPetsAndNext(this.userObj['id'],false);
        this.petNameCtrl.reset();
        this.selectedPetGender = null;
        this.selectedPetBread = null;
        this.petWeight = 0;
        this.bsValue = undefined;
      },
      (err) => {
        this.pageShowType = 'showpets';
      }
    )
  }

  getUserMembershipAgreement(type:string) {
    this.showAgreement = false;
    this.agreementPassCheck = true;
    var param = ''
    if(type == 'membership'){
       param += '?serviceId=' + this.selectedMembership.reservationServices.id;
      for (var i = 0; i < this.userPets.length; i++) {
        if (this.userPets[i].selected) {
          param += '&petKey=' + this.userPets[i].petKey;
        }
      }
      param += '&type=WEB&agreementSourceType=MEMBERSHIP'
    }
    else{
      param += '?type=WEB&agreementSourceType=GROUP_BASED&serviceId=' + this.selectedSession.groupService.id
      for (var i = 0; i < this.userPets.length; i++) {
        if (this.userPets[i].selected) {
          param += '&petKey=' + this.userPets[i].petKey;
        }
      }
    }
    this.petOwnersAgreements = []
    this.appService.getMembershipAgreement(param).subscribe(
      (res: any) => {
        this.membershipAgreement = res.list;
        if(this.membershipAgreement && this.membershipAgreement.length > 0){
          if(this.selectedPurchaseType == 'membership'){
            var filter = this.membershipAgreement.filter(x => x.userAgreementStatus != 'SIGNED' && x.agreement.forceWhileMembershipPurchase);
            if(filter && filter.length > 0){
              this.agreementPassCheck = false;
              this.showAgreement = true;
            }
          }
          else if(this.selectedPurchaseType == 'training'){
            var filter = this.membershipAgreement.filter(x => x.userAgreementStatus != 'SIGNED' && x.agreement.forceAgreement);
            if(filter && filter.length > 0){
              this.agreementPassCheck = false;
              this.showAgreement = true;
            } 
          }
          let petOwnerAgreement = res.list.filter((item: any) => item.userAgreementStatus != "SIGNED" && item.subject != 'PET')
          if(petOwnerAgreement.length > 0){
            for(let i = 0; i < petOwnerAgreement.length; i++){
              var find = this.petOwnersAgreements.find((item) => item.agreementId == petOwnerAgreement[i].agreement.id)
              if(!find){
                let item = petOwnerAgreement[i]
                let agreementFor = this.userPets.find(x => x.petKey == item.subjectKey);
                if(!agreementFor){
                  agreementFor = this.userObj['firstName'] 
                }
                else{
                  agreementFor = agreementFor.name;
                }
                let agreementObj: any = {
                  id: item.id,
                  name: item.agreement.name,
                  content: item.agreement.content,
                  status: item.userAgreementStatus,
                  userId: item.user.id,
                  subject: item.subject,
                  subjectKey: item.subjectKey, 
                  agreementId: item.agreement.id,
                  agreementFor : agreementFor
                }
                if (item.signatureTime) {
                  agreementObj['signatureTime'] = item.signatureTime
                }
                if (item.signedDate) {
                  agreementObj['signedDate'] = item.signedDate
                }
                if (item.expirationDate) {
                  agreementObj['expirationDate'] = item.expirationDate
                }
                if (item.agreement) {
                  if (item.agreement.forceAgreement) {
                    agreementObj['forceAgreement'] = item.agreement.forceAgreement
    
                    if (item.agreement.forceAgreement == true) {
                      this.forceAgreement = true
                    }
                  } else {
                    agreementObj['forceAgreement'] = false
                  }
                }
                this.petOwnersAgreements.push(agreementObj)
              }
            }
          }
          let filtered: any[] = this.membershipAgreement.filter((item: any) => item.userAgreementStatus != "SIGNED" && item.subject == 'PET')
          let agreements = []
          filtered.forEach((item: any) => {
            let agreementFor = this.userPets.find(x => x.petKey == item.subjectKey);
            if(!agreementFor){
              agreementFor = this.userObj['firstName']
            }
            else{
              agreementFor = agreementFor.name;
            }
            let agreementObj: any = {
              id: item.id,
              name: item.agreement.name,
              content: item.agreement.content,
              status: item.userAgreementStatus,
              userId: item.user.id,
              subject: item.subject,
              subjectKey: item.subjectKey, 
              agreementId: item.agreement.id,
              agreementFor : agreementFor
            }
            if (item.signatureTime) {
              agreementObj['signatureTime'] = item.signatureTime
            }
            if (item.signedDate) {
              agreementObj['signedDate'] = item.signedDate
            }
            if (item.expirationDate) {
              agreementObj['expirationDate'] = item.expirationDate
            }
            if (item.agreement) {
              if (item.agreement.forceAgreement) {
                agreementObj['forceAgreement'] = item.agreement.forceAgreement

                if (item.agreement.forceAgreement == true) {
                  this.forceAgreement = true
                }
              } else {
                agreementObj['forceAgreement'] = false
              }
            }
            agreements.push(agreementObj)
          });

          this.agreementsRequired = agreements
          for(var i = 0 ; i < this.petOwnersAgreements.length; i++){
            var find = this.agreementsRequired.find((item) => item.agreementId == this.petOwnersAgreements[i].agreementId.id)
            if(!find){
              this.agreementsRequired.push(this.petOwnersAgreements[i])
            }
          }
        }
      },
      (err) => {
        this.showAgreement = false;
      }
    )
  }

  showAgreements(agreements: any[]): boolean {
    if (agreements.length > 0) {
      return true
    }
    return false
  }

  formatDate(date: any, format: any) {
    let datePipe = new DatePipe('en-US')
    return datePipe.transform(date, format)
  }

  openAgreement(data: any) {
    let dialogRef = this.matDialog.open(AgreementComponent, {
      width: '80%',
      data: data,
      height : '90%'
    })

    dialogRef.componentInstance.submitted.subscribe((value: any) => {
      data.status = "SIGNED";
      data.signedDate = moment().format('x');
      let isAllSigned = this.agreementsRequired.filter((item: any) => item.status != "SIGNED")
      if (isAllSigned.length == 0) {
        this.agreementPassCheck = true
      }
    })
  }

  showImmunizations(immunizations: any[]): boolean {
    if (immunizations.length > 0) {
      return true
    }
    return false
  }

  showAddImmunizationDialog(data) {
    let dialogRef = this.matDialog.open(AddImmunizationComponent, {
      // height: '65%',
      width: '35%',
      data: data
    })

    dialogRef.componentInstance.submitted.subscribe((immunization: any) => {
      this.updateImmunization(immunization)
    })
  }

  getMembershipStartDate(){
    if(this.selectedMembership.subscriptionEffectiveDate && this.selectedMembership.subscriptionEffectiveDate != ''){
      return moment(this.selectedMembership.subscriptionEffectiveDate).isAfter(moment())? moment(this.selectedMembership.subscriptionEffectiveDate).format('MM/DD/YYYY') : moment().format('MM/DD/YYYY');
    }
    else{
      return moment().format('MM/DD/YYYY');
    }
  }

  membershipStartDateChange(event:any){
    moment.tz.setDefault(this.locationTimezone);
    let month = Number(this.selectedMembership.startDate.getMonth() + 1) > 9 ? Number(this.selectedMembership.startDate.getMonth() + 1) : '0' + Number(this.selectedMembership.startDate.getMonth() + 1);
    let day = this.selectedMembership.startDate.getDate() > 9 ? this.selectedMembership.startDate.getDate() : '0' + this.selectedMembership.startDate.getDate();
    let year = this.selectedMembership.startDate.getFullYear();
    let slashFormat = month + '/' + day + '/' + year;
    this.selectedMembership.effectiveDate = slashFormat;
  }

  async makePaymentForMembership(isSavedCard:boolean){
    this.disablePayDepositBtn = true
    var hasvalidCoupon = false;
    if (isSavedCard) {
      if (!this.selectedSavedCard) {
        Swal.fire({
          title: 'Warning',
          icon: 'warning',
          html: '<p style="font-size:15px;text-align:center">Please select a card</p>',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        })
        this.disablePayDepositBtn = false
        return
      }

      if (this.selectedSavedCard.ccvRequired && !this.selectedSavedCard.cvvValue || this.selectedSavedCard.cvvValue == "") {
        Swal.fire({
          title: 'Warning',
          icon: 'warning',
          html: '<p style="font-size:15px;text-align:center">Please enter cvv</p>',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        })
        this.disablePayDepositBtn = false
        return
      }

      if (this.selectedSavedCard.ccvRequired && this.selectedSavedCard.cvvValue.length < 3) {
        Swal.fire({
          title: 'Warning',
          icon: 'warning',
          html: '<p style="font-size:15px;text-align:center">Please enter valid cvv</p>',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        })
        this.disablePayDepositBtn = false
        return
      }

    }
 
    let pets = []
    for(let i=0; i<this.userPets.length; i++){
      if(this.userPets[i].selected){ 
        pets.push({petKey:this.userPets[i].petKey})
      }
    }
    var value = {
      autoProcess : this.selectedMembership.autoRenewal === true || this.selectedMembership.autoRenewal === "true" ? true : false,
      effectiveDate: moment(this.selectedMembership.effectiveDate, 'MM/DD/YYYY').format('x'),
      membership:{id:this.selectedMembership.id},
      user:{userKey:this.userObj['id']},
      pets:pets
    }
    this.showPageContentLoader()
    this.appService.createMembershipSubscription(value).subscribe(
      (res: any) => {
        this.selectedMembership.subscriptionId = res.data.id
        this.getMembershipInvoiceDetails(isSavedCard,this.couponDetails)
        
      },
      (err) => {
        this.hidePageContentLoader()
        this.isLoading = false;
        this.disablePayDepositBtn = false
      }
    )
  }

  getMembershipInvoiceDetails(isSavedCard:boolean,couponDetails:any){
    let data = {
      invoiceType: "MEMBERSHIP",
      invoice: "INVOICE",
      invoiceVersion : 'V1',
      saveInvoice: true,
      itemTotal: parseFloat(this.selectedMembership.totalPrice).toFixed(2),
      status: "OPEN",
      payableAmount: parseFloat(this.selectedMembership.totalPrice).toFixed(2),
      itemGroups:[],
      customerVO:{}
    }
    var taxAmount:any = (this.selectedMembership.reservationServices.service.priceTiers[0].amount * (this.selectedMembership.reservationServices.service.taxPercentage ? this.selectedMembership.reservationServices.service.taxPercentage : 0) / 100).toFixed(2)
    var total:number = parseFloat(this.selectedMembership.totalPrice)
    var listOfItems = [];

    var itemGroupObj = {
      amount:this.selectedMembership.reservationServices.service.priceTiers[0].amount,
      code:this.selectedMembership.subscriptionId,
      name : this.selectedMembership.name + '-' + this.selectedMembership.petNames,
      paid : false,
      payableAmount : this.selectedMembership.totalPrice,
      quantity:1,
      tax : this.selectedMembership.reservationServices.service.taxPercentage ? this.selectedMembership.reservationServices.service.taxPercentage : 0,
      taxAmount : (this.selectedMembership.reservationServices.service.priceTiers[0].amount * (this.selectedMembership.reservationServices.service.taxPercentage ? this.selectedMembership.reservationServices.service.taxPercentage : 0) / 100).toFixed(2),
      total :parseFloat(this.selectedMembership.reservationServices.service.priceTiers[0].amount).toFixed(2),
      type  : 'MEMBERSHIP'
    }
    listOfItems.push(itemGroupObj);

    if(this.hasvalidCoupon && couponDetails){
      var discount:any = 0;
      var text = ''
      if(couponDetails.discountMode == 'PERCENT' ){
        discount = (couponDetails.discountValue / 100) * total;
        text = 'Coupon : ' + this.couponCode + ' (' + couponDetails.discountValue + '%)';
        total = total - discount;
        taxAmount = total * (this.selectedMembership.reservationServices.service.taxPercentage ? this.selectedMembership.reservationServices.service.taxPercentage : 0) / 100
      }
      else{
        text = 'Coupon : ' + this.couponCode + ' ( $' + couponDetails.discountValue + ')';
        discount = couponDetails.discountValue;
        total = total - couponDetails.discountValue;
        taxAmount = total * (this.selectedMembership.reservationServices.service.taxPercentage ? this.selectedMembership.reservationServices.service.taxPercentage : 0) / 100
      }
      discount = parseFloat(discount).toFixed(2);
      discount = -Math.abs(discount);
      var couponItem = {
        amount:discount,
        code: couponDetails.id,
        name : text,
        paid : false,
        payableAmount : discount,
        quantity:1,
        tax : 0,
        taxAmount : 0.0,
        total :discount,
        type  : 'COUPON_ADJUSTMENT'
      }
      listOfItems.push(couponItem);
    }

    if (listOfItems.length > 0) {
      data.itemGroups = [{ name: "Membership Subscription", payableAmount: total, taxAmount: taxAmount, items: listOfItems }];
    }
    if (this.userObj) {
      data.customerVO = {
        "userKey": this.userObj['id'],
        "email": this.userObj.email,
        "firstName": this.userObj.firstName,
        "lastName": this.userObj.lastName
      };

      if (data.invoiceType == "MEMBERSHIP" && this.selectedMembership && this.selectedMembership.subscriptionId) {
        data.itemGroups[0].items[0].code = this.selectedMembership.subscriptionId;
      }

      var payment = {
        "paymentType": "Credit",
        "transactionType": "Sale",
        "paymentMode": "CARD_NOT_PRESENT",
        "amount": total,
        "appSource": "WEB",
        "loggedInUser": {userKey : this.userObj['id']} ,
        "customerInitiated": true,
        "recurring": false,
        "merchantTokenId":'',
        "cardType":'',
        'paidAmount': total,
      }

      var request = {
        "intervalLength": this.selectedMembership.intervalLength,
        "intervalUnit": this.selectedMembership.intervalUnit,
        "totalOccurrences": 1,
        "startDate": moment(this.selectedMembership.effectiveDate, 'MM/DD/YYYY').format('x'),
        "autoProcess": this.selectedMembership.autoRenewal === true || this.selectedMembership.autoRenewal === "true" ? true : false,
        "subTotal": total,
        "taxAmount": taxAmount,
        "total": total, 
        "invoice": data, 
        "applicationReturnUrl":window.location.href + "thankyou", 
        "payment": payment
      }

      if (this.selectedSavedCard && this.selectedSavedCard.merchantTokenId && isSavedCard) {
        request.payment.merchantTokenId = this.selectedSavedCard.merchantTokenId;
        request.payment.cardType = this.selectedSavedCard.cardType;
      }
      else{
        delete request.payment.merchantTokenId;
        delete request.payment.cardType;
      }

      request.payment.customerInitiated = !(this.selectedMembership.autoRenewal === true || this.selectedMembership.autoRenewal === "true" ? true : false);
      request.payment.recurring = this.selectedMembership.autoRenewal === true || this.selectedMembership.autoRenewal === "true" ? true : false;

      this.appService.createSubscription(request).subscribe(
        (res: any) => {
          this.hidePageContentLoader()
          this.paymentDetails = res.data;
          Swal.close()
          if (this.paymentDetails.checkoutUrl) {
            let link = this.paymentDetails.checkoutUrl;
            let data = {
              link: this.paymentDetails.checkoutUrl,
              isRequestDeposit: true,
              petName: this.pet_names,
              startTime: this.start_time_str,
              endTime: this.end_time_str,
              address: this.displayAddress
            }
            const dialogRef = this.matDialog.open(CardOnFileComponent, {
              height: '680px', data: data, disableClose: true
            });
            dialogRef.afterClosed().subscribe((result: any) => {
              console.log("//closed")
              this.disablePayDepositBtn = false;
            })
          }
          else if(isSavedCard){
            Swal.fire({
              icon: 'success',
              allowOutsideClick: false,
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: 'Okay',
              html: `Thank you for your payment . \n Your payment has been successfully processed. \n We look forward to seeing you.`
            }).then((result: any) => {
              if (result.isConfirmed) {
                this.reload()
              }
            })
          }
        },
        (err) => {
          this.hidePageContentLoader()
          this.isLoading = false;
          this.disablePayDepositBtn = false
        }
      )
    }
  }

  getPackages(){
    this.isLoading = true;
    this.appService.getPackageExternal().subscribe(
      (res: any) => {
        this.isLoading = false;
        if(res.data && res.data.content){
          this.packageList = res.data.content.filter(x => x.price && x.price != '' && x.showInApp);
          this.packageList = this.packageList.sort((a,b) => a.orderNo - b.orderNo);
          this.packageList.forEach((item: any) => {
            item.totalPrice = (item.price + (item.price * (item.tax ? item.tax : 0) / 100)).toFixed(2);
            if (item.serviceRule && item.serviceRule.ruleJson) {
              var json = JSON.parse(item.serviceRule.ruleJson);
              for (var i = 0; i < json.length; i++) {
                json[i].selected = false;
                for (var z = 0; z < json[i].rule.length; z++) {
                  var indexSer = item.services.findIndex(x => x.id == json[i].rule[z].serviceId)
                  if (indexSer >= 0) {
                    json[i].rule[z].name = item.services[indexSer].name;
                  }
                  else {
                    json[i].rule[z].name = "";
                  }
                }
              }
              item.serviceRules = json;
            }
          })
        }
      },
      (err) => {
        this.isLoading = false;
      }
    )
  }

  onPackageSelect(event:any,element:any){
    this.selectedPackage = element;
    moment.tz.setDefault(this.locationTimezone);
    let month = Number(new Date().getMonth() + 1) > 9 ? Number(new Date().getMonth() + 1) : '0' + Number(new Date().getMonth() + 1);
    let day = new Date().getDate() > 9 ? new Date().getDate() : '0' + new Date().getDate();
    let year = new Date().getFullYear();
    let slashFormat = month + '/' + day + '/' + year;
    this.selectedPackage.startDate = new Date();
    this.selectedPackage.effectiveDate = slashFormat;
    if(this.selectedPackage.allowAutoRenewal){
      this.selectedPackage.autoRenewal = 'true';
    }
    else{
      this.selectedPackage.autoRenewal = 'false'
    }
  }

  packageStartDateChange(event:any){
    moment.tz.setDefault(this.locationTimezone);
    let month = Number(this.selectedPackage.startDate.getMonth() + 1) > 9 ? Number(this.selectedPackage.startDate.getMonth() + 1) : '0' + Number(this.selectedPackage.startDate.getMonth() + 1);
    let day = this.selectedPackage.startDate.getDate() > 9 ? this.selectedPackage.startDate.getDate() : '0' + this.selectedPackage.startDate.getDate();
    let year = this.selectedPackage.startDate.getFullYear();
    let slashFormat = month + '/' + day + '/' + year;
    this.selectedPackage.effectiveDate = slashFormat;
  }

  makePaymentForPackage(isSavedCard) {
    this.disablePayDepositBtn = true
    if (isSavedCard) {
      if (!this.selectedSavedCard) {
        Swal.fire({
          title: 'Warning',
          icon: 'warning',
          html: '<p style="font-size:15px;text-align:center">Please select a card</p>',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        })
        this.disablePayDepositBtn = false
        return
      }

      if (this.selectedSavedCard.ccvRequired && !this.selectedSavedCard.cvvValue || this.selectedSavedCard.cvvValue == "") {
        Swal.fire({
          title: 'Warning',
          icon: 'warning',
          html: '<p style="font-size:15px;text-align:center">Please enter cvv</p>',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        })
        this.disablePayDepositBtn = false
        return
      }

      if (this.selectedSavedCard.ccvRequired && this.selectedSavedCard.cvvValue.length < 3) {
        Swal.fire({
          title: 'Warning',
          icon: 'warning',
          html: '<p style="font-size:15px;text-align:center">Please enter valid cvv</p>',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        })
        this.disablePayDepositBtn = false
        return
      }
    }

    var invoiceData = {
      invoiceType: "QUICK_PURCHASE",
      invoice: "INVOICE",
      saveInvoice: true,
      invoiceVersion: 'V1',
      itemTotal: this.selectedPackage.totalPrice,
      status: "OPEN",
      payableAmount: parseFloat(this.selectedPackage.totalPrice).toFixed(2),
      itemGroups: [],
      customerVO: {},
      taxAmount: this.selectedPackage.price * (this.selectedPackage.tax ? this.selectedPackage.tax : 0) / 100
    }

    var taxAmount:number = this.selectedPackage.price * (this.selectedPackage.tax ? this.selectedPackage.tax : 0) / 100
    var total:number = parseFloat(this.selectedPackage.totalPrice)
    var listOfItems = [];

    var itemGroupObj = {
      amount: this.selectedPackage.price,
      code: this.selectedPackage.id,
      name: this.selectedPackage.packageName,
      paid: false,
      payableAmount: this.selectedPackage.totalPrice,
      quantity: 1,
      tax: this.selectedPackage.tax ? this.selectedPackage.tax : 0,
      taxAmount: this.selectedPackage.price * (this.selectedPackage.tax ? this.selectedPackage.tax : 0) / 100,
      total: this.selectedPackage.price,
      type: 'PACKAGE',
      autoRenewPackage : this.selectedPackage.autoRenewal == true || this.selectedPackage.autoRenewal == "true" ? true : false,
      packageEffectiveDate : moment(this.selectedPackage.effectiveDate, 'MM/DD/YYYY').format('x')
    }
    //packageEffectiveDate,autoRenewPackage,

    listOfItems.push(itemGroupObj);
    if(this.hasvalidCoupon && this.couponDetails){
      var discount:any = 0;
      var text = ''
      if(this.couponDetails.discountMode == 'PERCENT' ){
        discount = (this.couponDetails.discountValue / 100) * total;
        text = 'Coupon : ' + this.couponCode + ' (' + this.couponDetails.discountValue + '%)';
        total = total - discount;
        taxAmount = total * (this.selectedPackage.tax ? this.selectedPackage.tax : 0) / 100
      }
      else{
        text = 'Coupon : ' + this.couponCode + ' ( $' + this.couponDetails.discountValue + ')';
        discount = this.couponDetails.discountValue;
        total = total - this.couponDetails.discountValue;
        taxAmount = total * (this.selectedPackage.tax ? this.selectedPackage.tax : 0) / 100
      }
      discount = parseFloat(discount).toFixed(2);
      discount = -Math.abs(discount);
      var couponItem = {
        amount:discount,
        code: this.couponDetails.id,
        name : text,
        paid : false,
        payableAmount : discount,
        quantity:1,
        tax : 0,
        taxAmount : 0.0,
        total :discount,
        type  : 'COUPON_ADJUSTMENT'
      }
      listOfItems.push(couponItem);
    }
    if (listOfItems.length > 0) {
      invoiceData.itemGroups = [{ name: "Quick CheckOut Invoice", payableAmount: total, taxAmount: taxAmount, items: listOfItems }];
    }

    if (this.userObj) {
      invoiceData.customerVO = {
        "userKey": this.userObj['id'],
        "email": this.userObj.email,
        "firstName": this.userObj.firstName,
        "lastName": this.userObj.lastName
      };
      this.showPageContentLoader()
      this.appService.createQCInvoice(invoiceData).subscribe(
        (res: any) => {
          this.disablePayDepositBtn = false;
          this.packageInvoiceDetails = res.data;
          var payment = {
            "paymentType": "Credit",
            "transactionType": "Sale",
            "paymentMode": "CARD_NOT_PRESENT",
            "amount": total,
            "appSource": "WEB",
            "loggedInUser": { userKey: this.userObj['id'] },
            "customerInitiated": !(this.selectedPackage.autoRenewal == true || this.selectedPackage.autoRenewal == "true" ? true : false),
            "recurring": this.selectedPackage.autoRenewal == true || this.selectedPackage.autoRenewal == "true" ? true : false,
            "merchantTokenId": '',
            "cardType": '',
            'paidAmount': total,
            'applicationReturnUrl': window.location.href + "thankyou",
          }

          if (this.selectedSavedCard && this.selectedSavedCard.merchantTokenId && isSavedCard) {
            payment.merchantTokenId = this.selectedSavedCard.merchantTokenId;
            payment.cardType = this.selectedSavedCard.cardType;
          }
          else {
            delete payment.merchantTokenId;
            delete payment.cardType;
          }
          this.disablePayDepositBtn = true
          this.appService.makeQCPayment(this.packageInvoiceDetails, payment).subscribe(
            (res: any) => {
              this.hidePageContentLoader()
              this.paymentDetails = res.data;
              Swal.close()
              if (this.paymentDetails.checkoutUrl) {
                let link = this.paymentDetails.checkoutUrl;
                let data = {
                  link: this.paymentDetails.checkoutUrl,
                  isRequestDeposit: true,
                  petName: this.pet_names,
                  startTime: this.start_time_str,
                  endTime: this.end_time_str,
                  address: this.displayAddress
                }
                const dialogRef = this.matDialog.open(CardOnFileComponent, {
                  height: '680px', data: data, disableClose: true
                });
                dialogRef.afterClosed().subscribe((result: any) => {
                  console.log("//closed")
                  this.disablePayDepositBtn = false;
                })
              }
              else if (isSavedCard) {
                Swal.fire({
                  icon: 'success',
                  allowOutsideClick: false,
                  showCancelButton: false,
                  showConfirmButton: true,
                  confirmButtonText: 'Okay',
                  html: `Thank you for your payment . \n Your payment has been successfully processed. \n We look forward to seeing you.`
                }).then((result: any) => {
                  if (result.isConfirmed) {
                    this.reload()
                  }
                })
              }
            },
            (err) => {
              this.hidePageContentLoader()
              this.isLoading = false;
              this.disablePayDepositBtn = false
            }
          )

        },
        (err) => {
          this.hidePageContentLoader()
          this.isLoading = false;
          this.disablePayDepositBtn = false
        }
      )
    }
  }

  addCoupon(){
    this.hasCoupon = true;
  }

  showInvoiceDescription(){
    this.showRules = !this.showRules;
  }

  async validateCoupon(){
    this.hasvalidCoupon = false;
    if(this.hasCoupon){
      if(!this.couponCode || this.couponCode == ''){
        Swal.fire({
          title: 'Warning',
          icon: 'warning',
          html: '<p style="font-size:15px;text-align:center">Please enter coupon code</p>',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        })
        return
      }

      this.couponCode = this.couponCode.trim()
      try {
        const resDate: any = await this.appService.userCoupon(this.userObj['id'], this.couponCode).toPromise();
        this.couponDetails = resDate.data;
        if (resDate.data.applyWhen != 'ONCE') {
          this.hasvalidCoupon = true;
        }
        else {
          try {
            const res: any = await this.appService.validateCoupon(this.userObj['id'], this.couponCode).toPromise();
            if (res.list && res.list.length > 0) {
              Swal.fire({
                title: 'Warning',
                icon: 'warning',
                html: '<p style="font-size:15px;text-align:center">Coupon already used</p>',
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'Ok',
              })
              this.disablePayDepositBtn = false;
              return;
            } else {
              this.hasvalidCoupon = true;
            }
          } catch (err) {
            this.disablePayDepositBtn = false;
            return;
          }
        }

        if (this.selectedPurchaseType == 'membership' &&
          (!this.couponDetails.applyForAllTypes && (!this.couponDetails.applyForAllMemberships && (!this.couponDetails.memberships || this.couponDetails.memberships.length == 0 || !this.couponDetails.memberships.some(m => m.id === this.selectedMembership.id))))) {
          Swal.fire({
            title: 'Warning',
            icon: 'warning',
            html: '<p style="font-size:15px;text-align:center">Coupon is not applicable for this membership</p>',
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'Ok',
          });
          this.hasvalidCoupon = false;
        }

        if (this.selectedPurchaseType == 'package' &&
          (!this.couponDetails.applyForAllTypes && (!this.couponDetails.applyForAllPackages && (!this.couponDetails.packages || this.couponDetails.packages.length == 0 || !this.couponDetails.packages.some(m => m.id === this.selectedPackage.id))))) {
          Swal.fire({
            title: 'Warning',
            icon: 'warning',
            html: '<p style="font-size:15px;text-align:center">Coupon is not applicable for this package</p>',
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'Ok',
          });
          this.hasvalidCoupon = false;
        }

        if (this.selectedPurchaseType == 'training' &&
          (!this.couponDetails.applyForAllTypes && (!this.couponDetails.applyForAllGroupBasedServices && (!this.couponDetails.groupBasedServices || this.couponDetails.groupBasedServices.length == 0 || !this.couponDetails.groupBasedServices.some(m => m.id === this.selectedSession.groupService.id))))) {
          Swal.fire({
            title: 'Warning',
            icon: 'warning',
            html: '<p style="font-size:15px;text-align:center">Coupon is not applicable for this training type</p>',
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'Ok',
          });
          this.hasvalidCoupon = false;
        }
       
      } catch (error) {
        Swal.fire({
          title: 'Warning',
          icon: 'warning',
          html: '<p style="font-size:15px;text-align:center">Invalid coupon code</p>',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        })
      }
    }
  }

  removeCoupon(){
    this.hasCoupon = false;
    this.hasvalidCoupon = false;
    this.couponDetails = undefined
  }

  getPaymentTotal(){
    if(this.selectedPurchaseType == 'membership'){
      if(this.hasvalidCoupon && this.couponDetails){
        var discount:any = 0;
        if(this.couponDetails.discountMode == 'PERCENT' ){
          discount = (this.couponDetails.discountValue / 100) * this.selectedMembership.totalPrice;
        }
        else{
          discount = this.couponDetails.discountValue;
        }
        return parseFloat(this.selectedMembership.totalPrice) - discount.toFixed(2);
      }
      return this.selectedMembership.totalPrice;
    }
    else if(this.selectedPurchaseType == 'package'){
      if(this.hasvalidCoupon && this.couponDetails){
        var discount:any = 0;
        if(this.couponDetails.discountMode == 'PERCENT' ){
          discount = (this.couponDetails.discountValue / 100) * this.selectedPackage.totalPrice;
        }
        else{
          discount = this.couponDetails.discountValue;
        }
        return parseFloat(this.selectedPackage.totalPrice) - discount.toFixed(2);
      }
      return this.selectedPackage.totalPrice;
    } else if (this.selectedPurchaseType == 'training') {
      if (this.selectedSession && this.selectedSession.groupService) {
        let findSelectedPets = this.userPets.filter((x: any) => x.selected);
        let total = findSelectedPets.length * (this.selectedSession.groupService.priceTiers[0].amount +
          (this.selectedSession.groupService.priceTiers[0].amount *
            (this.selectedSession.groupService.taxPercentage ? this.selectedSession.groupService.taxPercentage : 0) / 100));

        if (this.hasvalidCoupon && this.couponDetails) {
          let discount: number = 0;
          if (this.couponDetails.discountMode === 'PERCENT') {
            discount = (this.couponDetails.discountValue / 100) * (this.selectedSession.groupService.priceTiers[0].amount +
              (this.selectedSession.groupService.priceTiers[0].amount *
                (this.selectedSession.groupService.taxPercentage ? this.selectedSession.groupService.taxPercentage : 0) / 100));
          } else {
            discount = this.couponDetails.discountValue;
          }
          discount = discount * findSelectedPets.length;
          return (total - discount).toFixed(2);
        } else {
          return total.toFixed(2);
        }
      }
      else {
        return 0.00
      }
    }
  }

  getCouponDiscount(){
    if(this.selectedPurchaseType == 'membership'){
      if(this.hasvalidCoupon && this.couponDetails){
        var discount:any = 0;
        if(this.couponDetails.discountMode == 'PERCENT' ){
          discount = (this.couponDetails.discountValue / 100) * this.selectedMembership.totalPrice;
        }
        else{
          discount = this.couponDetails.discountValue;
        }
        return discount.toFixed(2);
      }
      return 0;
    }
    else if(this.selectedPurchaseType == 'package') {
      if(this.hasvalidCoupon && this.couponDetails){
        var discount:any = 0;
        if(this.couponDetails.discountMode == 'PERCENT' ){
          discount = (this.couponDetails.discountValue / 100) * this.selectedPackage.totalPrice;
        }
        else{
          discount = this.couponDetails.discountValue;
        }
        return discount.toFixed(2);
      }
      return 0;
    }
    else if(this.selectedPurchaseType == 'training'){
      if (this.selectedSession && this.selectedSession.groupService) {
        let findSelectedPets = this.userPets.filter((x: any) => x.selected);
        if (this.hasvalidCoupon && this.couponDetails) {
          let discount: number = 0;
          if (this.couponDetails.discountMode === 'PERCENT') {
            discount = (this.couponDetails.discountValue / 100) * (this.selectedSession.groupService.priceTiers[0].amount +
              (this.selectedSession.groupService.priceTiers[0].amount *
                (this.selectedSession.groupService.taxPercentage ? this.selectedSession.groupService.taxPercentage : 0) / 100))
          } else {
            discount =  this.couponDetails.discountValue;
          }
          discount = discount * findSelectedPets.length;
          return discount.toFixed(2);
        } else {
          return 0.00
        }
      }
      else {
        return 0.00
      }
    }
  }

  getCouponDiscountValue(){
    if(this.couponDetails){
        if(this.couponDetails.discountMode == 'PERCENT' ){
          return this.couponDetails.discountValue + '%';
        }
        return '$' + this.couponDetails.discountValue;
    }
    return ''
  }

  isShowNextBtnAndTable(){
    if(this.selectedPurchaseType == 'package'){
      return true;
    }
    else if(this.selectedPurchaseType == 'membership'){
      let find = this.membershipList.find(x => x.petTypeId == this.selectedPetID);
      if(find){
        return true;
      }
    }
    else if(this.selectedPurchaseType == 'training'){
      let find = this.trainingList.find(x => x.petType.id == this.selectedPetID);
      if(find){
        return true;
      }
    }
    return false;
  }

  getTraining() {
    this.isLoading = true;
    if (this.organizationKey && this.organizationKey != undefined) {
      this.appService.getTrainingExternal(this.organizationKey).subscribe(
        (res: any) => {
          this.isLoading = false;
          if(res.data && res.data.content && res.data.content.length > 0){
            this.trainingList = res.data.content.filter(x => 
              x.active && x.priceTiers && x.priceTiers.length > 0 
            )
            for(var i = 0 ; i < this.trainingList.length ; i++){
              if(this.trainingList[i].hideFromDevices && this.trainingList[i].hideStartDate && this.trainingList[i].hideEndDate){
                let currentDate = new Date();
                let hideStartDate = new Date(this.trainingList[i].hideStartDate);
                let hideEndDate = new Date(this.trainingList[i].hideEndDate);
                if ((hideStartDate <= currentDate) && (hideEndDate >= currentDate )) {
                  this.trainingList = this.trainingList.filter(x => x.id != this.trainingList[i].id)
                } 
              }
            }
            this.trainingList.sort((a,b) => a.orderNo - b.orderNo);
            if(this.trainingTypeQueryParam){
              this.selectedPurchaseType = 'training';
              let splitted: string[] = this.trainingTypeQueryParam.split(',')
              let findedTrainingServices : any[] = []
              splitted.forEach((a) => {
                var find = this.trainingList.find(x => x.id == a);
                if(find){
                  findedTrainingServices.push(find)
                  if (findedTrainingServices.length == 1) {
                    this.selectedPetID = find.petType.id;
                    this.infoService.getPetTypeId(this.selectedPetID);
                    this.infoService.petTypeId = this.selectedPetID;
                    this.newPetID = this.selectedPetID;
                    this.resetLocation();
                    this.selectedAddOnServices = [];
                    this.datePickerType = null;
                    var petType = this.petTypes.find(o => o.id == this.selectedPetID);
                    if (petType) {
                      this.selectedPetName = petType.name;
                      this.getReservationTypes(petType);
                      this.addPetGender(petType);
                      this.getPetBreed(petType);
                      this.selectedTraining(find);
                      this.focusOnTraining(find.id);
                    }
                  }
                }
              })
              if(findedTrainingServices.length > 0){
                this.trainingList = findedTrainingServices;
              }
            }
          }
          console.log(res)
        },
        (err) => {
          this.isLoading = false;
        }
      )
    }
  }

  focusOnTraining(trainingType: string) {
    const trainingId = trainingType
    const escapedId = CSS.escape(`training-${trainingId}`); 
    setTimeout(() => {
      const panel = this.elementRef.nativeElement.querySelector(`#${escapedId}`);
      if (panel) {
        this.renderer.setAttribute(panel, 'tabindex', '-1'); 
        panel.focus();
      }
    }, 0);
  }

  selectedTraining(trainingService:any){
    this.selectedTrainingType = trainingService.id
    if(!trainingService.sessions){
      this.appService.getSessions(this.organizationKey,trainingService.id).subscribe(
        (res:any) =>{
            if(res.data && res.data.content){
              trainingService.sessions = [];
              if(trainingService.enrollmentType == 'FIXED_CLASS_SCHEDULE'){
                trainingService.sessions = res.data.content.filter((x: any) =>
                  x.openForEnrollment && !x.hideFromDevices && moment(parseInt(x.recurringStartDate), 'x').isSameOrAfter(moment()) && x.classes && x.classes.length > 0 && x.totalPet < x.maxCapacity
                );
                trainingService.sessions = trainingService.sessions.filter((x: any) =>
                  parseInt(trainingService.bookingInterval) == 0 || (parseInt(trainingService.bookingInterval) <= moment(parseInt(x.recurringStartDate), 'x').diff(moment(), 'days'))
                );

                trainingService.sessions.forEach((session: any) => {
                  session.classes = session.classes.sort((a: any, b: any) => {
                    return moment(a.appointmentDate).diff(moment(b.appointmentDate))
                  })
                })
              }
              else{
                trainingService.sessions = res.data.content.filter((x:any) =>  x.openForEnrollment && !x.hideFromDevices);
                // trainingService.sessions = trainingService.sessions.filter((x: any) =>
                //   parseInt(trainingService.bookingInterval) == 0 || (parseInt(trainingService.bookingInterval) <= moment(parseInt(x.recurringStartDate), 'x').diff(moment(), 'days'))
                // );

                trainingService.sessions.forEach((session: any) => {
                  session.classes = session.classes.sort((a: any, b: any) => {
                    return moment(a.appointmentDate).diff(moment(b.appointmentDate))
                  })
                })

                trainingService.sessions.forEach((session: any) => {
                  session.uniqueClasses = []
                  session.classes.forEach((cls: any) => {
                    if (!session.uniqueClasses.includes(cls.classKey)) {
                      session.uniqueClasses.push(cls.classKey)
                    }
                  })
                })

                for(var i = 0 ; i < trainingService.sessions.length ; i++){
                  if(trainingService.sessions[i].classes && trainingService.sessions[i].classes.length > 0){
                    for(var j = 0 ; j < trainingService.sessions[i].classes.length ; j++){
                      if(moment(parseInt(trainingService.sessions[i].classes[j].appointmentDate),'x').isBefore(moment()) || (trainingService.sessions[i].classes[j].occupiedCapacity >= trainingService.sessions[i].maxCapacity)){
                        trainingService.sessions[i].classes[j].status = 'COMPLETED';
                      }
                      trainingService.sessions[i].classes[j].displayName = trainingService.sessions[i].classes[j].name + ' - ' + this.getDateAndTime(trainingService.sessions[i].classes[j].appointmentDate,'dateTime');
                      if(!trainingService.sessions[i].groupedClasses){
                        trainingService.sessions[i].groupedClasses = [];
                      }
                      let index = trainingService.sessions[i].groupedClasses.findIndex((x:any) => x.classKey == trainingService.sessions[i].classes[j].classKey);
                      if(index == -1){
                        trainingService.sessions[i].groupedClasses.push({
                          classKey : trainingService.sessions[i].classes[j].classKey,
                          name : trainingService.sessions[i].classes[j].name,
                          classDetails : []
                        })
                        if(trainingService.sessions[i].classes[j].status != 'COMPLETED'){
                          trainingService.sessions[i].groupedClasses[trainingService.sessions[i].groupedClasses.length - 1].classDetails.push(trainingService.sessions[i].classes[j])
                        }
                      }
                      else if(index != -1 && trainingService.sessions[i].classes[j].status != 'COMPLETED'){
                        trainingService.sessions[i].groupedClasses[index].classDetails.push(trainingService.sessions[i].classes[j])
                      }
                    }
                  }
                }
                trainingService.sessions = trainingService.sessions.filter((x: any) => x.classes && x.classes.length > 0 )

                // check all groupedClasses has atleast one classDetails else remove from session
                for (var i = 0; i < trainingService.sessions.length; i++) {
                  let filtedGroup = trainingService.sessions[i].groupedClasses.filter((x: any) => x.classDetails && x.classDetails.length > 0)
                  if(filtedGroup && filtedGroup.length != trainingService.sessions[i].groupedClasses.length){
                    trainingService.sessions = trainingService.sessions.filter((x: any) => x.id != trainingService.sessions[i].id)
                  }
                }
              }

              for (var i = 0; i < trainingService.sessions.length; i++) {
                let petType = this.petTypes.find((item: any) => item.id == trainingService.petType.id);
                if (petType) {
                  if (petType.genders && petType.genders.length > 0 && trainingService.sessions[i].gender && trainingService.sessions[i].gender != '') {
                    let name = "";
                    let genderIds = trainingService.sessions[i].gender.split(',')
                    genderIds.forEach((id: any) => {
                      let find = petType.genders.find((item: any) => item.id == id);
                      if (find) {
                        name = name == '' ? find.name : name + ', ' + find.name;
                      }
                    })
                    trainingService.sessions[i].genderAllowed = name;
                  }
  
                  if (trainingService.sessions[i].requiredMinimumAge && trainingService.sessions[i].requiredMinimumAge != 0 && trainingService.sessions[i].requiredMaximumAge != '') {
                    trainingService.sessions[i].petMinAge = (Math.floor(trainingService.sessions[i].requiredMinimumAge / 12) > 0 ? Math.floor(trainingService.sessions[i].requiredMinimumAge / 12) + " years" : '') + (trainingService.sessions[i].requiredMinimumAge % 12 > 0 ? " " + trainingService.sessions[i].requiredMinimumAge % 12 + " months" : "");
                  }
                }
                if(trainingService.sessions[i].duration && trainingService.sessions[i].duration != ''){
                  trainingService.sessions[i].durationInText = '';
                  let hours = Math.floor(trainingService.sessions[i].duration / 60);
                  let minutes = trainingService.sessions[i].duration % 60;
                  if(hours > 0){
                    trainingService.sessions[i].durationInText = hours + ' hour' + (hours > 1 ? 's' : '');
                  }
                  if(minutes > 0){
                    trainingService.sessions[i].durationInText += ' ' +  minutes + ' minute' + (minutes > 1 ? 's' : '') 
                  }
                }
              }
            }
            else{
              trainingService.sessions = [];
            }
        },
        (err:any) =>{
          console.log("err",err)
        }
      )
    }
  }

  getDateAndTime(date: any,type) {
    if(type == 'dateTime'){
      return moment(date, 'x').format('MM/DD/YYYY hh:mm A');
    }
    else if(type == 'date'){
      return moment(date, 'x').format('MM/DD/YYYY');
    }
    else if(type == 'time'){
      return moment(date, 'x').format('hh:mm A');
    }
  }

  onSessionChange($event: any, session: any) {
    let isSelected = $event.option.selected
    this.selectedSession = undefined;
    if (isSelected) {
      this.sessionSelected = true;
      for (var i = 0; i < this.trainingList.length; i++) {
        if (this.trainingList[i].sessions && this.trainingList[i].sessions.length > 0) {
          for (var j = 0; j < this.trainingList[i].sessions.length; j++) {
            if (this.trainingList[i].sessions[j].id == $event.option.value) {
              this.trainingList[i].sessions[j].selected = true
              this.selectedSession = this.trainingList[i].sessions[j];
              this.selectedSession.petType = this.trainingList[i].petType;
              this.selectedSession.groupService = this.trainingList[i]
            }
            else {
              this.trainingList[i].sessions[j].selected = false;
            }
          }
        }
      }
    }
    else {
      this.sessionSelected = false;
    }
  }

  makePaymentForTraining(isSavedCard:boolean){
    this.disablePayDepositBtn = true
    if (isSavedCard) {
      if (!this.selectedSavedCard) {
        Swal.fire({
          title: 'Warning',
          icon: 'warning',
          html: '<p style="font-size:15px;text-align:center">Please select a card</p>',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        })
        this.disablePayDepositBtn = false
        return
      }

      if (this.selectedSavedCard.ccvRequired && !this.selectedSavedCard.cvvValue || this.selectedSavedCard.cvvValue == "") {
        Swal.fire({
          title: 'Warning',
          icon: 'warning',
          html: '<p style="font-size:15px;text-align:center">Please enter cvv</p>',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        })
        this.disablePayDepositBtn = false
        return
      }

      if (this.selectedSavedCard.ccvRequired && this.selectedSavedCard.cvvValue.length < 3) {
        Swal.fire({
          title: 'Warning',
          icon: 'warning',
          html: '<p style="font-size:15px;text-align:center">Please enter valid cvv</p>',
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        })
        this.disablePayDepositBtn = false
        return
      }
    }

    var invoiceData = {
      invoiceType : 'GROUP_BASED',
      invoice : 'INVOICE',
      saveInvoice : true,
      itemTotal : this.getPaymentTotal(),
      status : 'OPEN',
      payableAmount : this.getPaymentTotal(),
      invoiceVersion : 'V1',
      applicationSource : 'WEB',
      taxAmount : 0.00,
      itemGroups: [],
      customerVO: {},
    }

    let selectedPets = this.userPets.filter((x:any) => x.selected)

    invoiceData.taxAmount = parseFloat(
      (selectedPets.length * (this.selectedSession.groupService.priceTiers[0].amount * 
        (this.selectedSession.groupService.taxPercentage ? this.selectedSession.groupService.taxPercentage : 0) / 100)).toFixed(2)
    );    
    invoiceData.customerVO = {
      "userKey": this.userObj['id'],
      "email": this.userObj.email,
      "firstName": this.userObj.firstName,
      "lastName": this.userObj.lastName
    };

    for(var i = 0 ; i < selectedPets.length ; i++){
      let listOfItems : any = {
          name : 'Training services for '+ selectedPets[i].name,
          payableAmount : this.selectedSession.groupService.priceTiers[0].amount,
          taxAmount : (this.selectedSession.groupService.priceTiers[0].amount * (this.selectedSession.groupService.taxPercentage ? this.selectedSession.groupService.taxPercentage : 0) / 100).toFixed(2),
          comments : selectedPets[i].id,
          items : [
            {
              name : this.selectedSession.name + ' - ' + selectedPets[i].name,
              description : this.selectedSession.groupService.name,
              quantity : 1,
              type : 'GROUP_BASED_SESSION',
              code : this.selectedSession.id,
              amount : this.selectedSession.groupService.priceTiers[0].amount.toFixed(2),
              total : this.selectedSession.groupService.priceTiers[0].amount.toFixed(2),
              tax : this.selectedSession.groupService.taxPercentage ? this.selectedSession.groupService.taxPercentage : 0,
              taxAmount : (this.selectedSession.groupService.priceTiers[0].amount.toFixed(2) * (this.selectedSession.groupService.taxPercentage ? this.selectedSession.groupService.taxPercentage : 0) / 100).toFixed(2),
              payableAmount : parseFloat((this.selectedSession.groupService.priceTiers[0].amount + (this.selectedSession.groupService.priceTiers[0].amount * (this.selectedSession.groupService.taxPercentage ? this.selectedSession.groupService.taxPercentage : 0) / 100)).toFixed(2)),
              paid : false,
              petId : selectedPets[i].id,
              petName : selectedPets[i].name,
              extras : ''
            }
          ]
      }

      if (this.selectedSession.groupService.enrollmentType == "OPEN_ENROLLMENT" && this.selectedSession.groupService.autoApproval){
        if (this.selectedSession.groupedClasses && this.selectedSession.groupedClasses)
        {
          var extras = [];
          for (var j = 0; j < this.selectedSession.groupedClasses.length; j++) {
            extras.push({
              classKey: this.selectedSession.groupedClasses[j].assignedClass.classKey,
              appointmentDate: this.selectedSession.groupedClasses[j].assignedClass.appointmentDate,
              appointmentEndTime: this.selectedSession.groupedClasses[j].assignedClass.appointmentEndTime,
              appointmentKey:this.selectedSession.groupedClasses[j].assignedClass.appointmentKey
            })
          }
          listOfItems.items[0].extras = JSON.stringify(extras)
        }
        else{
          delete listOfItems.items[0].extras;
        }
      }
      else if(this.selectedSession.groupService.enrollmentType == "OPEN_ENROLLMENT"){
        if (this.selectedSession.groupedClasses && this.selectedSession.groupedClasses) {
          var extras = [];
          for (var j = 0; j < this.selectedSession.groupedClasses.length; j++) {
            extras.push({
              classKey: this.selectedSession.groupedClasses[j].classKey
            })
          }
          listOfItems.items[0].extras = JSON.stringify(extras)
        }
        else {
          delete listOfItems.items[0].extras;
        }
      }
      else{
        delete listOfItems.items[0].extras;
      }


      if(this.hasCoupon && this.couponDetails){
        var discount:any = 0;
        var text = ''
        if(this.couponDetails.discountMode == 'PERCENT' ){
          discount = (this.couponDetails.discountValue / 100) * this.selectedSession.groupService.priceTiers[0].amount;
          text = 'Coupon : ' + this.couponCode + ' (' + this.couponDetails.discountValue + '%)';
        }
        else{
          text = 'Coupon : ' + this.couponCode + ' ( $' + this.couponDetails.discountValue + ')';
          discount = this.couponDetails.discountValue;
        }
        discount = parseFloat(discount).toFixed(2);
        discount = -Math.abs(discount);
        var couponItem:any = {
          amount:discount,
          code: this.couponDetails.id,
          name : text,
          paid : false,
          payableAmount : discount,
          quantity:1,
          tax : 0,
          taxAmount : 0.0,
          total :discount,
          type  : 'COUPON_ADJUSTMENT'
        }

        if(this.couponDetails.discountMode == 'PERCENT' ){
          couponItem.tax = this.selectedSession.groupService.taxPercentage ? this.selectedSession.groupService.taxPercentage : 0;
          var taxDiscount:any = (this.couponDetails.discountValue / 100) * this.selectedSession.groupService.priceTiers[0].amount.toFixed(2) * (this.selectedSession.groupService.taxPercentage ? this.selectedSession.groupService.taxPercentage : 0) / 100;
          taxDiscount = parseFloat(taxDiscount).toFixed(2);
          taxDiscount = -Math.abs(taxDiscount);
          couponItem.taxAmount = taxDiscount;
          couponItem.total = parseFloat(discount) + parseFloat(taxDiscount);
          couponItem.payableAmount = parseFloat(discount) + parseFloat(taxDiscount);
        }
        listOfItems.items.push(couponItem);
        listOfItems.payableAmount = parseFloat(listOfItems.items[0].payableAmount) + parseFloat(listOfItems.items[1].payableAmount);
        listOfItems.taxAmount = parseFloat(listOfItems.items[0].taxAmount) + parseFloat(listOfItems.items[1].taxAmount);
      }
      invoiceData.itemGroups.push(listOfItems)
    }
    this.showPageContentLoader()
    this.appService.createQCInvoice(invoiceData).subscribe(
      (res: any) => {
        this.disablePayDepositBtn = false;
        this.trainingInvoiceDetail = res.data;

        var paymentDetails = {
          "transactionType": "Sale",
          "paymentType": "Credit",
          "terminalName": "",
          "paymentMode": "CARD_NOT_PRESENT",
          "amount": this.getPaymentTotal(),
          "paidAmount": this.getPaymentTotal(),
          "paymentNotes": "",
          "loggedInUser": {
            "userKey": this.userObj['id']
          },
          "appSource": "WEB",
          "merchantTokenId": "",
          "cardType": "",
          "customerInitiated": false,
          "recurring": false,
          "applicationReturnUrl": window.location.href + "thankyou",
          // "applicationReturnUrl": this.appService.applicationReturnUrl + "/" + this.appService.tenantKey + "/payment.html"
        }

        if (this.selectedSavedCard && this.selectedSavedCard.merchantTokenId && isSavedCard) {
          paymentDetails.merchantTokenId = this.selectedSavedCard.merchantTokenId;
          paymentDetails.cardType = this.selectedSavedCard.cardType;
        }
        else {
          delete paymentDetails.merchantTokenId;
          delete paymentDetails.cardType;
        }
        this.disablePayDepositBtn = true
        this.appService.makeQCPayment(this.trainingInvoiceDetail, paymentDetails).subscribe(
          (res: any) => {
            this.hidePageContentLoader();
            this.paymentDetails = res.data;
            Swal.close()
            if (this.paymentDetails.checkoutUrl) {
              let link = this.paymentDetails.checkoutUrl;
              let data = {
                link: this.paymentDetails.checkoutUrl,
                isRequestDeposit: true,
                petName: this.pet_names,
                startTime: this.start_time_str,
                endTime: this.end_time_str,
                address: this.displayAddress
              }
              const dialogRef = this.matDialog.open(CardOnFileComponent, {
                height: '680px', data: data, disableClose: true
              });
              dialogRef.afterClosed().subscribe((result: any) => {
                this.disablePayDepositBtn = false;
              })
            }
            else if (isSavedCard) {
              Swal.fire({
                icon: 'success',
                allowOutsideClick: false,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'Okay',
                html: `Thank you for your payment . \n Your payment has been successfully processed. \n We look forward to seeing you.`
              }).then((result: any) => {
                if (result.isConfirmed) {
                  this.reload()
                }
              })
            }
          },
          (err) => {
            this.hidePageContentLoader();
            this.isLoading = false;
            this.disablePayDepositBtn = false
          }
        )

      },
      (err) => {
        this.hidePageContentLoader();
        this.isLoading = false;
        this.disablePayDepositBtn = false
      }
    )
  }

  isDisablePayBtnForTraining(){
    if(this.selectedSession && this.selectedSession.groupService.enrollmentType != 'FIXED_CLASS_SCHEDULE' && this.selectedSession.groupService.autoApproval){
      let findAssignedClass = this.selectedSession.groupedClasses.filter((x:any) => x.assignedClass)
      if(findAssignedClass.length < this.selectedSession.groupedClasses.length){
        return true;
      }
    }
    return false;
  }

  getVetData(){
    this.appService.getVeterinarianDate(this.organizationKey,this.userObj['id']).subscribe(
      (res:any) =>{
        if(res.data && res.data.content && res.data.content.length > 0){
          this.veterinarianDetails = res.data.content;
          this.filteredVet = res.data.content
        }
      },
      (err:any) =>{
        console.log("err",err)
      }
    )
  }

  filterVet(){
    const filterValue = this.vetInput.nativeElement.value.toLowerCase();
    this.filteredVet = this.veterinarianDetails.filter(o => o.name.toLowerCase().includes(filterValue) || (o.phone && o.phone.toLowerCase().includes(filterValue)) );
  }

  showAddVet(){
    let dialogRef = this.matDialog.open(AddVetComponent, {
      width: '50%',
      data: {organizationKey: this.organizationKey}
    })

    dialogRef.componentInstance.submitted.subscribe((data: any) => {
      this.appService.addVeterinarian(data).subscribe(
        (res:any) =>{
          this.getVetData();
          dialogRef.close();
        },
        (err:any) =>{
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: err.error.error.message
          })
          dialogRef.close();
        }
      )
    })
  }

  isMandatory(type: string, editType: string) {

    if (this.ageRequired && type == 'birthday' && editType == 'edit') {
      return true;
    }
    if (this.genderRequired && type == 'gender' && editType == 'edit') {
      return true;
    }
    if (this.weightMandatory && type == 'weight' && editType == 'edit') {
      return true;
    }

    if (this.profileMap.size > 0) {
      if (this.profileMap.has('PET_COLOR_WEB') && type == 'color') {
        let colorRequired = false;
        if (editType == 'add') {
          this.profileMap.get("PET_COLOR_WEB").forEach(item => {
            if (item.type == "onCreatePet") {
              colorRequired = item.status;
            }
          });
        }
        if (editType == 'edit') {
          this.profileMap.get("PET_COLOR_WEB").forEach(item => {
            if (item.type == "onCreateAppointment") {
              colorRequired = item.status;
            }
          })
        }
        if (colorRequired) {
          return true;
        }
      }
      //dob
      if (this.profileMap.has('PET_DOB_WEB') && type == 'birthday') {
        let colorRequired = false;
        if (editType == 'add') {
          this.profileMap.get("PET_DOB_WEB").forEach(item => {
            if (item.type == "onCreatePet") {
              colorRequired = item.status;
            }
          });
        }
        if (editType == 'edit') {
          this.profileMap.get("PET_DOB_WEB").forEach(item => {
            if (item.type == "onCreateAppointment") {
              colorRequired = item.status;
            }
          })
        }
        if (colorRequired) {
          return true;
        }
      }
      //gender
      if (this.profileMap.has('PET_SEX_WEB') && type == 'gender') {
        let genderRequired = false;
        if (editType == 'add') {
          this.profileMap.get("PET_SEX_WEB").forEach(item => {
            if (item.type == "onCreatePet") {
              genderRequired = item.status;
            }
          });
        }
        if (editType == 'edit') {
          this.profileMap.get("PET_SEX_WEB").forEach(item => {
            if (item.type == "onCreateAppointment") {
              genderRequired = item.status;
            }
          })
        }
        if (genderRequired) {
          return true;
        }
      }
      //weight
      if (this.profileMap.has('PET_WEIGHT_WEB') && type == 'weight') {
        let weightRequired = false;
        if (editType == 'add') {
          this.profileMap.get("PET_WEIGHT_WEB").forEach(item => {
            if (item.type == "onCreatePet") {
              weightRequired = item.status;
            }
          });
        }
        if (editType == 'edit') {
          this.profileMap.get("PET_WEIGHT_WEB").forEach(item => {
            if (item.type == "onCreateAppointment") {
              weightRequired = item.status;
            }
          })
        }
        if (weightRequired) {
          return true;
        }
      }
      //vet
      if (this.profileMap.has('PET_VETERINARIAN_WEB') && type == 'vet') {
        let vetRequired = false;
        if (editType == 'add') {
          this.profileMap.get("PET_VETERINARIAN_WEB").forEach(item => {
            if (item.type == "onCreatePet") {
              vetRequired = item.status;
            }
          });
        }

        if (editType == 'edit') {
          this.profileMap.get("PET_VETERINARIAN_WEB").forEach(item => {
            if (item.type == "onCreateAppointment") {
              vetRequired = item.status;
            }
          })
        }
        if (vetRequired) {
          return true;
        }
      }
    }
    return false;
  }

  selectedVet(event:any){
    this.selectedVetDetails = event.option.value;
  }

  displayProperty(value) {
    if (value) {
      return value.name;
    }
  }

  checkPetOwnerMandatory(){
    if (this.profileMap.has('PETOWNER_AUTHORIZED_CONTACT_WEB') && (!this.userDetails.userPreference || this.hasAuthorizedPickup(this.userDetails.userPreference))) {
      let authContact = false;
      if (this.selectedPurchaseType == 'service') {
        this.profileMap.get("PETOWNER_AUTHORIZED_CONTACT_WEB").forEach(item => {
          if (item.type == "onCreateAppointment") {
            authContact = item.status;
          }
        });
      }
      if (this.selectedPurchaseType == 'membership') {
        this.profileMap.get("PETOWNER_AUTHORIZED_CONTACT_WEB").forEach(item => {
          if (item.type == "onMembershipPurchase") {
            authContact = item.status;
          }
        })
      }
      if (this.selectedPurchaseType == 'package') {
        this.profileMap.get("PETOWNER_AUTHORIZED_CONTACT_WEB").forEach(item => {
          if (item.type == "onPackagePurchase") {
            authContact = item.status;
          }
        })
      }
      if (this.selectedPurchaseType == 'training') {
        this.profileMap.get("PETOWNER_AUTHORIZED_CONTACT_WEB").forEach(item => {
          if (item.type == "onTrainingPurchase") {
            authContact = item.status;
          }
        })
      }
      if (authContact) {
        this.petOwnerMandatory['requireAuthorized'] = true;
      }
    }

    if(this.profileMap.has('PETOWNER_EMERGENCY_CONTACT_WEB') && (!this.userDetails.userPreference || this.hasNoEmergencyContact(this.userDetails.userPreference))){
      let emergencyContact = false;
      if (this.selectedPurchaseType == 'service') {
        this.profileMap.get("PETOWNER_EMERGENCY_CONTACT_WEB").forEach(item => {
          if (item.type == "onCreateAppointment") {
            emergencyContact = item.status;
          }
        });
      }
      if (this.selectedPurchaseType == 'membership') {
        this.profileMap.get("PETOWNER_EMERGENCY_CONTACT_WEB").forEach(item => {
          if (item.type == "onMembershipPurchase") {
            emergencyContact = item.status;
          }
        })
      }
      if (this.selectedPurchaseType == 'package') {
        this.profileMap.get("PETOWNER_EMERGENCY_CONTACT_WEB").forEach(item => {
          if (item.type == "onPackagePurchase") {
            emergencyContact = item.status;
          }
        })
      }
      if (this.selectedPurchaseType == 'training') {
        this.profileMap.get("PETOWNER_EMERGENCY_CONTACT_WEB").forEach(item => {
          if (item.type == "onTrainingPurchase") {
            emergencyContact = item.status;
          }
        })
      }
      if (emergencyContact) {
        this.petOwnerMandatory['requireEmergency'] = true;
      }
    }

    if(this.profileMap.has('PETOWNER_EMAIL_WEB') && !this.userDetails.email){
      let email = false;
      if (this.selectedPurchaseType == 'service') {
        this.profileMap.get("PETOWNER_EMAIL_WEB").forEach(item => {
          if (item.type == "onCreateAppointment") {
            email = item.status;
          }
        });
      }
      if (this.selectedPurchaseType == 'membership') {
        this.profileMap.get("PETOWNER_EMAIL_WEB").forEach(item => {
          if (item.type == "onMembershipPurchase") {
            email = item.status;
          }
        })
      }
      if (this.selectedPurchaseType == 'package') {
        this.profileMap.get("PETOWNER_EMAIL_WEB").forEach(item => {
          if (item.type == "onPackagePurchase") {
            email = item.status;
          }
        })
      }
      if (this.selectedPurchaseType == 'training') {
        this.profileMap.get("PETOWNER_EMAIL_WEB").forEach(item => {
          if (item.type == "onTrainingPurchase") {
            email = item.status;
          }
        })
      }

      if (email) {
        this.petOwnerMandatory['requireEmail'] = true;
      }
    }

    if(this.profileMap.has('PET_OWNER_MOBILENUMBER_WEB') && !this.userDetails.mobileNumber){
      let mobile = false;
      if (this.selectedPurchaseType == 'service') {
        this.profileMap.get("PET_OWNER_MOBILENUMBER_WEB").forEach(item => {
          if (item.type == "onCreateAppointment") {
            mobile = item.status;
          }
        })
      }
      if (this.selectedPurchaseType == 'membership') {
        this.profileMap.get("PET_OWNER_MOBILENUMBER_WEB").forEach(item => {
          if (item.type == "onMembershipPurchase") {
            mobile = item.status;
          }
        })
      }
      if (this.selectedPurchaseType == 'package') {
        this.profileMap.get("PET_OWNER_MOBILENUMBER_WEB").forEach(item => {
          if (item.type == "onPackagePurchase") {
            mobile = item.status;
          }
        })
      }
      if (this.selectedPurchaseType == 'training') {
        this.profileMap.get("PET_OWNER_MOBILENUMBER_WEB").forEach(item => {
          if (item.type == "onTrainingPurchase") {
            mobile = item.status;
          }
        })
      }

      if (mobile) {
        this.petOwnerMandatory['requireMobile'] = true;
      }
    }
  }

  hasNoEmergencyContact(obj) {
    return (
      (!obj.emergencyContantEmail || obj.emergencyContantEmail.trim() === "") &&
      (!obj.emergencyContantPerson || obj.emergencyContantPerson.trim() === "") &&
      (!obj.emergencyContantPhone || obj.emergencyContantPhone.trim() === "") &&
      (!obj.emergencyContantEmail1 || obj.emergencyContantEmail1.trim() === "") &&
      (!obj.emergencyContantPerson1 || obj.emergencyContantPerson1.trim() === "") &&
      (!obj.emergencyContantPhone1 || obj.emergencyContantPhone1.trim() === "") &&
      (!obj.emergencyContantEmail2 || obj.emergencyContantEmail2.trim() === "") &&
      (!obj.emergencyContantPerson2 || obj.emergencyContantPerson2.trim() === "") &&
      (!obj.emergencyContantPhone2 || obj.emergencyContantPhone2.trim() === "")
    );
  }

  hasAuthorizedPickup(obj) {
    return (
      (!obj.authorizedEmailToPickup || obj.authorizedEmailToPickup.trim() === "") &&
      (!obj.authorizedMobileNoToPickup || obj.authorizedMobileNoToPickup.trim() === "") &&
      (!obj.authorizedPersonToPickup || obj.authorizedPersonToPickup.trim() === "") &&
      (!obj.authorizedEmailToPickup1 || obj.authorizedEmailToPickup1.trim() === "") &&
      (!obj.authorizedMobileNoToPickup1 || obj.authorizedMobileNoToPickup1.trim() === "") &&
      (!obj.authorizedPersonToPickup1 || obj.authorizedPersonToPickup1.trim() === "") &&
      (!obj.authorizedEmailToPickup2 || obj.authorizedEmailToPickup2.trim() === "") &&
      (!obj.authorizedMobileNoToPickup2 || obj.authorizedMobileNoToPickup2.trim() === "") &&
      (!obj.authorizedPersonToPickup2 || obj.authorizedPersonToPickup2.trim() === "")
    );
  }

  allMandatoryFieldsAdded(){
    if (this.petOwnerMandatory.requireAuthorized) {
      if (this.petOwnerMandatory.authorizedPhone) {
        this.petOwnerMandatory.authorizedPhone = this.petOwnerMandatory.authorizedPhone.trim();
      }
      if (this.petOwnerMandatory.authorizedEmail) {
        this.petOwnerMandatory.authorizedEmail = this.petOwnerMandatory.authorizedEmail.trim();
      }
      if (
        !this.petOwnerMandatory.authorizedName || 
        this.petOwnerMandatory.authorizedName.trim() === '' || 
        (!this.petOwnerMandatory.authorizedEmail && 
        !this.petOwnerMandatory.authorizedPhone) || 
        (this.petOwnerMandatory.authorizedEmail && 
        !this.emailPattern.test(this.petOwnerMandatory.authorizedEmail)) || 
        (this.petOwnerMandatory.authorizedPhone && 
        this.petOwnerMandatory.authorizedPhone.length < 10)
      ) {
        return false;
      }
    }
    if (this.petOwnerMandatory.requireEmergency) {
      if (this.petOwnerMandatory.emergencyPhone) {
        this.petOwnerMandatory.emergencyPhone = this.petOwnerMandatory.emergencyPhone.trim();
      }
      if (this.petOwnerMandatory.emergencyEmail) {
        this.petOwnerMandatory.emergencyEmail = this.petOwnerMandatory.emergencyEmail.trim();
      }
      if (
        !this.petOwnerMandatory.emergencyName || 
        this.petOwnerMandatory.emergencyName.trim() === '' || 
        (!this.petOwnerMandatory.emergencyEmail && 
        !this.petOwnerMandatory.emergencyPhone) || 
        (this.petOwnerMandatory.emergencyEmail && 
        !this.emailPattern.test(this.petOwnerMandatory.emergencyEmail)) || 
        (this.petOwnerMandatory.emergencyPhone && 
        this.petOwnerMandatory.emergencyPhone.length < 10)
      ) {
        return false;
      }
    }
    if(this.petOwnerMandatory.requireEmail){
      if(!this.petOwnerMandatory.email || this.petOwnerMandatory.email.trim() == '' || !this.emailPattern.test(this.petOwnerMandatory.email)){
        return false;
      }
    }
    if(this.petOwnerMandatory.requireMobile){
      if(!this.petOwnerMandatory.phoneNumber || this.petOwnerMandatory.phoneNumber.trim() == '' || this.petOwnerMandatory.phoneNumber.length < 10){
        return false;
      }
    }
    if(!this.addressSaved && !this.validateUserAddress('save')){
       return false;
    }
    return true;
  }

  updatePetOwnerDetails(){
    if (!this.addressSaved) {
      this.validateUserAddress('save');
    }

    if(this.petOwnerMandatory && (this.petOwnerMandatory.requireMobile || this.petOwnerMandatory.email)){
        if(this.petOwnerMandatory.requireMobile){
          this.userDetails.mobileNumber = this.petOwnerMandatory.phoneNumber;
        }
        if(this.petOwnerMandatory.requireEmail){
          this.userDetails.email = this.petOwnerMandatory.email;
        }

        this.userDetails.tenantKey = this.appService.tenantKey;

        this.appService.updateUserDetail(this.userDetails).subscribe(
          (res:any) =>{
          })
    }

    if (this.petOwnerMandatory && (this.petOwnerMandatory.requireAuthorized || this.petOwnerMandatory.requireEmergency)) {
      var userPreference = this.userDetails.userPreference || {};
      delete userPreference.id;
      delete userPreference.createdOn;
      delete userPreference.responseCode
      delete userPreference.shouldDisplay
      if (this.petOwnerMandatory.requireAuthorized) {
        userPreference.authorizedEmailToPickup = this.petOwnerMandatory.authorizedEmail;
        userPreference.authorizedMobileNoToPickup = this.petOwnerMandatory.authorizedPhone;
        userPreference.authorizedPersonToPickup = this.petOwnerMandatory.authorizedName;
      }
      if (this.petOwnerMandatory.requireEmergency) {
        userPreference.emergencyContantEmail = this.petOwnerMandatory.emergencyEmail;
        userPreference.emergencyContantPerson = this.petOwnerMandatory.emergencyName;
        userPreference.emergencyContantPhone = this.petOwnerMandatory.emergencyPhone;
      }

      userPreference.pushNotification = false;
      userPreference.sms = false;
      userPreference.email = false;
      let locationKeyKey = this.storageService.getItem('locationKey');
      userPreference.preferredLocation = {
        locationKey: locationKeyKey.includes('"') ? JSON.parse(locationKeyKey) : locationKeyKey
      }
      this.appService.updateUserPreference(this.userDetails.userKey, userPreference).subscribe(
        (res: any) => {
        })
    }
  }

  getTrainingSessionDescription(session:any, training:any, type:string){
    var description = '';
    if(session.description && session.description != ''){
      description = session.description;
    }
    if(session.duration && session.duration != ''){
      let hours = Math.floor(session.duration / 60);
      let minutes = session.duration % 60;
      description += '\n' + 'Duration : ' + (hours > 0 ? hours + ' hours' : '') + (minutes > 0 ? ' ' + minutes + ' minutes' : '');
    }
    if(training.trainingType != 'PRIVATE' && training.enrollmentType == 'FIXED_CLASS_SCHEDULE'){
      if(session.classes && session.classes.length > 0){
        session.classes.forEach((cls:any) => {
          description += '\n' + cls.name + ' - ' + this.getDateAndTime(cls.appointmentDate, 'dateTime');
        });
      }
    }
    else if(training.trainingType != 'PRIVATE' && training.enrollmentType != 'FIXED_CLASS_SCHEDULE'){
      if(session.groupedClasses && session.groupedClasses.length > 0){
        session.groupedClasses.forEach((cls:any) => {
          description += '\n' + cls.name;
        });
      }
    }
  
    if(description != ''){
      if(type == 'bool'){
        return true;
      } else {
        this.toolTipText = description;
      }
    } else {
      if(type == 'bool'){
        return false;
      } else {
        return '';
      }
    }
  }

  showImages(service:any){
    if(!service.document || !service.document.id){
      return;
    }
    if(this.getAttachmentInProcess){
      return;
    }
    this.getAttachmentInProcess = true;
    // close the dialog if already open
    const dialogRef = this.dialog.getDialogById('images-video-component');
    if(dialogRef){
      dialogRef.close();
    }
    this.appService.getAttachments(service.document.id).subscribe(
      (res:any) =>{
        this.getAttachmentInProcess = false;
        if(res.data && res.data.attachments && res.data.attachments.length > 0){
          this.dialog.open(ImagesAndVideosComponent, {
            data: {images: res.data, title: service.name},
            width: '650px',
            height: '650px',
            disableClose: true,
            panelClass: 'images-video-component' ,
          });
        }
      },
      (err:any) =>{
        this.getAttachmentInProcess = false;
        console.log("err",err)
      }
    )
  }

  showPageContentLoader(): void {
    this.isPageLoader = true;
    const pageSidebar = this.el.nativeElement.querySelector('#page-sidebar');
    const pageContentLoader = this.el.nativeElement.querySelector('.page-content-loader');
    if (pageSidebar && pageContentLoader) {
      const marginLeft = `${pageSidebar.offsetWidth}px`;
      this.renderer.setStyle(pageContentLoader, 'margin-left', marginLeft);
    }
  }

  hidePageContentLoader(): void {
    this.isPageLoader = false;
  }

  openBreedSelector() {
    const dialogRef = this.matDialog.open(BreedSelectorDialogComponent, {
      width: '400px',
      data: { breeds: this.petBreeds }
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result)
      }
    });
  }
}

@Component({
  selector: 'alert-dialog',
  templateUrl: 'alert.component.html',
})
export class AlertComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) { }
}
